// LESSON 2 - Medical Emergencies Questions

// Topics:
//   1. Introduction and prevention (Part 1)
//   1. Introduction and prevention (Part 2)
//   1. Introduction and prevention (Part 3)
//   1. Introduction and prevention (Part 4)
//   1. Introduction and prevention (Part 4-2)
//   1. Introduction and prevention (Part 3-2)
//   2. Vital Signs revised
//   3. Legal considerations revised
//   2-3. Medical Emergencies
// 
// TOTAL: 871 questions
// ID Range: 70001 - 70832

export const questions = {
  "1. Introduction and prevention (Part 1)": [
    {
      id: 70001,
      question: "What is a medical emergency in the context of dental practice?",
      options: [
        "A minor discomfort that can be managed with over-the-counter medication",
        "An injury or illness that poses an immediate threat to a person's health or life requiring help from a doctor or hospital",
        "Any situation where a patient requests pain medication",
        "A scheduled consultation with a physician about dental treatment"
      ],
      correctAnswer: 1
    },
    {
      id: 70002,
      question: "Which of the following is NOT a preventive measure to minimize life-threatening incidents?",
      options: [
        "Comprehensive health history and risk assessment",
        "Vital signs monitoring including BP, pulse, and respiration",
        "Scheduling longer appointments to complete all procedures at once",
        "Anxiety recognition and management using nitrous oxide"
      ],
      correctAnswer: 2
    },
    {
      id: 70003,
      question: "Which factor contributes to increased medical emergencies in dental practice?",
      options: [
        "Decreased use of dental medications",
        "Shorter appointment times",
        "Increased number of older clients and prevalence of chronic disease",
        "Reduced life expectancy in the population"
      ],
      correctAnswer: 2
    },
    {
      id: 70004,
      question: "What is the leading cause of death in persons over the age of 65?",
      options: [
        "Respiratory disease",
        "Diabetes complications",
        "Cancer",
        "Cardiovascular disease"
      ],
      correctAnswer: 3
    },
    {
      id: 70005,
      question: "Which medication is commonly used as a local anesthetic in dental treatments?",
      options: [
        "Amoxicillin",
        "Lidocaine",
        "Chlorohexidine",
        "Ibuprofen"
      ],
      correctAnswer: 1
    },
    {
      id: 70006,
      question: "What type of medication is nitrous oxide classified as in dental practice?",
      options: [
        "Antibiotic",
        "Analgesic",
        "Sedative",
        "Local anesthetic"
      ],
      correctAnswer: 2
    },
    {
      id: 70007,
      question: "Which medical advancement has allowed people to live longer after cardiac events?",
      options: [
        "Improved dental hygiene protocols",
        "Coronary bypass operations",
        "Enhanced orthodontic techniques",
        "Better oral cancer screenings"
      ],
      correctAnswer: 1
    },
    {
      id: 70008,
      question: "For a diabetic patient, what blood glucose level requires medical clearance before dental treatment?",
      options: [
        "5.0 mmol/L",
        "7.5 mmol/L",
        "Less than 3.9 mmol/L or greater than 11.1 mmol/L",
        "6.0 mmol/L"
      ],
      correctAnswer: 2
    },
    {
      id: 70009,
      question: "What should be available on hand for a diabetic patient experiencing hypoglycemia?",
      options: [
        "Sugar-free beverages only",
        "Insulin injection",
        "Orange juice or sugar cubes",
        "Blood pressure medication"
      ],
      correctAnswer: 2
    },
    {
      id: 70010,
      question: "Should you give sugary foods or drinks to a patient experiencing hyperglycemia?",
      options: [
        "Yes, to stabilize their condition",
        "No, as this will worsen the hyperglycemia",
        "Only if they request it",
        "Yes, but in small amounts"
      ],
      correctAnswer: 1
    },
    {
      id: 70011,
      question: "Which drug interaction is particularly dangerous when combined with alcohol in dental practice?",
      options: [
        "Fluoride treatments",
        "Chlorohexidine rinse",
        "Local anesthetic and barbiturates",
        "Topical numbing gel"
      ],
      correctAnswer: 2
    },
    {
      id: 70012,
      question: "What medication should NOT be given to asthma patients due to increased hypersensitivity risk?",
      options: [
        "Albuterol",
        "Oxygen",
        "Aspirin",
        "Epinephrine"
      ],
      correctAnswer: 2
    },
    {
      id: 70013,
      question: "What does the term \"tachypnea\" refer to?",
      options: [
        "Slow respiratory rate",
        "Irregular heartbeat",
        "Increased respiratory rate",
        "Decreased heart rate"
      ],
      correctAnswer: 2
    },
    {
      id: 70014,
      question: "Which classification system is used to estimate medical risk for patients receiving anesthesia?",
      options: [
        "WHO Risk Assessment",
        "ASA Physical Status Classification System",
        "Dental Emergency Protocol System",
        "Medical Risk Evaluation Scale"
      ],
      correctAnswer: 1
    },
    {
      id: 70015,
      question: "What does ABC stand for in medical emergency management?",
      options: [
        "Assess, Breathe, Circulate",
        "Alert, Blood pressure, Cardiopulmonary",
        "Airway, Breathing, Circulation",
        "Ambulance, Basic care, CPR"
      ],
      correctAnswer: 2
    },
    {
      id: 70016,
      question: "What is syncope?",
      options: [
        "An allergic reaction to anesthesia",
        "Sudden, transient loss of consciousness due to inadequate blood flow to the brain",
        "A chronic respiratory condition",
        "Elevated blood pressure during dental procedures"
      ],
      correctAnswer: 1
    },
    {
      id: 70017,
      question: "What is the appropriate patient position for treating syncope?",
      options: [
        "Seated upright",
        "Supine position with legs slightly elevated",
        "Left lateral position",
        "Standing position"
      ],
      correctAnswer: 1
    },
    {
      id: 70018,
      question: "What is orthostatic hypotension?",
      options: [
        "High blood pressure when standing",
        "Sudden drop in systolic BP from change of body position",
        "Elevated heart rate during exercise",
        "Low blood pressure during sleep"
      ],
      correctAnswer: 1
    },
    {
      id: 70019,
      question: "How should you prevent orthostatic hypotension when dismissing a dental patient?",
      options: [
        "Have them stand up quickly and walk immediately",
        "Keep them in supine position for 30 minutes",
        "Slowly raise the chair and have the client sit for a couple of minutes",
        "Administer oxygen before they stand"
      ],
      correctAnswer: 2
    },
    {
      id: 70020,
      question: "What is the recommended position for an asthmatic patient during an attack?",
      options: [
        "Supine with legs elevated",
        "Left lateral position",
        "Sitting position",
        "Trendelenburg position"
      ],
      correctAnswer: 2
    },
    {
      id: 70021,
      question: "Which medication is used as a bronchodilator for asthma attacks?",
      options: [
        "Nitroglycerin",
        "Epinephrine",
        "Benadryl",
        "Albuterol (Salbutamol)"
      ],
      correctAnswer: 3
    },
    {
      id: 70022,
      question: "Should oxygen be administered during a hyperventilation episode?",
      options: [
        "Yes, at maximum flow rate",
        "No, oxygen should not be administered",
        "Only if the patient requests it",
        "Yes, but only with a nebulizer"
      ],
      correctAnswer: 1
    },
    {
      id: 70023,
      question: "How should a hyperventilating patient manage their breathing?",
      options: [
        "Take rapid, shallow breaths",
        "Hold their breath for as long as possible",
        "Cup their hands over mouth and nose and breathe slowly",
        "Breathe through a straw"
      ],
      correctAnswer: 2
    },
    {
      id: 70024,
      question: "What is angina pectoris?",
      options: [
        "Permanent heart damage",
        "Temporary lack of oxygenated blood supply to the myocardium",
        "Lung infection",
        "Stroke affecting speech"
      ],
      correctAnswer: 1
    },
    {
      id: 70025,
      question: "How many doses of nitroglycerin can be administered within 15 minutes for angina?",
      options: [
        "Up to 5 doses",
        "No limit",
        "Do not exceed 3 doses",
        "Only 1 dose"
      ],
      correctAnswer: 2
    },
    {
      id: 70026,
      question: "What is the appropriate position for a patient experiencing difficulty breathing during cardiac distress?",
      options: [
        "Supine position",
        "Upright or sitting position",
        "Prone position",
        "Trendelenburg position"
      ],
      correctAnswer: 1
    },
    {
      id: 70027,
      question: "What is a transient ischemic attack (TIA)?",
      options: [
        "Permanent brain damage",
        "Heart attack",
        "Ministroke with temporary symptoms",
        "Respiratory failure"
      ],
      correctAnswer: 2
    },
    {
      id: 70028,
      question: "Which emergency drug is used for anaphylactic shock?",
      options: [
        "Albuterol",
        "Nitroglycerin",
        "Diazepam",
        "Epinephrine"
      ],
      correctAnswer: 3
    },
    {
      id: 70029,
      question: "What is the brand name for diazepam?",
      options: [
        "Benadryl",
        "Valium",
        "Ativan",
        "Xanax"
      ],
      correctAnswer: 1
    },
    {
      id: 70030,
      question: "Which drug family does diazepam belong to?",
      options: [
        "Opioids",
        "Beta-blockers",
        "Benzodiazepines",
        "Antihistamines"
      ],
      correctAnswer: 2
    },
    {
      id: 70031,
      question: "What medication is used for mild to moderate allergic reactions?",
      options: [
        "Epinephrine",
        "Albuterol",
        "Nitroglycerin",
        "Benadryl"
      ],
      correctAnswer: 3
    },
    {
      id: 70032,
      question: "What should be used for syncope management?",
      options: [
        "Nitroglycerin spray",
        "Insulin injection",
        "Ammonia inhalant",
        "Albuterol inhaler"
      ],
      correctAnswer: 2
    },
    {
      id: 70033,
      question: "Which condition is treated with oral carbohydrates or glucose?",
      options: [
        "Hyperventilation",
        "Hypoglycemia",
        "Angina",
        "Asthma"
      ],
      correctAnswer: 1
    },
    {
      id: 70034,
      question: "What is the most common medical emergency in dental practice?",
      options: [
        "Cardiac arrest",
        "Seizures",
        "Syncope",
        "Anaphylaxis"
      ],
      correctAnswer: 2
    },
    {
      id: 70035,
      question: "What does ASA I classification indicate?",
      options: [
        "Patient with severe systemic disease",
        "Normal, healthy client free of systemic disease",
        "Patient requiring hospital treatment only",
        "Moribund patient not expected to survive"
      ],
      correctAnswer: 1
    },
    {
      id: 70036,
      question: "What does ASA II classification indicate?",
      options: [
        "Patient requires emergency surgery",
        "Client with mild systemic disease or extreme dental anxiety",
        "Normal healthy patient with no modifications needed",
        "Patient with incapacitating disease"
      ],
      correctAnswer: 1
    },
    {
      id: 70037,
      question: "What does a \"yellow light\" in ASA classification mean?",
      options: [
        "No treatment should be provided",
        "Treatment can proceed with no modifications",
        "Treatment permitted with consideration for modifications",
        "Emergency treatment only"
      ],
      correctAnswer: 2
    },
    {
      id: 70038,
      question: "What does ASA IV classification indicate?",
      options: [
        "Normal healthy patient",
        "Patient with mild disease",
        "Patient with moderate disease",
        "Patient with incapacitating systemic disease that is a constant threat to life"
      ],
      correctAnswer: 3
    },
    {
      id: 70039,
      question: "What type of dental treatment is appropriate for ASA IV patients?",
      options: [
        "All elective procedures",
        "Non-invasive treatment including analgesics and antibiotics",
        "Routine cleanings and restorations",
        "Cosmetic procedures only"
      ],
      correctAnswer: 1
    },
    {
      id: 70040,
      question: "Where should emergency dental care for ASA IV patients be performed if immediate treatment is needed?",
      options: [
        "Regular dental office with oxygen available",
        "Hospital setting",
        "Mobile dental clinic",
        "Patient's home"
      ],
      correctAnswer: 1
    },
    {
      id: 70041,
      question: "Which vital sign should be monitored for diabetic patients before dental treatment?",
      options: [
        "Temperature only",
        "Blood sugar levels",
        "Reflexes",
        "Pupil dilation"
      ],
      correctAnswer: 1
    },
    {
      id: 70042,
      question: "What causes hyperglycemia in diabetic patients?",
      options: [
        "Too much insulin",
        "Excessive exercise",
        "Insulin deficiency or resistance",
        "Skipping meals"
      ],
      correctAnswer: 2
    },
    {
      id: 70043,
      question: "What causes hypoglycemia in diabetic patients?",
      options: [
        "Insulin deficiency",
        "Too much insulin, missed meals, or exercise",
        "Eating too much sugar",
        "Lack of physical activity"
      ],
      correctAnswer: 1
    },
    {
      id: 70044,
      question: "How is hypoglycemia treated in a dental emergency?",
      options: [
        "Insulin injection",
        "Glucose administration and monitoring levels",
        "Diuretic medication",
        "Epinephrine injection"
      ],
      correctAnswer: 1
    },
    {
      id: 70045,
      question: "Which factor does NOT contribute to longer appointment times increasing emergency risk?",
      options: [
        "More stress for the client",
        "Advanced dental procedures like implants",
        "Complex treatments like root canals",
        "Improved patient comfort measures"
      ],
      correctAnswer: 3
    },
    {
      id: 70046,
      question: "What should dental professionals record for diabetic patients according to CDHO?",
      options: [
        "Only their blood sugar level at arrival",
        "Summary of medical history, medications, physician advice, decisions made, and procedures used",
        "Just their hemoglobin A1C result",
        "Only adverse reactions to treatment"
      ],
      correctAnswer: 1
    },
    {
      id: 70047,
      question: "What is the first step in managing a medical emergency?",
      options: [
        "Administer medication immediately",
        "Call 911 first",
        "Recognize problem and activate emergency medical system",
        "Start CPR"
      ],
      correctAnswer: 2
    },
    {
      id: 70048,
      question: "What does the P in the emergency management protocol stand for?",
      options: [
        "Prescribe medication",
        "Position patient appropriately",
        "Provide oxygen",
        "Prevent further injury"
      ],
      correctAnswer: 1
    },
    {
      id: 70049,
      question: "What does the A in PAD management stand for?",
      options: [
        "Activate EMS",
        "Administer appropriate drugs",
        "Assess vital signs",
        "Apply bandages"
      ],
      correctAnswer: 1
    },
    {
      id: 70050,
      question: "What does the D in PAD management stand for?",
      options: [
        "Document event",
        "Definitive management",
        "Discharge patient",
        "Determine cause"
      ],
      correctAnswer: 1
    },
    {
      id: 70051,
      question: "What is the first step in the Basic Life Support (BLS) algorithm?",
      options: [
        "Start chest compressions",
        "Give rescue breaths",
        "Check for responsiveness and breathing",
        "Call for help"
      ],
      correctAnswer: 2
    },
    {
      id: 70052,
      question: "What equipment should be immediately available in a dental emergency?",
      options: [
        "Only an oxygen tank",
        "Emergency drug kit and oxygen delivery system",
        "Just a phone to call 911",
        "Only basic first aid supplies"
      ],
      correctAnswer: 1
    },
    {
      id: 70053,
      question: "What is the appropriate oxygen flow rate for most dental emergencies?",
      options: [
        "1-2 liters per minute",
        "3-4 liters per minute",
        "4-6 liters per minute or higher",
        "Oxygen should not be used"
      ],
      correctAnswer: 2
    },
    {
      id: 70054,
      question: "When should a pulse oximeter be used?",
      options: [
        "Only during surgical procedures",
        "When oxygen is being administered to a client",
        "Only for pediatric patients",
        "Never necessary in dental practice"
      ],
      correctAnswer: 1
    },
    {
      id: 70055,
      question: "What does a myocardial infarction represent?",
      options: [
        "Temporary chest pain",
        "Heart receiving adequate blood supply",
        "Death of heart muscle tissue due to lack of blood supply",
        "Normal heart function"
      ],
      correctAnswer: 2
    },
    {
      id: 70056,
      question: "What is another name for a cerebrovascular accident?",
      options: [
        "Heart attack",
        "Seizure",
        "Stroke",
        "Syncope"
      ],
      correctAnswer: 2
    },
    {
      id: 70057,
      question: "What causes a cerebrovascular accident?",
      options: [
        "Excess oxygen to the brain",
        "Interruption of oxygen to the brain",
        "Low blood sugar",
        "High blood pressure only"
      ],
      correctAnswer: 1
    },
    {
      id: 70058,
      question: "What is an aneurysm?",
      options: [
        "Normal blood vessel structure",
        "Ballooning out of a weakened arterial wall",
        "Complete blockage of an artery",
        "Inflammation of a vein"
      ],
      correctAnswer: 1
    },
    {
      id: 70059,
      question: "What should be done if syncope persists for 15-20 minutes?",
      options: [
        "Continue monitoring only",
        "Give patient water",
        "Activate EMS/call 911",
        "Let patient rest longer"
      ],
      correctAnswer: 2
    },
    {
      id: 70060,
      question: "What is systolic pressure?",
      options: [
        "Pressure during heart relaxation",
        "Pressure in arteries during ventricular contraction",
        "Average pressure throughout the day",
        "Pressure only in veins"
      ],
      correctAnswer: 1
    },
    {
      id: 70061,
      question: "What is diastolic pressure?",
      options: [
        "Maximum pressure in arteries",
        "Pressure during heart contraction",
        "Pressure in arteries during ventricular relaxation",
        "Pressure in capillaries only"
      ],
      correctAnswer: 2
    },
    {
      id: 70062,
      question: "What is Addison's disease?",
      options: [
        "Overproduction of hormones",
        "Inability to produce glucocorticoids and/or mineralocorticoids",
        "Thyroid disorder",
        "Liver disease"
      ],
      correctAnswer: 1
    },
    {
      id: 70063,
      question: "What are barbiturates used for in medicine?",
      options: [
        "Only as painkillers",
        "Treating infections",
        "Anxiety, insomnia, and seizure control",
        "Blood pressure control"
      ],
      correctAnswer: 2
    },
    {
      id: 70064,
      question: "What type of medications are ibuprofen and acetaminophen?",
      options: [
        "Antibiotics",
        "Analgesics (pain relievers)",
        "Sedatives",
        "Antihistamines"
      ],
      correctAnswer: 1
    },
    {
      id: 70065,
      question: "What should be part of the pre-treatment evaluation to minimize emergencies?",
      options: [
        "Only asking about allergies",
        "Medical history questionnaires and dialogue histories",
        "Just checking blood pressure",
        "No evaluation necessary"
      ],
      correctAnswer: 1
    },
    {
      id: 70066,
      question: "When should stress reduction techniques be used?",
      options: [
        "Only after an emergency occurs",
        "Only for anxious patients",
        "During treatment as a preventive measure",
        "Never necessary"
      ],
      correctAnswer: 2
    },
    {
      id: 70067,
      question: "What is included in a Basic Life Support (BLS) kit?",
      options: [
        "Only bandages",
        "AED, oxygen, and emergency medications",
        "Just a phone",
        "Only surgical instruments"
      ],
      correctAnswer: 1
    },
    {
      id: 70068,
      question: "What must be assessed before dismissing a patient?",
      options: [
        "Only their payment status",
        "Stable conditions and ability to safely leave",
        "Only their next appointment time",
        "Nothing needs assessment"
      ],
      correctAnswer: 1
    },
    {
      id: 70069,
      question: "What type of therapy allows cancer patients to live longer?",
      options: [
        "Only surgery",
        "Only diet changes",
        "Radiation therapy",
        "Physical therapy only"
      ],
      correctAnswer: 2
    },
    {
      id: 70070,
      question: "What does chemotherapy do?",
      options: [
        "Only treats infections",
        "Stops cell division and is absorbed systemically",
        "Only reduces pain",
        "Has no systemic effects"
      ],
      correctAnswer: 1
    },
    {
      id: 70071,
      question: "What does ASA III classification indicate?",
      options: [
        "Normal healthy patient",
        "Patient with severe incapacitating disease",
        "Client with severe systemic disease that limits activity but is not incapacitating",
        "Moribund patient"
      ],
      correctAnswer: 2
    },
    {
      id: 70072,
      question: "What is an ASA V patient?",
      options: [
        "Normal healthy patient",
        "Patient with mild disease",
        "Moribund patient not expected to survive 24 hours with or without treatment",
        "Patient ready for discharge"
      ],
      correctAnswer: 2
    },
    {
      id: 70073,
      question: "When is ASA E designation added?",
      options: [
        "For routine procedures",
        "For elective surgery",
        "For emergency operations",
        "Never used in dentistry"
      ],
      correctAnswer: 2
    },
    {
      id: 70074,
      question: "What is an example of an ASA V condition?",
      options: [
        "Mild hypertension",
        "Controlled diabetes",
        "Ruptured abdominal aneurysm",
        "Common cold"
      ],
      correctAnswer: 2
    },
    {
      id: 70075,
      question: "What does ASA VI classification indicate?",
      options: [
        "Highest risk patient alive",
        "Patient with mild disease",
        "Declared brain-dead whose organs are being removed for donation",
        "Patient refusing treatment"
      ],
      correctAnswer: 2
    },
    {
      id: 70076,
      question: "When do ASA III patients typically exhibit symptoms?",
      options: [
        "At all times",
        "Only during sleep",
        "During physiological or psychological stress",
        "Never"
      ],
      correctAnswer: 2
    },
    {
      id: 70077,
      question: "What treatment approach is appropriate for ASA I patients?",
      options: [
        "Hospital-only treatment",
        "Treatment modification always required",
        "Routine dental care without modification",
        "Non-invasive treatment only"
      ],
      correctAnswer: 2
    },
    {
      id: 70078,
      question: "Medical emergencies in dental practice require help from a doctor or hospital.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70079,
      question: "Comprehensive health history and vital signs monitoring can help minimize life-threatening incidents.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70080,
      question: "Life-threatening emergencies in dental practice only occur to elderly patients.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70081,
      question: "Cardiovascular disease is the leading cause of death in persons over 65.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70082,
      question: "Lidocaine is commonly used as a local anesthetic in dental treatments.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70083,
      question: "Nitrous oxide is classified as an antibiotic in dental practice.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70084,
      question: "Coronary bypass operations have allowed people to pursue active lives after surgery.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70085,
      question: "Diabetic patients with blood glucose less than 3.9 mmol/L require medical clearance before treatment.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70086,
      question: "You should give sugary foods to a patient experiencing hyperglycemia.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70087,
      question: "Orange juice can help raise blood sugar levels quickly during hypoglycemia.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70088,
      question: "All drugs are risk-free when used properly in dental practice.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70089,
      question: "Aspirin should be avoided in asthmatic patients due to increased hypersensitivity risk.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70090,
      question: "Syncope is defined as sudden, transient loss of consciousness.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70091,
      question: "The supine position with legs elevated is appropriate for treating syncope.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70092,
      question: "Orthostatic hypotension involves a sudden increase in blood pressure.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70093,
      question: "Patients should slowly rise from the dental chair to prevent orthostatic hypotension.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70094,
      question: "An asthmatic patient should be positioned sitting upright during an attack.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70095,
      question: "Albuterol is a bronchodilator used for asthma attacks.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70096,
      question: "Oxygen should be administered during hyperventilation episodes.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70097,
      question: "Angina pectoris involves temporary lack of oxygenated blood to the heart muscle.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70098,
      question: "You can administer unlimited doses of nitroglycerin for angina.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70099,
      question: "A transient ischemic attack is also known as a ministroke.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70100,
      question: "Epinephrine is used to treat anaphylactic shock.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70101,
      question: "Valium is the brand name for diazepam.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70102,
      question: "Diazepam belongs to the opioid drug family.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70103,
      question: "Benadryl is used for mild to moderate allergic reactions.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70104,
      question: "Syncope is the most common medical emergency in dental practice.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70105,
      question: "ASA I classification indicates a normal, healthy patient free of systemic disease.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70106,
      question: "ASA IV patients can receive all elective dental procedures in a regular office.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70107,
      question: "Blood sugar levels should be monitored for diabetic patients before dental treatment.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70108,
      question: "Hyperglycemia is caused by insulin deficiency or resistance.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70109,
      question: "Hypoglycemia can be caused by too much insulin or missed meals.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70110,
      question: "A pulse oximeter should be used when oxygen is administered to a client.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70111,
      question: "Myocardial infarction means the heart is receiving adequate blood supply.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70112,
      question: "A cerebrovascular accident involves interruption of oxygen to the brain.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70113,
      question: "An aneurysm is a ballooning out of a weakened arterial wall.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70114,
      question: "Metronidazole can be safely mixed with alcohol without side effects.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70115,
      question: "Barbiturates are used for anxiety, insomnia, and seizure control.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70116,
      question: "Standard opioids increase CNS depressant effects when mixed with alcohol.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70117,
      question: "Ibuprofen and acetaminophen are examples of analgesics used in dentistry.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70118,
      question: "Tachypnea means a slow respiratory rate.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70119,
      question: "ABC stands for Airway, Breathing, and Circulation in emergency management.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70120,
      question: "Delayed recovery from syncope after 15-20 minutes should prompt a call to EMS.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70121,
      question: "Systolic pressure measures the pressure in arteries during heart contraction.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70122,
      question: "Addison's disease involves inability to produce certain hormones.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70123,
      question: "Medical history questionnaires are part of pre-treatment evaluation to minimize emergencies.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70124,
      question: "Patients should always be assessed for stable conditions before dismissal.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70125,
      question: "Life-threatening emergencies in dental offices occur only during surgical procedures.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70126,
      question: "Radiation therapy allows cancer patients to live longer.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70127,
      question: "Longer dental appointments decrease stress for patients.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70128,
      question: "Chemotherapy medication stops cell division and is absorbed through the entire system.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70129,
      question: "ASA III patients exhibit symptoms even at rest.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70130,
      question: "ASA II patients may have extreme dental anxiety even without systemic disease.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70131,
      question: "Yellow light in ASA classification means no treatment should be provided.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70132,
      question: "ASA VI classification refers to brain-dead patients whose organs are being donated.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70133,
      question: "Nitroglycerin can be administered 1-2 sprays every 5 minutes for angina.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70134,
      question: "Medical consultation before treatment helps assess risk and determine modifications.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70135,
      question: "Stress reduction techniques should only be used after an emergency occurs.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70136,
      question: "An AED is part of the basic life support kit in dental offices.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "1. Introduction and prevention (Part 2)": [
    {
      id: 70137,
      question: "What is the definition of a medical emergency in dental practice?",
      options: [
        "Any patient complaint during treatment",
        "A minor injury that requires first aid",
        "An injury or illness that poses an immediate threat to a person's health or life requiring help from a doctor or hospital",
        "A situation requiring appointment rescheduling"
      ],
      correctAnswer: 2
    },
    {
      id: 70138,
      question: "Who can experience life-threatening emergencies in a dental office?",
      options: [
        "Only elderly patients over 70",
        "The client, dentist, staff member, or someone accompanying the client",
        "Only patients with known medical conditions",
        "Only the dentist performing procedures"
      ],
      correctAnswer: 1
    },
    {
      id: 70139,
      question: "How frequently do life-threatening emergencies occur in dental offices?",
      options: [
        "Multiple times daily in every practice",
        "Never in modern dental practices",
        "They occur infrequently but can happen",
        "Only during surgical extractions"
      ],
      correctAnswer: 2
    },
    {
      id: 70140,
      question: "Which factor does NOT contribute to medical emergencies in dental practice?",
      options: [
        "Increased number of older clients",
        "Longer appointment times",
        "Shorter working hours for staff",
        "Increased drug use"
      ],
      correctAnswer: 2
    },
    {
      id: 70141,
      question: "What happens as life expectancy increases in relation to dental care?",
      options: [
        "Fewer people seek dental treatment",
        "The number of older clients seeking dental care increases",
        "Medical emergencies decrease significantly",
        "Dental procedures become unnecessary"
      ],
      correctAnswer: 1
    },
    {
      id: 70142,
      question: "Why are older clients at greater risk for emergency situations?",
      options: [
        "They have better immune systems",
        "They tolerate stress better than younger patients",
        "They may be less likely to tolerate the stress of dental procedures",
        "They require shorter appointments"
      ],
      correctAnswer: 2
    },
    {
      id: 70143,
      question: "What is the leading cause of death in persons over age 65?",
      options: [
        "Respiratory disease",
        "Diabetes complications",
        "Cancer",
        "Cardiovascular disease"
      ],
      correctAnswer: 3
    },
    {
      id: 70144,
      question: "How have therapeutic advances affected patient longevity?",
      options: [
        "They have decreased life expectancy",
        "They have had no effect on lifespan",
        "People with chronic conditions are living longer",
        "Only cancer patients benefit"
      ],
      correctAnswer: 2
    },
    {
      id: 70145,
      question: "How long ago would clients with diabetes and cardiovascular disease have lived significantly shorter lives?",
      options: [
        "5-10 years ago",
        "10-15 years ago",
        "25-35 years ago",
        "50-60 years ago"
      ],
      correctAnswer: 2
    },
    {
      id: 70146,
      question: "What surgical procedure is mentioned as commonly allowing people to pursue active lives?",
      options: [
        "Hip replacement surgery",
        "Cataract surgery",
        "Coronary bypass operations",
        "Appendectomy"
      ],
      correctAnswer: 2
    },
    {
      id: 70147,
      question: "What cancer treatments allow clients to live longer?",
      options: [
        "Only surgical removal",
        "Radiation and chemotherapy",
        "Homeopathic remedies only",
        "Dietary changes alone"
      ],
      correctAnswer: 1
    },
    {
      id: 70148,
      question: "What has happened with organ transplant procedures?",
      options: [
        "They are no longer performed",
        "Success rates have decreased",
        "They have higher success rates and are performed more frequently",
        "They are only experimental"
      ],
      correctAnswer: 2
    },
    {
      id: 70149,
      question: "Which chronic disorders are mentioned as having more effective drug therapies?",
      options: [
        "Only mental health conditions",
        "High blood pressure, diabetes, and HIV",
        "Only infectious diseases",
        "Only autoimmune disorders"
      ],
      correctAnswer: 1
    },
    {
      id: 70150,
      question: "Which clients are more susceptible to medical emergencies?",
      options: [
        "Young healthy adults only",
        "Clients with chronic disorders that are managed or controlled",
        "Only undiagnosed patients",
        "Athletes in peak condition"
      ],
      correctAnswer: 1
    },
    {
      id: 70151,
      question: "Why do advanced dental procedures contribute to emergency risk?",
      options: [
        "They use outdated equipment",
        "They require less skill",
        "They generally require longer appointments increasing stress",
        "They are performed without anesthesia"
      ],
      correctAnswer: 2
    },
    {
      id: 70152,
      question: "Which procedures are becoming more common and take longer appointments?",
      options: [
        "Simple cleanings and fluoride treatments",
        "Crowns, bridges, periodontics, endodontics, and implants",
        "Only routine examinations",
        "Teeth whitening procedures"
      ],
      correctAnswer: 1
    },
    {
      id: 70153,
      question: "How does appointment length affect emergency risk?",
      options: [
        "Shorter appointments increase risk",
        "Appointment length has no effect",
        "Longer appointment time means more stress for clients",
        "Only affects dentist fatigue"
      ],
      correctAnswer: 2
    },
    {
      id: 70154,
      question: "Is the increased stress from longer appointments only a concern for compromised clients?",
      options: [
        "Yes, only compromised clients are affected",
        "No, both healthy and compromised clients experience more stress",
        "Only anxious patients are affected",
        "Only pediatric patients are affected"
      ],
      correctAnswer: 1
    },
    {
      id: 70155,
      question: "What is the first main reason drugs are used in dental practice?",
      options: [
        "Cosmetic enhancement",
        "Insurance requirements",
        "Pain prevention",
        "Sterilization purposes"
      ],
      correctAnswer: 2
    },
    {
      id: 70156,
      question: "What is included in the main reasons for drug use in dentistry?",
      options: [
        "Only pain management",
        "Pain prevention, pain management, anxiety reduction, and infection treatment/prevention",
        "Only infection prevention",
        "Only cosmetic purposes"
      ],
      correctAnswer: 1
    },
    {
      id: 70157,
      question: "What is true about all drugs used in dental practice?",
      options: [
        "They are completely risk-free",
        "All drugs have multiple effects and NO drug is risk free",
        "Only prescription drugs have risks",
        "Over-the-counter drugs are always safe"
      ],
      correctAnswer: 1
    },
    {
      id: 70158,
      question: "What must clinicians know to decrease drug-related emergencies?",
      options: [
        "Only drug names and dosages",
        "Patient insurance coverage",
        "Pharmacologic actions and proper techniques",
        "Only side effects"
      ],
      correctAnswer: 2
    },
    {
      id: 70159,
      question: "Which side effect is associated with many high blood pressure medications?",
      options: [
        "Increased appetite",
        "Enhanced vision",
        "Improved hearing",
        "Orthostatic hypotension"
      ],
      correctAnswer: 3
    },
    {
      id: 70160,
      question: "What happens when local anesthetic is mixed with alcohol?",
      options: [
        "Enhanced effectiveness",
        "No interaction occurs",
        "Dangerous drug interaction",
        "Improved pain relief"
      ],
      correctAnswer: 2
    },
    {
      id: 70161,
      question: "What happens when barbiturates are mixed with alcohol?",
      options: [
        "Improved sleep quality",
        "Enhanced effectiveness",
        "Dangerous interaction",
        "No effect"
      ],
      correctAnswer: 2
    },
    {
      id: 70162,
      question: "What is the result of mixing standard opioids with alcohol?",
      options: [
        "Better pain control",
        "Decreased side effects",
        "Increase in CNS depressant effects",
        "No interaction"
      ],
      correctAnswer: 2
    },
    {
      id: 70163,
      question: "What symptoms occur when metronidazole is mixed with alcohol?",
      options: [
        "Improved antibiotic effectiveness",
        "No symptoms occur",
        "Enhanced healing",
        "Facial flushing, nausea, headaches, and palpitations"
      ],
      correctAnswer: 3
    },
    {
      id: 70164,
      question: "How are medical emergencies classified by signs and symptoms?",
      options: [
        "By patient age only",
        "In categories representing usual clinical manifestation of the problem",
        "By insurance coverage",
        "By treatment cost"
      ],
      correctAnswer: 1
    },
    {
      id: 70165,
      question: "Can some emergency situations fit into multiple classification categories?",
      options: [
        "No, each fits only one category",
        "Yes, some situations could be included in different classifications",
        "Only cardiovascular emergencies fit multiple categories",
        "Classifications never overlap"
      ],
      correctAnswer: 1
    },
    {
      id: 70166,
      question: "What are myocardial infarction and cerebrovascular accident possible causes of?",
      options: [
        "Hyperventilation",
        "Seizures",
        "Unconsciousness",
        "Anxiety attacks"
      ],
      correctAnswer: 2
    },
    {
      id: 70167,
      question: "How are medical emergencies classified by cause?",
      options: [
        "By time of day only",
        "By patient age and gender",
        "Cardiovascular vs non-cardiovascular; stress-related vs non-stress-related",
        "By insurance type only"
      ],
      correctAnswer: 2
    },
    {
      id: 70168,
      question: "What does the cardiovascular classification consider?",
      options: [
        "Patient's emotional state",
        "Whether it involves the heart or not",
        "Patient's dental history",
        "Type of insurance coverage"
      ],
      correctAnswer: 1
    },
    {
      id: 70169,
      question: "What does stress-related classification assess?",
      options: [
        "Patient's work situation",
        "Family history only",
        "Whether it was treatment/office induced or presented independently",
        "Financial concerns"
      ],
      correctAnswer: 2
    },
    {
      id: 70170,
      question: "Which is NOT listed as a potential dental emergency?",
      options: [
        "Syncope",
        "Common cold",
        "Hyperventilation",
        "Asthma"
      ],
      correctAnswer: 1
    },
    {
      id: 70171,
      question: "Which cardiovascular emergency is listed as a potential dental emergency?",
      options: [
        "Varicose veins",
        "Angina pectoris",
        "Spider veins",
        "Bruising"
      ],
      correctAnswer: 1
    },
    {
      id: 70172,
      question: "Which respiratory emergency is listed as potential in dental settings?",
      options: [
        "Chronic bronchitis",
        "Asthma",
        "Common cold",
        "Seasonal allergies"
      ],
      correctAnswer: 1
    },
    {
      id: 70173,
      question: "Which neurological emergency is mentioned as potential in dental settings?",
      options: [
        "Migraine headache",
        "Tension headache",
        "Seizures",
        "Dizziness"
      ],
      correctAnswer: 2
    },
    {
      id: 70174,
      question: "Which metabolic emergencies are listed as potential dental emergencies?",
      options: [
        "Thyroid storm only",
        "Adrenal crisis only",
        "Hypo/hyperglycemia and adrenal crisis",
        "Only hypoglycemia"
      ],
      correctAnswer: 2
    },
    {
      id: 70175,
      question: "Which traumatic emergency involves the eye?",
      options: [
        "Conjunctivitis",
        "Foreign body or chemical solutions in eye",
        "Eye strain",
        "Glaucoma"
      ],
      correctAnswer: 1
    },
    {
      id: 70176,
      question: "Which dental trauma is listed as a potential emergency?",
      options: [
        "Tooth sensitivity",
        "Gum inflammation",
        "Avulsed tooth",
        "Plaque buildup"
      ],
      correctAnswer: 2
    },
    {
      id: 70177,
      question: "Which structural emergency is mentioned as potential in dental practice?",
      options: [
        "Broken fingernail",
        "Sprained wrist",
        "Dislocated jaw",
        "Twisted ankle"
      ],
      correctAnswer: 2
    },
    {
      id: 70178,
      question: "What ranking does syncope have in the top ten emergencies?",
      options: [
        "10th most common",
        "5th most common",
        "1st most common",
        "3rd most common"
      ],
      correctAnswer: 2
    },
    {
      id: 70179,
      question: "What ranking does postural hypotension have in the top ten emergencies?",
      options: [
        "1st most common",
        "10th most common",
        "4th most common",
        "7th most common"
      ],
      correctAnswer: 2
    },
    {
      id: 70180,
      question: "What ranking does angina pectoris have in the top ten emergencies?",
      options: [
        "10th most common",
        "1st most common",
        "3rd most common",
        "8th most common"
      ],
      correctAnswer: 2
    },
    {
      id: 70181,
      question: "What ranking does mild allergic reaction have in the top ten emergencies?",
      options: [
        "2nd most common",
        "5th most common",
        "9th most common",
        "10th most common"
      ],
      correctAnswer: 0
    },
    {
      id: 70182,
      question: "What ranking does seizures have in the top ten emergencies?",
      options: [
        "3rd most common",
        "5th most common",
        "7th most common",
        "10th most common"
      ],
      correctAnswer: 1
    },
    {
      id: 70183,
      question: "What is the purpose of pre-treatment evaluation?",
      options: [
        "To bill insurance correctly",
        "To minimize emergencies before they occur",
        "To schedule appointments efficiently",
        "To determine payment methods"
      ],
      correctAnswer: 1
    },
    {
      id: 70184,
      question: "What components are included in pre-treatment evaluation?",
      options: [
        "Only blood pressure measurement",
        "Medical history questionnaires and dialogue histories",
        "Only allergy assessment",
        "Only dental history review"
      ],
      correctAnswer: 1
    },
    {
      id: 70185,
      question: "What should be done during treatment to minimize emergencies?",
      options: [
        "Rush through procedures quickly",
        "Ignore patient complaints",
        "Use stress reduction techniques",
        "Avoid monitoring vital signs"
      ],
      correctAnswer: 2
    },
    {
      id: 70186,
      question: "What should be evaluated before patient dismissal?",
      options: [
        "Only payment completion",
        "Only next appointment scheduling",
        "Stable conditions to ensure safe dismissal",
        "Nothing needs evaluation"
      ],
      correctAnswer: 2
    },
    {
      id: 70187,
      question: "What does ASA stand for?",
      options: [
        "American Surgery Association",
        "American Society of Anesthesiologists",
        "Anesthetic Safety Assessment",
        "Advanced Surgical Analysis"
      ],
      correctAnswer: 1
    },
    {
      id: 70188,
      question: "What is the purpose of the ASA Physical Status Classification System?",
      options: [
        "To determine insurance coverage",
        "To schedule appointment length",
        "To estimate medical risk for patients receiving anesthesia",
        "To calculate treatment costs"
      ],
      correctAnswer: 2
    },
    {
      id: 70189,
      question: "Does the ASA system apply only to general anesthesia?",
      options: [
        "Yes, only general anesthesia",
        "No, it applies to all types of anesthesia including local",
        "Only to IV sedation",
        "Only to nitrous oxide sedation"
      ],
      correctAnswer: 1
    },
    {
      id: 70190,
      question: "What does ASA 1 classification indicate?",
      options: [
        "Patient with severe disease",
        "Normal, healthy client free of systemic disease",
        "Patient with mild disease",
        "Emergency patient"
      ],
      correctAnswer: 1
    },
    {
      id: 70191,
      question: "What does \"green light\" mean in ASA classification?",
      options: [
        "Emergency treatment only",
        "No treatment should be provided",
        "Treatment can proceed without modification",
        "Hospital referral required"
      ],
      correctAnswer: 2
    },
    {
      id: 70192,
      question: "What does ASA II classification indicate?",
      options: [
        "Normal healthy patient",
        "Client with mild systemic disease",
        "Patient with severe disease",
        "Moribund patient"
      ],
      correctAnswer: 1
    },
    {
      id: 70193,
      question: "Can an ASA I patient be classified as ASA II?",
      options: [
        "Never possible",
        "Only with physician approval",
        "Yes, if they have extreme dental anxiety",
        "Only if they request it"
      ],
      correctAnswer: 2
    },
    {
      id: 70194,
      question: "What does \"yellow light\" mean in ASA classification?",
      options: [
        "No treatment permitted",
        "Emergency only",
        "Treatment permitted with consideration for modifications",
        "Hospital treatment required"
      ],
      correctAnswer: 2
    },
    {
      id: 70195,
      question: "What does ASA III classification indicate?",
      options: [
        "Normal healthy patient",
        "Client with severe systemic disease that limits activity but is not incapacitating",
        "Patient with mild disease",
        "Moribund patient"
      ],
      correctAnswer: 1
    },
    {
      id: 70196,
      question: "How is dental anxiety considered in ASA classification?",
      options: [
        "Never considered",
        "Only for children",
        "Extreme dental anxiety can increase ASA classification",
        "Only for phobic patients"
      ],
      correctAnswer: 2
    },
    {
      id: 70197,
      question: "When do ASA III patients exhibit symptoms?",
      options: [
        "At all times including rest",
        "Never show any symptoms",
        "Do not exhibit symptoms at rest but distress appears during stress",
        "Only during sleep"
      ],
      correctAnswer: 2
    },
    {
      id: 70198,
      question: "What example illustrates ASA III symptom presentation?",
      options: [
        "Patient always has chest pain",
        "Patient never experiences any discomfort",
        "Angina client is fine in waiting room but develops chest pain in dental chair",
        "Patient refuses all treatment"
      ],
      correctAnswer: 2
    },
    {
      id: 70199,
      question: "Is elective dental care contraindicated for ASA III patients?",
      options: [
        "Yes, absolutely contraindicated",
        "No, not contraindicated but risk is increased",
        "Only surgical care is contraindicated",
        "All care is contraindicated"
      ],
      correctAnswer: 1
    },
    {
      id: 70200,
      question: "When is distress present in ASA IV patients?",
      options: [
        "Only during procedures",
        "Never present",
        "Only during stress",
        "Even at rest"
      ],
      correctAnswer: 3
    },
    {
      id: 70201,
      question: "What does \"red light\" classification mean for ASA IV patients?",
      options: [
        "Treatment proceeds normally",
        "Only routine care provided",
        "Significant restrictions on dental treatment",
        "No restrictions apply"
      ],
      correctAnswer: 2
    },
    {
      id: 70202,
      question: "What type of dental treatment should ASA IV patients receive?",
      options: [
        "All elective procedures",
        "Noninvasive treatment including analgesics and antibiotics",
        "Aggressive surgical treatment",
        "Cosmetic procedures"
      ],
      correctAnswer: 1
    },
    {
      id: 70203,
      question: "Where should immediate dental care for ASA IV patients be performed if needed?",
      options: [
        "Regular dental office",
        "Mobile dental unit",
        "Hospital setting",
        "Patient's home"
      ],
      correctAnswer: 2
    },
    {
      id: 70204,
      question: "Why is hospital setting preferred for ASA IV emergency treatment?",
      options: [
        "Better billing options",
        "More convenient scheduling",
        "In case an acute medical emergency occurs",
        "Faster appointment times"
      ],
      correctAnswer: 2
    },
    {
      id: 70205,
      question: "What is more significant to ASA IV patients' health than dental treatment?",
      options: [
        "Their insurance coverage",
        "Their medical problems",
        "Their appointment schedule",
        "Their dental history"
      ],
      correctAnswer: 1
    },
    {
      id: 70206,
      question: "Medical emergencies require help from a doctor or hospital.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70207,
      question: "Life-threatening emergencies can only happen to patients in dental offices.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70208,
      question: "Life-threatening emergencies occur frequently in dental offices.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70209,
      question: "Increased number of older clients contributes to medical emergencies in dental practice.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70210,
      question: "Medical advancements are a factor that increases emergency likelihood.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70211,
      question: "Longer appointments contribute to increased emergency risk.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70212,
      question: "As life expectancy increases, fewer older clients seek dental care.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70213,
      question: "Cardiovascular disease is the leading cause of death in persons over 65.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70214,
      question: "Clients with chronic conditions are living shorter lives than 25-35 years ago.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70215,
      question: "Coronary bypass operations allow people to pursue active lives after surgery.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70216,
      question: "Radiation and chemotherapy allow cancer clients to live longer.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70217,
      question: "Organ transplants have lower success rates today than in the past.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70218,
      question: "More effective drug therapies are available for managing chronic disorders today.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70219,
      question: "Clients with managed chronic disorders are more susceptible to medical emergencies.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70220,
      question: "Advanced dental procedures like implants generally require longer appointments.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70221,
      question: "Longer appointment times increase stress only for compromised clients.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70222,
      question: "Drugs in dental practice are used for pain prevention and management.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70223,
      question: "All drugs are risk-free when used properly.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70224,
      question: "All drugs have multiple effects.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70225,
      question: "Orthostatic hypotension is associated with many high blood pressure medications.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70226,
      question: "Local anesthetic and alcohol mix well together.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70227,
      question: "Standard opioids mixed with alcohol increase CNS depressant effects.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70228,
      question: "Metronidazole mixed with alcohol causes no side effects.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70229,
      question: "Medical emergencies can be classified by signs and symptoms.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70230,
      question: "Some emergency situations can fit into multiple classification categories.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70231,
      question: "Myocardial infarction can cause unconsciousness.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70232,
      question: "Medical emergencies can be classified as cardiovascular vs non-cardiovascular.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70233,
      question: "Stress-related classification considers if the emergency was treatment-induced.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70234,
      question: "Syncope is listed as a potential dental emergency.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70235,
      question: "Fluoride poisoning is a potential dental emergency.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70236,
      question: "Syncope is the most common emergency in private dental practice.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70237,
      question: "Cardiac arrest is the most common emergency in private practice.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70238,
      question: "Medical history questionnaires are part of pre-treatment evaluation.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70239,
      question: "Dialogue histories help minimize emergencies before they occur.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70240,
      question: "Stress reduction techniques should be used during treatment.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70241,
      question: "Stable conditions should be assessed before patient dismissal.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70242,
      question: "ASA stands for American Society of Anesthesiologists.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70243,
      question: "The ASA system helps estimate medical risk for patients receiving anesthesia.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70244,
      question: "The ASA system applies only to general anesthesia.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70245,
      question: "ASA 1 indicates a normal, healthy client free of systemic disease.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70246,
      question: "ASA II can include an ASA I patient with extreme dental anxiety.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70247,
      question: "ASA III patients exhibit symptoms even at rest.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70248,
      question: "ASA IV patients have distress present even at rest.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70249,
      question: "\"Green light\" for ASA I means treatment can proceed without modification.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70250,
      question: "\"Yellow light\" means treatment is permitted with possible modifications.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70251,
      question: "\"Red light\" for ASA IV means significant treatment restrictions apply.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70252,
      question: "ASA IV patients should receive all elective dental procedures.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70253,
      question: "ASA IV emergency care should be done in a hospital setting if immediate care is needed.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70254,
      question: "ASA E indicates an emergency operation.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70255,
      question: "ASA 6 refers to brain-dead patients whose organs are being removed for donation.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "1. Introduction and prevention (Part 4)": [
    {
      id: 70275,
      question: "What is omega-3 primarily taken for according to the lecture?",
      options: [
        "Bone health and calcium absorption",
        "Mental health and cognitive function",
        "Immune system support",
        "Cardiovascular conditions"
      ],
      correctAnswer: 3
    },
    {
      id: 70276,
      question: "What dental consideration is required when a patient is taking omega-3?",
      options: [
        "Check for drug interactions with local anesthetics",
        "Monitor the vital signs (blood pressure)",
        "Assess for allergic reactions",
        "Evaluate kidney function"
      ],
      correctAnswer: 1
    },
    {
      id: 70277,
      question: "What medication class does Eliquis belong to?",
      options: [
        "Antibiotic used for bacterial infections",
        "Antihypertensive for blood pressure control",
        "Blood thinner (anticoagulant)",
        "Anti-inflammatory for pain management"
      ],
      correctAnswer: 2
    },
    {
      id: 70278,
      question: "For patients taking Eliquis or other blood thinners (excluding baby aspirin), what should be checked?",
      options: [
        "INR levels and ensure no other bleeding disorders",
        "Blood glucose levels",
        "Liver enzyme levels",
        "White blood cell count"
      ],
      correctAnswer: 0
    },
    {
      id: 70279,
      question: "What is the dosage threshold mentioned for baby aspirin that doesn't require special precautions?",
      options: [
        "50 milligrams",
        "81 milligrams",
        "100 milligrams",
        "325 milligrams"
      ],
      correctAnswer: 1
    },
    {
      id: 70280,
      question: "What should you do if you forgot to ask about INR levels and the patient bleeds profusely?",
      options: [
        "Apply ice packs immediately",
        "Use hemostatic agents like Hematin with cotton plier",
        "Call emergency services right away",
        "Elevate the patient's legs"
      ],
      correctAnswer: 1
    },
    {
      id: 70281,
      question: "Why is it important to know INR levels for patients on warfarin or Eliquis?",
      options: [
        "These medications affect liver metabolism",
        "These medications cause kidney complications",
        "These medications make blood very thin, easy to bleed",
        "These medications interact with local anesthetics"
      ],
      correctAnswer: 2
    },
    {
      id: 70282,
      question: "What question in the medical health history addresses bleeding tendencies?",
      options: [
        "Have you had recent surgery or hospitalization?",
        "Do you take any prescription medications?",
        "Do you bruise easily or experience prolonged bleeding after dental treatments?",
        "Have you ever had complications from anesthesia?"
      ],
      correctAnswer: 2
    },
    {
      id: 70283,
      question: "What conditions might bleeding disorders indicate caution for?",
      options: [
        "Root canal therapy and crown preparation",
        "Probing, scaling, or invasive procedures",
        "Fluoride application and sealant placement",
        "Radiographic imaging and photography"
      ],
      correctAnswer: 1
    },
    {
      id: 70284,
      question: "When is a medical clearance needed for anemia?",
      options: [
        "If it's poorly controlled or patient stopped taking medication",
        "Only if the patient requests it",
        "For all cases of anemia regardless of control",
        "Never, as anemia is not a dental concern"
      ],
      correctAnswer: 0
    },
    {
      id: 70285,
      question: "What should you do if a patient's blood pressure reads 135/85 and they have no history of hypertension?",
      options: [
        "Proceed with treatment immediately",
        "Send them to emergency room",
        "Take the reading again after 5 minutes",
        "Cancel the appointment"
      ],
      correctAnswer: 2
    },
    {
      id: 70286,
      question: "After retaking blood pressure and confirming elevated readings, what is the next step?",
      options: [
        "Give the patient the original form",
        "Call their family doctor immediately",
        "Give the patient a copy of the reading",
        "Document only without patient notification"
      ],
      correctAnswer: 2
    },
    {
      id: 70287,
      question: "What is white coat syndrome?",
      options: [
        "Allergy to dental materials",
        "Elevated blood pressure in clinical settings due to anxiety",
        "Sensitivity to bright lights",
        "Fear of needles and injections"
      ],
      correctAnswer: 1
    },
    {
      id: 70288,
      question: "What should you do for a patient with confirmed white coat syndrome?",
      options: [
        "Refuse treatment until blood pressure normalizes",
        "Send medical consultation and ask for letter from family doctor",
        "Ignore the elevated readings",
        "Only take blood pressure at end of appointment"
      ],
      correctAnswer: 1
    },
    {
      id: 70289,
      question: "What three questions should be asked of diabetic patients?",
      options: [
        "When was last meal, medication, and blood sugar level",
        "Type of diabetes, family history, and diet",
        "Insurance coverage, medication costs, and pharmacy",
        "Exercise routine, weight changes, and stress levels"
      ],
      correctAnswer: 0
    },
    {
      id: 70290,
      question: "If seeing a diabetic patient for the first time, what additional information should you obtain?",
      options: [
        "Complete dietary log for the past week",
        "List of all family members with diabetes",
        "When was last blood work and what was A1C level",
        "Exercise habits and sleep patterns"
      ],
      correctAnswer: 2
    },
    {
      id: 70291,
      question: "What should be available chairside for a diabetic patient?",
      options: [
        "Insulin and syringes for emergencies",
        "Glucose tablets or juice for hypoglycemia",
        "Blood glucose monitor only",
        "Special dietary supplements"
      ],
      correctAnswer: 1
    },
    {
      id: 70292,
      question: "What condition would require giving a patient juice?",
      options: [
        "Hyperglycemia (high blood sugar)",
        "Hypertension (high blood pressure)",
        "Hypoglycemia (low blood sugar)",
        "Hypotension (low blood pressure)"
      ],
      correctAnswer: 2
    },
    {
      id: 70293,
      question: "What types of allergies should be specifically asked about in the medical history?",
      options: [
        "Food allergies only",
        "Environmental allergens like pollen",
        "Latex, antibiotics, anesthetics, or dental materials",
        "Pet dander and dust mites"
      ],
      correctAnswer: 2
    },
    {
      id: 70294,
      question: "What should you do if a patient has a delayed allergic reaction after leaving the clinic?",
      options: [
        "Tell them to take their allergy medication and go to walk-in clinic",
        "Ignore it as it's no longer your responsibility",
        "Schedule an immediate follow-up appointment",
        "Prescribe antihistamines over the phone"
      ],
      correctAnswer: 0
    },
    {
      id: 70295,
      question: "What respiratory condition question should be asked in the medical history?",
      options: [
        "Do you smoke or use tobacco products?",
        "Have you had pneumonia or bronchitis recently?",
        "Do you have asthma or breathing difficulties?",
        "Do you live in an area with poor air quality?"
      ],
      correctAnswer: 2
    },
    {
      id: 70296,
      question: "If an asthma patient didn't bring their inhaler, what follow-up questions should be asked?",
      options: [
        "What is your peak flow reading today?",
        "When was last asthmatic episode and what triggered it?",
        "How many times per day do you use your inhaler?",
        "What type of asthma do you have?"
      ],
      correctAnswer: 1
    },
    {
      id: 70297,
      question: "Where should emergency inhalers be available?",
      options: [
        "Only in hospitals",
        "In every private practice and clinic including Oxford",
        "Only in dental specialty offices",
        "Not required in dental settings"
      ],
      correctAnswer: 1
    },
    {
      id: 70298,
      question: "How often does CPR certification expire?",
      options: [
        "Every year",
        "Every 3 years",
        "Every 2 years",
        "Every 5 years"
      ],
      correctAnswer: 2
    },
    {
      id: 70299,
      question: "According to CDHO guidelines, how often must CPR refresher courses be taken?",
      options: [
        "Every 2 years when certification expires",
        "Every year regardless of certification expiry",
        "Every 6 months",
        "Only when certification expires"
      ],
      correctAnswer: 1
    },
    {
      id: 70300,
      question: "What happens if you fail to maintain annual CPR refresher courses as required by CDHO?",
      options: [
        "Nothing, it's just a recommendation",
        "You receive a warning letter",
        "You're putting yourself under disciplinary committee",
        "You lose your license immediately"
      ],
      correctAnswer: 2
    },
    {
      id: 70301,
      question: "What should dental hygienists know regarding emergency procedures?",
      options: [
        "Only basic first aid techniques",
        "Drugs in first aid kit, when to stop treatment, when to call EMS",
        "CPR only, no other procedures",
        "How to diagnose medical emergencies"
      ],
      correctAnswer: 1
    },
    {
      id: 70302,
      question: "When should vital signs be checked after giving nitroglycerin?",
      options: [
        "Before administering nitroglycerin",
        "Immediately while administering",
        "After patient is stable, then check pulse",
        "Every 30 seconds during administration"
      ],
      correctAnswer: 2
    },
    {
      id: 70303,
      question: "What is the correct method for nitroglycerin administration?",
      options: [
        "Patient swallows it with water",
        "Spray or sublingual (under tongue)",
        "Intramuscular injection",
        "Applied topically to chest"
      ],
      correctAnswer: 1
    },
    {
      id: 70304,
      question: "Who administers nitroglycerin when the patient is conscious?",
      options: [
        "The dental hygienist administers it",
        "The dentist must administer it",
        "The patient administers it to themselves",
        "Emergency medical services must be called first"
      ],
      correctAnswer: 2
    },
    {
      id: 70305,
      question: "What is the only exception where dental professionals may administer emergency medication?",
      options: [
        "Nitroglycerin in unconscious patients",
        "Insulin for diabetic emergencies",
        "EpiPen when patient is unable and staff trained",
        "Aspirin for heart attack symptoms"
      ],
      correctAnswer: 2
    },
    {
      id: 70306,
      question: "Can dental professionals create their own medical health history forms?",
      options: [
        "Yes, as long as it covers everything and follows guidelines",
        "No, only standardized forms are allowed",
        "Only dentists can create custom forms",
        "Only with written permission from CDHO"
      ],
      correctAnswer: 0
    },
    {
      id: 70307,
      question: "What approval is needed for custom medical health history forms?",
      options: [
        "No approval needed if comprehensive",
        "Must be approved before use",
        "Only peer review required",
        "Annual review by CDHO"
      ],
      correctAnswer: 1
    },
    {
      id: 70308,
      question: "What should be documented before sending out medical clearance for anemia?",
      options: [
        "Only the diagnosis",
        "All information including diagnosis, medication status, and compliance",
        "Just the patient's concerns",
        "Only blood work results"
      ],
      correctAnswer: 1
    },
    {
      id: 70309,
      question: "What cardiovascular questions should be in the medical history?",
      options: [
        "Family history of heart disease only",
        "Chest pain/angina, heart attack history, blood pressure status",
        "Cholesterol levels and exercise habits",
        "Diet and stress management techniques"
      ],
      correctAnswer: 1
    },
    {
      id: 70310,
      question: "If a patient has angina, should you still give nitroglycerin during an episode?",
      options: [
        "No, never give nitroglycerin to angina patients",
        "Yes, give nitroglycerin unless contraindicated",
        "Only if blood pressure is normal",
        "Only after calling emergency services"
      ],
      correctAnswer: 1
    },
    {
      id: 70311,
      question: "What is the purpose of medical consultation forms?",
      options: [
        "To document patient complaints",
        "To transfer care to another provider",
        "To ask if there's anything to be mindful of when treating patient",
        "To request medical records only"
      ],
      correctAnswer: 2
    },
    {
      id: 70312,
      question: "What should be done if a patient indicates they have bleeding disorders like hemophilia?",
      options: [
        "Refuse treatment immediately",
        "Read about it and determine if medical clearance needed",
        "Proceed with treatment as normal",
        "Only perform non-invasive procedures"
      ],
      correctAnswer: 1
    },
    {
      id: 70313,
      question: "Why is it important to ask diabetic patients when they last ate?",
      options: [
        "To schedule lunch breaks appropriately",
        "To prevent hypoglycemia during treatment",
        "To calculate anesthetic dosage",
        "To determine if they need antibiotics"
      ],
      correctAnswer: 1
    },
    {
      id: 70314,
      question: "What should be monitored for elderly patients on blood thinners?",
      options: [
        "Blood glucose levels",
        "Kidney function",
        "INR levels especially",
        "Cholesterol levels"
      ],
      correctAnswer: 2
    },
    {
      id: 70315,
      question: "What type of content will be covered in the next week's lectures?",
      options: [
        "Lectures 1 and 2 review",
        "Lectures 2 and 3 (lecture 3 is straightforward with less content)",
        "Only new advanced topics",
        "Case study presentations only"
      ],
      correctAnswer: 1
    },
    {
      id: 70316,
      question: "When is the test scheduled?",
      options: [
        "Two weeks from current class",
        "At the end of the semester",
        "Next week after finishing lectures 2 and 3",
        "After all case presentations are complete"
      ],
      correctAnswer: 2
    },
    {
      id: 70317,
      question: "What topics does the medical emergency course overlap with?",
      options: [
        "Pharmacology only",
        "Medical health history and follow-up procedures",
        "Radiology techniques",
        "Periodontal charting"
      ],
      correctAnswer: 1
    },
    {
      id: 70318,
      question: "What is emphasized about following CDHO standards?",
      options: [
        "They are optional guidelines for experienced practitioners",
        "Must be followed to maintain certification and avoid discipline",
        "Only apply to new graduates",
        "Can be modified based on clinical judgment"
      ],
      correctAnswer: 1
    },
    {
      id: 70319,
      question: "Why might patients not always follow guidelines about bringing inhalers?",
      options: [
        "They forget or don't perceive need",
        "Inhalers are too expensive",
        "Dental offices always have replacements",
        "CDHO doesn't require it"
      ],
      correctAnswer: 0
    },
    {
      id: 70320,
      question: "What should you do before treating a patient who didn't bring their inhaler?",
      options: [
        "Refuse treatment completely",
        "Ask when last episode was and what triggered it",
        "Provide them with clinic's emergency inhaler",
        "Have them sign a waiver"
      ],
      correctAnswer: 1
    },
    {
      id: 70321,
      question: "What precaution should be taken with latex allergies?",
      options: [
        "Use latex gloves but change frequently",
        "Avoid latex materials and use alternatives",
        "Pre-medicate with antihistamines",
        "Only dentist can treat these patients"
      ],
      correctAnswer: 1
    },
    {
      id: 70322,
      question: "What is the rationale for monitoring vitals with omega-3 supplementation?",
      options: [
        "It's a legal requirement for all supplements",
        "Omega-3 has cardiovascular effects requiring monitoring",
        "Omega-3 causes blood sugar changes",
        "Omega-3 affects breathing patterns"
      ],
      correctAnswer: 1
    },
    {
      id: 70323,
      question: "What should be documented about a patient's white coat syndrome?",
      options: [
        "Nothing, as it's not a real condition",
        "The elevated readings and medical consultation sent",
        "Only that patient was anxious",
        "Just the final blood pressure reading"
      ],
      correctAnswer: 1
    },
    {
      id: 70324,
      question: "Omega-3 is commonly taken for cardiovascular health.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70325,
      question: "Baby aspirin (81mg) requires the same precautions as other blood thinners like Eliquis.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70326,
      question: "INR levels should be checked for patients taking warfarin or Eliquis.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70327,
      question: "Hematin can be used to help stop profuse bleeding.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70328,
      question: "Medical clearance is always needed for anemia regardless of control status.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70329,
      question: "If a patient's blood pressure is elevated and they have no history of hypertension, you should retake it after 5 minutes.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70330,
      question: "Patients with white coat syndrome do not need medical consultation.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70331,
      question: "For diabetic patients, you should ask about their last meal, medication, and blood sugar level.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70332,
      question: "Juice should be given to a patient experiencing hyperglycemia (high blood sugar).",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70333,
      question: "Latex allergies should be specifically asked about in the medical history.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70334,
      question: "If a patient has a delayed allergic reaction, they should take their allergy medication and go to a walk-in clinic.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70335,
      question: "Emergency inhalers are only required in hospital dental departments.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70336,
      question: "CPR certification expires every 2 years.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70337,
      question: "CDHO requires CPR refresher courses every 2 years.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70338,
      question: "Failing to maintain annual CPR refreshers can result in disciplinary action.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70339,
      question: "Nitroglycerin should be administered by the dental professional in all cases.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70340,
      question: "Nitroglycerin is administered sublingually (under the tongue).",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70341,
      question: "The only exception for dental professionals administering medication is with EpiPen when the patient is unable and staff is trained.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70342,
      question: "Dental professionals cannot create their own medical health history forms.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70343,
      question: "Custom medical health history forms need to be approved.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70344,
      question: "When a patient has angina, you should never give them nitroglycerin.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70345,
      question: "Medical consultation forms help identify what to be mindful of when treating a patient.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70346,
      question: "The test will be held next week after completing lectures 2 and 3.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70347,
      question: "Lecture 3 is described as having a lot of complex content.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ],
  "1. Introduction and prevention (Part 3)": [
    {
      id: 70348,
      question: "What is the primary purpose of studying medical emergencies in dental hygiene practice?",
      options: [
        "To replace the need for emergency medical services",
        "To diagnose complex medical conditions independently",
        "To recognize, prevent, and manage life-threatening situations",
        "To perform advanced cardiac life support procedures"
      ],
      correctAnswer: 2
    },
    {
      id: 70349,
      question: "Which of the following is NOT one of the three main objectives of learning medical emergencies?",
      options: [
        "Recognition of medical emergencies",
        "Management of medical emergencies",
        "Prevention of medical emergencies",
        "Prescription of emergency medications"
      ],
      correctAnswer: 3
    },
    {
      id: 70350,
      question: "What percentage of dental practitioners will likely face a medical emergency during their career?",
      options: [
        "Approximately 90% will experience emergencies",
        "Approximately 50% will experience emergencies",
        "Approximately 25% will experience emergencies",
        "Approximately 75% will experience emergencies"
      ],
      correctAnswer: 0
    },
    {
      id: 70351,
      question: "Which factor has contributed to the increased likelihood of medical emergencies in dental settings?",
      options: [
        "Reduced number of patients seeking dental care",
        "Aging population with multiple medical conditions",
        "Decreased use of local anesthetics in procedures",
        "Simplified dental procedures requiring less time"
      ],
      correctAnswer: 1
    },
    {
      id: 70352,
      question: "What is the most common medical emergency in dental practice?",
      options: [
        "Cardiac arrest requiring immediate defibrillation",
        "Severe allergic reactions to medications",
        "Syncope, also known as fainting",
        "Respiratory failure due to airway obstruction"
      ],
      correctAnswer: 2
    },
    {
      id: 70353,
      question: "Which of the following best describes syncope?",
      options: [
        "Prolonged confusion without loss of consciousness",
        "Temporary loss of consciousness with spontaneous recovery",
        "Permanent loss of consciousness requiring hospitalization",
        "Loss of motor function without consciousness changes"
      ],
      correctAnswer: 1
    },
    {
      id: 70354,
      question: "What is the primary cause of vasovagal syncope?",
      options: [
        "Sudden drop in blood pressure and heart rate",
        "Acute myocardial infarction with cardiac dysfunction",
        "Severe dehydration leading to circulatory collapse",
        "Cerebrovascular accident affecting consciousness centers"
      ],
      correctAnswer: 0
    },
    {
      id: 70355,
      question: "Which sign or symptom typically precedes a syncopal episode?",
      options: [
        "Severe headache with visual disturbances",
        "Sudden chest pain radiating to the arm",
        "Dizziness, nausea, or feeling warm",
        "Difficulty breathing with audible wheezing"
      ],
      correctAnswer: 2
    },
    {
      id: 70356,
      question: "What is the recommended immediate management for a patient experiencing syncope?",
      options: [
        "Begin chest compressions to restore circulation",
        "Keep patient upright to maintain blood pressure",
        "Administer oxygen at high flow rates immediately",
        "Position patient supine with legs elevated"
      ],
      correctAnswer: 3
    },
    {
      id: 70357,
      question: "How can dental professionals help prevent syncope during treatment?",
      options: [
        "Ensure patients are comfortable and reduce anxiety",
        "Administer sedatives to all anxious patients routinely",
        "Perform all procedures with patient standing upright",
        "Avoid using local anesthetics that may cause reactions"
      ],
      correctAnswer: 0
    },
    {
      id: 70358,
      question: "What characterizes orthostatic hypotension?",
      options: [
        "Consistently high blood pressure regardless of position",
        "Blood pressure drop upon standing from sitting",
        "Elevated blood pressure when lying down flat",
        "Irregular blood pressure fluctuations during exercise"
      ],
      correctAnswer: 1
    },
    {
      id: 70359,
      question: "Which patient population is at highest risk for orthostatic hypotension?",
      options: [
        "Young adults with no medical history",
        "Middle-aged patients with excellent health",
        "Elderly patients taking multiple medications",
        "Children undergoing routine dental examinations"
      ],
      correctAnswer: 2
    },
    {
      id: 70360,
      question: "What is the recommended prevention strategy for orthostatic hypotension in dental practice?",
      options: [
        "Keep patients in supine position indefinitely",
        "Encourage vigorous movement immediately after treatment",
        "Have patients stand quickly after procedures",
        "Allow patients to sit up slowly before standing"
      ],
      correctAnswer: 3
    },
    {
      id: 70361,
      question: "Which condition involves a severe, life-threatening allergic reaction?",
      options: [
        "Anaphylaxis with systemic multi-organ involvement",
        "Mild urticaria with localized skin involvement",
        "Contact dermatitis affecting only exposed areas",
        "Delayed hypersensitivity occurring days after exposure"
      ],
      correctAnswer: 0
    },
    {
      id: 70362,
      question: "What is the first-line medication for treating anaphylaxis?",
      options: [
        "Bronchodilators to open constricted airways",
        "Epinephrine administered via intramuscular injection",
        "Antihistamines to block histamine receptors",
        "Corticosteroids to reduce long-term inflammation"
      ],
      correctAnswer: 1
    },
    {
      id: 70363,
      question: "Which symptom is most indicative of anaphylaxis rather than a mild allergic reaction?",
      options: [
        "Mild rash on arms without other symptoms",
        "Localized itching at the injection site only",
        "Difficulty breathing with throat swelling",
        "Slight nausea without respiratory involvement"
      ],
      correctAnswer: 2
    },
    {
      id: 70364,
      question: "How can dental professionals prevent anaphylactic reactions?",
      options: [
        "Administer antibiotics prophylactically to all patients",
        "Avoid asking about patient medication allergies",
        "Use the same materials for all patients uniformly",
        "Obtain thorough medical and allergy history"
      ],
      correctAnswer: 3
    },
    {
      id: 70365,
      question: "What characterizes angina pectoris?",
      options: [
        "Chest pain due to temporary inadequate oxygen supply",
        "Permanent heart muscle damage with tissue death",
        "Complete blockage of coronary arteries requiring surgery",
        "Inflammation of the heart lining causing discomfort"
      ],
      correctAnswer: 0
    },
    {
      id: 70366,
      question: "Which medication is typically used to manage an angina attack?",
      options: [
        "Aspirin to thin blood and prevent clotting",
        "Nitroglycerin to dilate blood vessels",
        "Beta-blockers to slow heart rate permanently",
        "Calcium channel blockers for long-term control"
      ],
      correctAnswer: 1
    },
    {
      id: 70367,
      question: "What distinguishes myocardial infarction from angina?",
      options: [
        "MI involves actual heart tissue death while angina doesn't",
        "MI causes temporary pain while angina is permanent",
        "MI resolves with rest while angina requires medication",
        "MI occurs only during exercise while angina occurs at rest"
      ],
      correctAnswer: 0
    },
    {
      id: 70368,
      question: "Which sign is characteristic of a myocardial infarction?",
      options: [
        "Intermittent pain occurring only during physical activity",
        "Brief chest discomfort relieved by rest",
        "Severe crushing chest pain lasting over 20 minutes",
        "Mild discomfort that resolves with nitroglycerin"
      ],
      correctAnswer: 2
    },
    {
      id: 70369,
      question: "What is the appropriate emergency response for suspected myocardial infarction?",
      options: [
        "Allow patient to rest and reassess in 30 minutes",
        "Transport patient to hospital in personal vehicle",
        "Continue dental treatment after giving nitroglycerin",
        "Call emergency services immediately and administer aspirin"
      ],
      correctAnswer: 3
    },
    {
      id: 70370,
      question: "Which factor increases the risk of cardiac emergencies during dental treatment?",
      options: [
        "History of heart disease and high stress levels",
        "Young age with no cardiovascular risk factors",
        "Regular exercise and healthy lifestyle habits",
        "Normal blood pressure and cholesterol levels"
      ],
      correctAnswer: 0
    },
    {
      id: 70371,
      question: "What is hypoglycemia?",
      options: [
        "Chronic elevation of blood glucose over time",
        "Abnormally low blood sugar causing symptoms",
        "Abnormally high blood sugar requiring insulin",
        "Normal blood sugar fluctuation during meals"
      ],
      correctAnswer: 1
    },
    {
      id: 70372,
      question: "Which symptom is commonly associated with hypoglycemia?",
      options: [
        "Excessive thirst and frequent urination",
        "Dry mouth with decreased perspiration",
        "Confusion, sweating, and shakiness",
        "Slow onset of symptoms over several days"
      ],
      correctAnswer: 2
    },
    {
      id: 70373,
      question: "What is the immediate treatment for conscious hypoglycemic patients?",
      options: [
        "Give glucose tablets or sugary drink",
        "Administer insulin to regulate blood sugar",
        "Provide protein-rich foods for sustained energy",
        "Encourage exercise to metabolize excess sugar"
      ],
      correctAnswer: 0
    },
    {
      id: 70374,
      question: "How can dental professionals prevent hypoglycemic episodes?",
      options: [
        "Require all diabetic patients to fast before treatment",
        "Schedule appointments immediately after patients have eaten",
        "Prohibit diabetic patients from bringing glucose sources",
        "Avoid scheduling appointments during typical meal times"
      ],
      correctAnswer: 1
    },
    {
      id: 70375,
      question: "What characterizes a cerebrovascular accident (stroke)?",
      options: [
        "Temporary disruption of brain function with full recovery",
        "Minor brain dysfunction without lasting consequences",
        "Interruption of blood flow to brain causing cell death",
        "Reversible brain injury with immediate resolution"
      ],
      correctAnswer: 2
    },
    {
      id: 70376,
      question: "Which acronym helps identify stroke symptoms?",
      options: [
        "SAMPLE for gathering patient history information",
        "RICE for rest, ice, compression, elevation",
        "AVPU for assessing level of consciousness",
        "FAST for face, arm, speech, time"
      ],
      correctAnswer: 3
    },
    {
      id: 70377,
      question: "What does the \"F\" in FAST stand for when assessing stroke?",
      options: [
        "Face drooping on one side",
        "Fever indicating possible infection complications",
        "Fingers showing decreased sensation bilaterally",
        "Feet demonstrating weakness in both lower extremities"
      ],
      correctAnswer: 0
    },
    {
      id: 70378,
      question: "What is the critical time window for stroke treatment to be most effective?",
      options: [
        "Within the first 30 minutes of symptom onset",
        "Within the first 12 hours of symptom onset",
        "Within the first 3 hours of symptom onset",
        "Within the first 24 hours of symptom onset"
      ],
      correctAnswer: 2
    },
    {
      id: 70379,
      question: "Which breathing emergency involves narrowing of the airways?",
      options: [
        "Pulmonary embolism blocking blood vessels",
        "Asthma causing bronchial constriction",
        "Pneumonia affecting alveolar gas exchange",
        "Pleural effusion compressing lung tissue"
      ],
      correctAnswer: 1
    },
    {
      id: 70380,
      question: "What medication do asthmatic patients typically carry for acute attacks?",
      options: [
        "Rescue inhaler with bronchodilator medication",
        "Oral corticosteroids for long-term control",
        "Antihistamines to reduce allergic response",
        "Antibiotics to prevent respiratory infections"
      ],
      correctAnswer: 0
    },
    {
      id: 70381,
      question: "What is the primary management strategy for choking (foreign body airway obstruction)?",
      options: [
        "Place patient supine and monitor breathing",
        "Perform abdominal thrusts (Heimlich maneuver)",
        "Encourage patient to continue coughing forcefully",
        "Immediately begin rescue breathing with ventilations"
      ],
      correctAnswer: 1
    },
    {
      id: 70382,
      question: "How can dental professionals prevent choking during procedures?",
      options: [
        "Work without suction to avoid tissue trauma",
        "Allow patients to talk continuously during treatment",
        "Use rubber dam isolation and maintain suction",
        "Position patients completely upright at all times"
      ],
      correctAnswer: 2
    },
    {
      id: 70383,
      question: "Which seizure type involves loss of consciousness with convulsions?",
      options: [
        "Generalized tonic-clonic seizures with full-body involvement",
        "Absence seizures with brief consciousness lapses",
        "Focal seizures affecting only specific body areas",
        "Myoclonic seizures with brief muscle jerks"
      ],
      correctAnswer: 0
    },
    {
      id: 70384,
      question: "What is the appropriate management during an active seizure?",
      options: [
        "Administer anticonvulsant medications immediately during seizure",
        "Protect patient from injury and time the seizure",
        "Restrain patient movements to prevent injury",
        "Place objects in mouth to prevent tongue biting"
      ],
      correctAnswer: 1
    },
    {
      id: 70385,
      question: "When should emergency services be called for a seizure?",
      options: [
        "Only if the patient has never had seizures before",
        "Only if the patient stops breathing permanently",
        "If seizure lasts longer than 5 minutes",
        "Immediately when any seizure begins regardless of duration"
      ],
      correctAnswer: 2
    },
    {
      id: 70386,
      question: "Which emergency involves severe hyperventilation causing respiratory alkalosis?",
      options: [
        "Asthma attack with bronchial obstruction",
        "Chronic obstructive pulmonary disease exacerbation",
        "Pulmonary embolism blocking circulation",
        "Hyperventilation syndrome due to anxiety"
      ],
      correctAnswer: 3
    },
    {
      id: 70387,
      question: "What is the recommended treatment for hyperventilation syndrome?",
      options: [
        "Administer high-flow oxygen through non-rebreather mask",
        "Have patient breathe into paper bag immediately",
        "Provide bronchodilator medication via nebulizer",
        "Calm patient and encourage slow breathing"
      ],
      correctAnswer: 3
    },
    {
      id: 70388,
      question: "What should be included in a dental office emergency kit?",
      options: [
        "Oxygen, AED, epinephrine, and emergency medications",
        "Only basic first aid supplies like bandages",
        "Advanced surgical instruments for emergency procedures",
        "Prescription medications for long-term chronic conditions"
      ],
      correctAnswer: 0
    },
    {
      id: 70389,
      question: "Why is an Automated External Defibrillator (AED) important in dental offices?",
      options: [
        "It provides oxygen to patients experiencing breathing difficulties",
        "It administers emergency medications automatically to patients",
        "It can restore normal heart rhythm during cardiac arrest",
        "It measures blood pressure during emergency situations"
      ],
      correctAnswer: 2
    },
    {
      id: 70390,
      question: "What is the purpose of obtaining a thorough medical history before dental treatment?",
      options: [
        "To delay treatment until all conditions are resolved",
        "To identify potential risk factors for medical emergencies",
        "To avoid treating patients with any medical conditions",
        "To determine insurance coverage for dental procedures"
      ],
      correctAnswer: 1
    },
    {
      id: 70391,
      question: "Which vital sign should be routinely monitored before and during dental procedures?",
      options: [
        "Body temperature to detect infections early",
        "Pupil response to assess neurological function",
        "Blood pressure to identify cardiovascular concerns",
        "Respiratory rate exclusively for all patients"
      ],
      correctAnswer: 2
    },
    {
      id: 70392,
      question: "How can stress and anxiety contribute to medical emergencies in dental settings?",
      options: [
        "They have no effect on medical emergency occurrence",
        "They only affect patients with no medical history",
        "They can trigger conditions like syncope and hyperventilation",
        "They prevent emergencies by increasing patient alertness"
      ],
      correctAnswer: 2
    },
    {
      id: 70393,
      question: "What is the recommended positioning for most medical emergencies in dental practice?",
      options: [
        "Keep patient in upright seated position always",
        "Have patient stand to improve circulation",
        "Position patient on their side exclusively",
        "Place patient supine with legs elevated"
      ],
      correctAnswer: 3
    },
    {
      id: 70394,
      question: "Which principle is fundamental to preventing medical emergencies?",
      options: [
        "Treat all patients identically regardless of medical history",
        "Avoid asking about medications to save time",
        "Know patient's medical history and prepare accordingly",
        "Schedule all high-risk patients at end of day"
      ],
      correctAnswer: 2
    },
    {
      id: 70395,
      question: "What role does proper training play in managing medical emergencies?",
      options: [
        "It is optional for dental hygienists with experience",
        "It is only required for dentists, not support staff",
        "It ensures quick recognition and appropriate response",
        "It eliminates the need for emergency equipment"
      ],
      correctAnswer: 2
    },
    {
      id: 70396,
      question: "How often should dental professionals practice emergency response protocols?",
      options: [
        "Once during initial training is sufficient for career",
        "Only when an actual emergency occurs",
        "Never, as written protocols are adequate",
        "Regularly through drills and continuing education"
      ],
      correctAnswer: 3
    },
    {
      id: 70397,
      question: "What is the significance of calling emergency medical services (EMS) promptly?",
      options: [
        "It is unnecessary if dental team manages emergency",
        "It should be delayed until all office interventions attempted",
        "It ensures professional help and transportation to hospital",
        "It is only needed for patients without medical insurance"
      ],
      correctAnswer: 2
    },
    {
      id: 70398,
      question: "Which documentation is essential after a medical emergency in the dental office?",
      options: [
        "Only financial billing information for the visit",
        "No documentation needed if patient recovers fully",
        "Detailed account of incident, interventions, and patient response",
        "Brief note stating \"emergency occurred\" without details"
      ],
      correctAnswer: 2
    },
    {
      id: 70399,
      question: "What is the purpose of informed consent regarding medical emergencies?",
      options: [
        "To eliminate all liability for dental practitioners",
        "To prevent patients from suing after emergencies occur",
        "To allow treatment without patient's knowledge",
        "To ensure patients understand risks and emergency protocols"
      ],
      correctAnswer: 3
    },
    {
      id: 70400,
      question: "How does effective communication help prevent medical emergencies?",
      options: [
        "It has no impact on emergency prevention strategies",
        "It only matters after an emergency has occurred",
        "It builds trust and helps identify patient concerns",
        "It should be minimized to reduce patient anxiety"
      ],
      correctAnswer: 2
    },
    {
      id: 70401,
      question: "What is the recommended approach when a patient discloses anxiety about dental treatment?",
      options: [
        "Dismiss concerns and proceed with treatment",
        "Require psychiatric clearance before any treatment",
        "Refuse to treat anxious patients entirely",
        "Acknowledge concerns and implement comfort measures"
      ],
      correctAnswer: 3
    },
    {
      id: 70402,
      question: "Which scenario would warrant postponing elective dental treatment?",
      options: [
        "Patient had breakfast two hours before appointment",
        "Patient asks questions about the planned procedure",
        "Patient arrives exactly on time for appointment",
        "Patient reports feeling unwell with flu-like symptoms"
      ],
      correctAnswer: 3
    },
    {
      id: 70403,
      question: "What is the importance of maintaining current CPR certification for dental professionals?",
      options: [
        "It is only required for dentists, not hygienists",
        "It is optional if emergency services are nearby",
        "It ensures competence in life-saving techniques",
        "It can be substituted with online video training"
      ],
      correctAnswer: 2
    },
    {
      id: 70404,
      question: "How should emergency medications be stored in the dental office?",
      options: [
        "In locked cabinets inaccessible during emergencies",
        "In multiple random locations throughout office",
        "Mixed with regular supplies without labeling",
        "In designated area that is easily accessible"
      ],
      correctAnswer: 3
    },
    {
      id: 70405,
      question: "What is the shelf life concern for emergency medications?",
      options: [
        "Emergency medications never expire and last indefinitely",
        "Expired medications work better than fresh ones",
        "They must be checked regularly and replaced before expiration",
        "Expiration dates are suggestions and can be ignored"
      ],
      correctAnswer: 2
    },
    {
      id: 70406,
      question: "Which member of the dental team should be trained in emergency response?",
      options: [
        "Only the dentist needs emergency training",
        "Only the receptionist who calls emergency services",
        "Training is not necessary with modern equipment",
        "All team members should be trained"
      ],
      correctAnswer: 3
    },
    {
      id: 70407,
      question: "What is the purpose of assigning specific emergency roles to team members?",
      options: [
        "To create confusion during actual emergencies",
        "To limit who can participate in emergency care",
        "To avoid having too many people helping patient",
        "To ensure organized, efficient response to emergencies"
      ],
      correctAnswer: 3
    },
    {
      id: 70408,
      question: "How can proper patient positioning during treatment prevent emergencies?",
      options: [
        "Position has no effect on emergency occurrence",
        "All patients should be treated while standing upright",
        "Appropriate positioning reduces risk of syncope and aspiration",
        "Supine position should be avoided for all patients"
      ],
      correctAnswer: 2
    },
    {
      id: 70409,
      question: "What is the recommended response when a patient's medical history indicates high risk?",
      options: [
        "Refuse to treat the patient in office setting",
        "Proceed with treatment without any modifications",
        "Require patient to sign liability waiver only",
        "Consult with patient's physician and take extra precautions"
      ],
      correctAnswer: 3
    },
    {
      id: 70410,
      question: "Which factor makes elderly patients more vulnerable to medical emergencies?",
      options: [
        "They have stronger immune systems than younger patients",
        "They experience fewer medication side effects",
        "They recover more quickly from medical emergencies",
        "They often have multiple chronic conditions and medications"
      ],
      correctAnswer: 3
    },
    {
      id: 70411,
      question: "What is the relationship between local anesthetic administration and medical emergencies?",
      options: [
        "Local anesthetics never cause any emergency situations",
        "All patients react identically to local anesthetics",
        "Improper technique or allergies can trigger emergencies",
        "Allergic reactions occur only with general anesthesia"
      ],
      correctAnswer: 2
    },
    {
      id: 70412,
      question: "How does maintaining a calm demeanor help during medical emergencies?",
      options: [
        "It has no effect on emergency outcomes",
        "It should be avoided in favor of showing urgency",
        "It only matters for minor emergencies, not major ones",
        "It reduces patient anxiety and helps team function effectively"
      ],
      correctAnswer: 3
    },
    {
      id: 70413,
      question: "What is the significance of knowing the location of emergency equipment?",
      options: [
        "Equipment location is irrelevant during emergencies",
        "Equipment should be stored in locked rooms always",
        "Quick access saves critical time during emergencies",
        "Only the dentist needs to know equipment locations"
      ],
      correctAnswer: 2
    },
    {
      id: 70414,
      question: "Which assessment should be performed immediately when a patient appears to be in distress?",
      options: [
        "Wait and observe for 10 minutes before assessing",
        "Complete full dental examination first before assessment",
        "Ask patient to leave and return another day",
        "Check airway, breathing, and circulation (ABCs)"
      ],
      correctAnswer: 3
    },
    {
      id: 70415,
      question: "What is the purpose of activating emergency medical services early in a crisis?",
      options: [
        "To increase costs and create unnecessary expenses",
        "To transfer all responsibility to paramedics immediately",
        "To avoid having to manage the emergency personally",
        "To ensure help arrives quickly if condition worsens"
      ],
      correctAnswer: 3
    },
    {
      id: 70416,
      question: "How should a dental professional respond if unsure about the severity of a patient's symptoms?",
      options: [
        "Assume symptoms are minor and continue treatment",
        "Ignore symptoms if patient doesn't complain loudly",
        "Ask patient to diagnose their own condition",
        "Err on side of caution and seek emergency help"
      ],
      correctAnswer: 3
    },
    {
      id: 70417,
      question: "What is the value of post-emergency debriefing with the dental team?",
      options: [
        "It serves no purpose and wastes valuable time",
        "It should only occur if the emergency had poor outcome",
        "It is only necessary for dentists, not other staff",
        "It identifies areas for improvement in emergency response"
      ],
      correctAnswer: 3
    },
    {
      id: 70418,
      question: "Which type of emergency requires immediate administration of epinephrine?",
      options: [
        "Severe anaphylactic reaction with systemic symptoms",
        "Simple syncope without allergic component",
        "Mild anxiety without physiological symptoms",
        "Orthostatic hypotension from standing too quickly"
      ],
      correctAnswer: 0
    },
    {
      id: 70419,
      question: "What is the recommended oxygen flow rate for most medical emergencies?",
      options: [
        "1-2 liters per minute for all emergencies",
        "Oxygen should never be given in dental emergencies",
        "10-15 liters per minute for all patients regardless",
        "4-6 liters per minute or higher depending on condition"
      ],
      correctAnswer: 3
    },
    {
      id: 70420,
      question: "How can monitoring vital signs help prevent medical emergencies?",
      options: [
        "Vital signs provide no useful information for prevention",
        "Vital signs should only be taken after emergencies happen",
        "Only blood pressure matters; other vitals are unnecessary",
        "Abnormal readings can alert to problems before emergencies occur"
      ],
      correctAnswer: 3
    },
    {
      id: 70421,
      question: "What is the significance of updating medical history at each appointment?",
      options: [
        "Medical history never changes once initially recorded",
        "Updates are only needed for new patients",
        "Annual updates are sufficient for all patients",
        "Conditions and medications can change over time"
      ],
      correctAnswer: 3
    },
    {
      id: 70422,
      question: "Which approach best describes prevention-focused dental care?",
      options: [
        "Treating emergencies only after they occur",
        "Avoiding treatment for patients with medical conditions",
        "Proactive identification of risks and preventive measures",
        "Relying solely on emergency equipment without preparation"
      ],
      correctAnswer: 2
    },
    {
      id: 70423,
      question: "What is the appropriate response when emergency equipment is found to be expired or malfunctioning?",
      options: [
        "Continue using it until replacement arrives next year",
        "Replace it immediately to ensure readiness",
        "Remove it and work without backup equipment",
        "Use it only for non-critical emergencies"
      ],
      correctAnswer: 1
    },
    {
      id: 70424,
      question: "How does patient education contribute to emergency prevention?",
      options: [
        "It has no impact on emergency occurrence rates",
        "It helps patients recognize and report concerning symptoms",
        "It should be avoided to prevent patient anxiety",
        "It is only necessary for high-risk patients"
      ],
      correctAnswer: 1
    },
    {
      id: 70425,
      question: "What is the recommended action when a patient reports taking anticoagulant medications?",
      options: [
        "Proceed with invasive procedures without modifications",
        "Refuse all dental treatment permanently",
        "Take extra precautions and consider consultation",
        "Ignore the medication history completely"
      ],
      correctAnswer: 2
    },
    {
      id: 70426,
      question: "Which factor indicates a patient may be at risk for a medical emergency?",
      options: [
        "Recent comprehensive dental cleaning without issues",
        "History of well-controlled chronic disease",
        "Unstable or poorly controlled medical conditions",
        "Young age with no family medical history"
      ],
      correctAnswer: 2
    },
    {
      id: 70427,
      question: "Medical emergencies in dental practice are extremely rare and unlikely to occur during a dental hygienist's career.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70428,
      question: "Syncope is the most common medical emergency encountered in dental practice.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70429,
      question: "Orthostatic hypotension occurs when blood pressure increases upon standing up.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70430,
      question: "Epinephrine is the first-line treatment for anaphylaxis.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70431,
      question: "Angina pectoris and myocardial infarction are the same condition.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70432,
      question: "The FAST acronym is used to identify signs of stroke.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70433,
      question: "Hypoglycemia refers to abnormally high blood sugar levels.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70434,
      question: "During an active seizure, objects should be placed in the patient's mouth to prevent tongue biting.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70435,
      question: "An Automated External Defibrillator (AED) should be available in every dental office.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "1. Introduction and prevention (Part 4-2)": [
    {
      id: 70436,
      question: "What should be monitored when a patient is taking omega-3 supplements?",
      options: [
        "Vital signs including blood pressure readings",
        "Blood glucose levels to check metabolic function",
        "Liver enzymes to assess organ function",
        "Oxygen saturation levels during treatment"
      ],
      correctAnswer: 0
    },
    {
      id: 70437,
      question: "For patients taking blood thinners like Eliquis or warfarin, what level should be checked before dental treatment?",
      options: [
        "Hemoglobin levels to assess anemia",
        "INR levels to assess bleeding risk",
        "Platelet count for clotting ability",
        "Blood glucose for metabolic status"
      ],
      correctAnswer: 1
    },
    {
      id: 70438,
      question: "What medication can help control profuse bleeding in patients on blood thinners?",
      options: [
        "Epinephrine to constrict blood vessels",
        "Aspirin to promote clot formation",
        "Hematin applied with cotton pliers",
        "Nitroglycerin to improve circulation"
      ],
      correctAnswer: 2
    },
    {
      id: 70439,
      question: "When is a medical consultation needed for a patient with anemia?",
      options: [
        "When anemia is well-controlled with medication",
        "When patient has normal hemoglobin levels",
        "When patient follows a vegetarian diet only",
        "When patient was diagnosed but stopped taking medication"
      ],
      correctAnswer: 3
    },
    {
      id: 70440,
      question: "If a patient without a history of hypertension has a blood pressure reading of 135/85, what should you do?",
      options: [
        "Retake the reading after 5 minutes",
        "Immediately call emergency services for treatment",
        "Proceed with treatment without any concerns",
        "Dismiss the patient and refuse treatment"
      ],
      correctAnswer: 0
    },
    {
      id: 70441,
      question: "What is white coat syndrome?",
      options: [
        "Allergic reaction to dental materials or latex",
        "Elevated blood pressure due to anxiety in medical settings",
        "Low blood pressure from standing up quickly",
        "Skin reaction to disinfectants or cleaning agents"
      ],
      correctAnswer: 1
    },
    {
      id: 70442,
      question: "For a patient with white coat syndrome showing elevated blood pressure, what should you do?",
      options: [
        "Refuse treatment and dismiss the patient immediately",
        "Proceed with treatment ignoring the readings",
        "Send medical consultation and possibly request physician's letter",
        "Administer blood pressure medication in the office"
      ],
      correctAnswer: 2
    },
    {
      id: 70443,
      question: "What three questions should you ask diabetic patients before dental treatment?",
      options: [
        "Diet preferences, medication type, insurance coverage",
        "What is A1C, family history, exercise routine",
        "Previous dental work, allergies, medical history",
        "When was last meal, last medication, blood sugar level"
      ],
      correctAnswer: 3
    },
    {
      id: 70444,
      question: "What should be available chairside for a diabetic patient experiencing hypoglycemia?",
      options: [
        "Glucose tablets or sugary drink",
        "Insulin injection to regulate blood sugar",
        "Protein bars for sustained energy",
        "Water to prevent dehydration only"
      ],
      correctAnswer: 0
    },
    {
      id: 70445,
      question: "If a patient has a delayed allergic reaction after leaving the clinic, what should you advise?",
      options: [
        "Wait 24 hours to see if symptoms resolve",
        "Take antihistamine and go to nearest walk-in clinic",
        "Return to dental office for treatment immediately",
        "Apply ice and monitor symptoms at home"
      ],
      correctAnswer: 1
    },
    {
      id: 70446,
      question: "When should asthmatic patients bring their inhalers to dental appointments?",
      options: [
        "Only if they've had an attack recently",
        "Only for surgical procedures requiring anesthesia",
        "Always, for every dental appointment",
        "Never, as the clinic has emergency inhalers"
      ],
      correctAnswer: 2
    },
    {
      id: 70447,
      question: "If an asthmatic patient didn't bring their inhaler, what questions should you ask?",
      options: [
        "Insurance coverage and payment method available",
        "Family history and genetic predisposition",
        "Dietary habits and exercise routine",
        "When was last episode and what triggered it"
      ],
      correctAnswer: 3
    },
    {
      id: 70448,
      question: "What should be documented if a patient previously fainted during dental treatment?",
      options: [
        "What happened and what triggered it",
        "Only the date of the incident",
        "Patient's current blood pressure only",
        "Names of staff present during incident"
      ],
      correctAnswer: 0
    },
    {
      id: 70449,
      question: "Which anti-anxiety option can be offered to anxious patients during dental treatment?",
      options: [
        "Oral sedatives prescribed by the hygienist",
        "Nitrous oxide if available in the practice",
        "Over-the-counter sleeping pills before appointment",
        "Muscle relaxants administered by dental assistant"
      ],
      correctAnswer: 1
    },
    {
      id: 70450,
      question: "What is the contraindication for using an EpiPen on a pregnant patient?",
      options: [
        "Permanent paralysis of lower extremities",
        "Immediate allergic reaction to epinephrine",
        "Possible premature labor or miscarriage",
        "Severe hypertension requiring hospitalization"
      ],
      correctAnswer: 2
    },
    {
      id: 70451,
      question: "What is the current guideline regarding lead aprons for dental radiographs?",
      options: [
        "Always required for all patients regardless",
        "Only required for pediatric patients exclusively",
        "Banned in all Canadian dental practices",
        "Some studies suggest they may not be necessary"
      ],
      correctAnswer: 3
    },
    {
      id: 70452,
      question: "When working with other hygienists with more experience, whose guidelines should you follow?",
      options: [
        "Your regulatory body (CDHO) standards",
        "The most experienced hygienist's personal preferences",
        "The dentist's individual practice protocols only",
        "Whatever the majority of staff agrees upon"
      ],
      correctAnswer: 0
    },
    {
      id: 70453,
      question: "What is the blood pressure threshold above which you should not proceed with treatment?",
      options: [
        "Anything above 120/80 requires immediate referral",
        "Approximately 170 systolic is generally considered too high",
        "Any reading above 100/60 is dangerous",
        "Only readings above 200/120 are concerning"
      ],
      correctAnswer: 1
    },
    {
      id: 70454,
      question: "If a patient on hypertension medication has very high blood pressure, what should you do?",
      options: [
        "Proceed with treatment and monitor closely",
        "Give the patient water and recheck immediately",
        "Stop treatment, refer to physician, wait for medication adjustment",
        "Continue as planned but avoid local anesthetic"
      ],
      correctAnswer: 2
    },
    {
      id: 70455,
      question: "When should a patient return after being referred for uncontrolled hypertension?",
      options: [
        "The next day after seeing physician",
        "Immediately after physician appointment",
        "After 6 months of medication compliance",
        "After at least 1-2 weeks on medication"
      ],
      correctAnswer: 3
    },
    {
      id: 70456,
      question: "What is the contraindication for nitroglycerin administration?",
      options: [
        "Sexual enhancement drugs taken within 24 hours",
        "Patient has eaten within 2 hours",
        "Patient is currently taking antibiotics",
        "Patient has diabetes or hypoglycemia"
      ],
      correctAnswer: 0
    },
    {
      id: 70457,
      question: "How many nitroglycerin sprays can be given for angina?",
      options: [
        "1 spray total regardless of response",
        "3 sprays with 5-minute intervals",
        "5 sprays with 2-minute intervals",
        "Unlimited until symptoms resolve completely"
      ],
      correctAnswer: 1
    },
    {
      id: 70458,
      question: "What is the shelf life of nitroglycerin after opening?",
      options: [
        "6 weeks from opening date",
        "24 weeks from opening date",
        "12 weeks from opening date",
        "Nitroglycerin never expires once opened"
      ],
      correctAnswer: 2
    },
    {
      id: 70459,
      question: "Can aspirin be given during a myocardial infarction (heart attack)?",
      options: [
        "No, aspirin is contraindicated completely",
        "Only if patient requests it",
        "Only if prescribed by cardiologist",
        "Yes, aspirin can be administered"
      ],
      correctAnswer: 3
    },
    {
      id: 70460,
      question: "What type of syncope occurs when a patient faints in the dental chair?",
      options: [
        "Vasodepressor syncope from anxiety or stress",
        "Cardiac syncope from heart failure",
        "Neurogenic syncope from brain damage",
        "Metabolic syncope from electrolyte imbalance"
      ],
      correctAnswer: 0
    },
    {
      id: 70461,
      question: "For patients with epilepsy, what should be provided during treatment?",
      options: [
        "Bright overhead lights for visibility",
        "Sunglasses to reduce light sensitivity",
        "Ear plugs to block noise",
        "Heavy blankets for comfort"
      ],
      correctAnswer: 1
    },
    {
      id: 70462,
      question: "Which dental procedures can trigger asthmatic episodes?",
      options: [
        "Taking medical history and vital signs",
        "Manual toothbrushing and flossing only",
        "Air polishing and aerosol-generating procedures",
        "Taking impressions with alginate material"
      ],
      correctAnswer: 2
    },
    {
      id: 70463,
      question: "What characterizes orthostatic hypotension?",
      options: [
        "Elevated blood pressure when lying down",
        "Consistently high blood pressure regardless of position",
        "Normal blood pressure with regular fluctuations",
        "Blood pressure drop from sudden position changes"
      ],
      correctAnswer: 3
    },
    {
      id: 70464,
      question: "Which patients are most at risk for orthostatic hypotension?",
      options: [
        "Elderly, pregnant, fasting, or hypertensive patients",
        "Young athletes with excellent cardiovascular health",
        "Children under 10 years old",
        "Middle-aged patients with no medical conditions"
      ],
      correctAnswer: 0
    },
    {
      id: 70465,
      question: "What is the proper technique to prevent orthostatic hypotension?",
      options: [
        "Raise chair quickly to save time",
        "Slowly raise chair and have patient sit before standing",
        "Keep patient supine for entire appointment",
        "Have patient stand immediately after treatment"
      ],
      correctAnswer: 1
    },
    {
      id: 70466,
      question: "For which condition should you NOT administer oxygen?",
      options: [
        "Syncope or fainting episode",
        "Asthmatic attack or bronchospasm",
        "Hyperventilation syndrome",
        "Orthostatic hypotension or dizziness"
      ],
      correctAnswer: 2
    },
    {
      id: 70467,
      question: "What is used to help a patient regain consciousness from syncope?",
      options: [
        "Cold water sprayed on face",
        "Smelling salts placed in mouth",
        "Epinephrine injection immediately",
        "Ammonia capsule broken near nose"
      ],
      correctAnswer: 3
    },
    {
      id: 70468,
      question: "How long should you wait before calling EMS if a patient remains unconscious?",
      options: [
        "Call after 15-20 minutes of unconsciousness",
        "Wait 30 minutes to see improvement",
        "Wait 1 hour before making decision",
        "Never call EMS for simple syncope"
      ],
      correctAnswer: 0
    },
    {
      id: 70469,
      question: "What does ABC stand for in emergency assessment?",
      options: [
        "Alert, Breathing, Consciousness levels",
        "Airway, Breathing, Circulation",
        "Assess, Blood pressure, Call EMS",
        "Anxiety, Baseline vitals, Consultation"
      ],
      correctAnswer: 1
    },
    {
      id: 70470,
      question: "When a patient has profuse bleeding that won't stop with pressure, what action should you take besides using hematin?",
      options: [
        "Continue applying pressure indefinitely",
        "Dismiss patient without further treatment",
        "Find out INR levels and monitor closely",
        "Apply ice packs to affected area"
      ],
      correctAnswer: 2
    },
    {
      id: 70471,
      question: "If someone reports bruising easily or prolonged bleeding, what might this indicate?",
      options: [
        "Normal variation in healing time",
        "Vitamin deficiency easily corrected",
        "Anxiety-related psychosomatic symptoms",
        "Bleeding issues requiring caution during procedures"
      ],
      correctAnswer: 3
    },
    {
      id: 70472,
      question: "What should you do if ammonia capsules are needed for a syncopal episode?",
      options: [
        "Break capsule near patient's nose for 10-15 seconds",
        "Place capsule directly in patient's mouth",
        "Wave capsule rapidly around patient's head",
        "Mix capsule contents with water"
      ],
      correctAnswer: 0
    },
    {
      id: 70473,
      question: "When working with diabetic patients, what should you document on their first visit?",
      options: [
        "Only current blood sugar reading",
        "When last blood work was done and A1C levels",
        "Family history of diabetes only",
        "Current weight and BMI measurements"
      ],
      correctAnswer: 1
    },
    {
      id: 70474,
      question: "If an asthmatic patient was hospitalized for asthma one week ago, what should you do?",
      options: [
        "Proceed with all treatment as planned",
        "Treat but avoid hand scaling only",
        "Dismiss patient and request medical consultation",
        "Continue with aerosol procedures cautiously"
      ],
      correctAnswer: 2
    },
    {
      id: 70475,
      question: "What questions should you ask about an asthmatic patient's hospitalization?",
      options: [
        "Insurance coverage and hospital name",
        "Length of hospital stay only",
        "Names of treating physicians",
        "Why hospitalized - severity or forgot inhaler"
      ],
      correctAnswer: 3
    },
    {
      id: 70476,
      question: "For asthmatic patients, which procedures should be avoided after a mild episode?",
      options: [
        "Aerosol procedures, polishing, and fluoride varnish",
        "All procedures must be postponed indefinitely",
        "Hand scaling and probing only",
        "Charting and medical history review"
      ],
      correctAnswer: 0
    },
    {
      id: 70477,
      question: "What position should an asthmatic patient be in during an attack?",
      options: [
        "Completely flat supine position",
        "Upright sitting position",
        "Side-lying position with legs elevated",
        "Prone position face down"
      ],
      correctAnswer: 1
    },
    {
      id: 70478,
      question: "When is epinephrine (EpiPen) appropriate for an asthmatic patient?",
      options: [
        "For all asthma attacks regardless of severity",
        "Never, as it's contraindicated for asthma",
        "When allergic reaction signs accompany asthma symptoms",
        "Only if patient specifically requests it"
      ],
      correctAnswer: 2
    },
    {
      id: 70479,
      question: "How many doses of albuterol can be given before calling EMS?",
      options: [
        "1 dose only then call immediately",
        "5 doses before considering EMS",
        "Unlimited doses until symptoms improve",
        "3 doses before escalating to emergency services"
      ],
      correctAnswer: 3
    },
    {
      id: 70480,
      question: "What is the difference between short-acting and long-acting asthma inhalers?",
      options: [
        "Short-acting works faster; long-acting takes longer",
        "Short-acting costs more than long-acting",
        "Short-acting lasts longer than long-acting",
        "There is no difference in mechanism"
      ],
      correctAnswer: 0
    },
    {
      id: 70481,
      question: "What should patients do with their asthma inhalers regarding dental appointments?",
      options: [
        "Leave inhalers at home to avoid contamination",
        "Always bring inhalers and ensure they're not expired",
        "Only bring inhalers if feeling symptoms",
        "Replace inhalers monthly regardless of expiration"
      ],
      correctAnswer: 1
    },
    {
      id: 70482,
      question: "If a patient has an expired inhaler at their appointment, what should you assess?",
      options: [
        "Proceed without any concerns or documentation",
        "Patient's insurance coverage for new inhaler",
        "When last used, what triggered episodes, seasonal patterns",
        "Brand and manufacturer of the inhaler"
      ],
      correctAnswer: 2
    },
    {
      id: 70483,
      question: "What should every clinic have available for asthmatic emergencies?",
      options: [
        "Only patient's personal inhaler",
        "Long-acting inhalers for prevention",
        "Oral corticosteroids for immediate use",
        "Albuterol (rescue inhaler) in emergency kit"
      ],
      correctAnswer: 3
    },
    {
      id: 70484,
      question: "Who can administer medication when a patient is conscious during an emergency?",
      options: [
        "Patient should self-administer; help bring it closer",
        "Only licensed physicians present",
        "Any dental team member can administer",
        "Only the dentist can give medication"
      ],
      correctAnswer: 0
    },
    {
      id: 70485,
      question: "What is the EpiPen dosage for adults versus children?",
      options: [
        "0.15 for adults, 0.3 for children",
        "0.3 for adults, 0.15 for children",
        "0.5 for adults, 0.25 for children",
        "Same dose of 0.2 for everyone"
      ],
      correctAnswer: 1
    },
    {
      id: 70486,
      question: "What phrase helps remember EpiPen administration technique?",
      options: [
        "\"Red to the head, blue to you\"",
        "\"Orange up, blue down to ground\"",
        "\"Blue to the sky, orange to the thigh\"",
        "\"Blue to leg, orange to head\""
      ],
      correctAnswer: 2
    },
    {
      id: 70487,
      question: "During a seizure, what should you do with instruments and sharp objects?",
      options: [
        "Leave everything in place for quick access",
        "Hand instruments to the patient",
        "Place instruments closer for emergency use",
        "Move away all sharps and instrument trays"
      ],
      correctAnswer: 3
    },
    {
      id: 70488,
      question: "When should you gently hold a patient having a seizure?",
      options: [
        "If they're moving violently and could injure themselves",
        "Never touch a patient during seizure",
        "Always restrain patient throughout seizure",
        "Only if patient specifically requested it beforehand"
      ],
      correctAnswer: 0
    },
    {
      id: 70489,
      question: "What should be monitored when administering oxygen to a patient?",
      options: [
        "Room temperature and humidity levels",
        "Pulse using pulse oximeter",
        "Blood glucose levels continuously",
        "Dental chair position only"
      ],
      correctAnswer: 1
    },
    {
      id: 70490,
      question: "When should you take blood pressure readings for patients with white coat syndrome?",
      options: [
        "Only once at the beginning",
        "Every 5 minutes throughout appointment",
        "Before and after the appointment",
        "Never, as readings will be inaccurate"
      ],
      correctAnswer: 2
    },
    {
      id: 70491,
      question: "What makes you an autonomous, self-regulating professional in dental hygiene?",
      options: [
        "Years of experience working in practice",
        "Approval from the dentist for decisions",
        "Following senior hygienists' personal preferences",
        "Ability to make independent clinical decisions following regulations"
      ],
      correctAnswer: 3
    },
    {
      id: 70492,
      question: "Why is it important to have a witness when a patient goes unconscious?",
      options: [
        "To protect against potential legal issues or accusations",
        "To help with treatment procedures",
        "To call the patient's family members",
        "To operate emergency equipment properly"
      ],
      correctAnswer: 0
    },
    {
      id: 70493,
      question: "What should you do the day after a patient had a medical emergency in your chair?",
      options: [
        "Wait for patient to contact you",
        "Follow up to check if patient is okay",
        "Send a bill for services rendered",
        "Report incident to dental association"
      ],
      correctAnswer: 1
    },
    {
      id: 70494,
      question: "What should you do if cotton rolls or dry angles get stuck to tissue?",
      options: [
        "Pull forcefully to remove quickly",
        "Leave them attached permanently",
        "Moisten with water or saliva to soften",
        "Cut tissue to release material"
      ],
      correctAnswer: 2
    },
    {
      id: 70495,
      question: "Why can't you use wet cotton rolls during fluoride application?",
      options: [
        "They improve fluoride absorption",
        "Wet cotton is more comfortable",
        "Water enhances fluoride effectiveness",
        "They will remove the fluoride"
      ],
      correctAnswer: 3
    },
    {
      id: 70496,
      question: "What is the purpose of making a cup with hands during hyperventilation?",
      options: [
        "To help patient rebreathe own CO2 and calm down",
        "To collect exhaled carbon dioxide",
        "To catch vomit if patient nauseated",
        "To measure respiratory rate accurately"
      ],
      correctAnswer: 0
    },
    {
      id: 70497,
      question: "What does ASA classification system assess?",
      options: [
        "Allergy severity and anaphylaxis risk",
        "Patient's medical status and difficulty level",
        "Anxiety levels before dental procedures",
        "Ability to pay for dental treatment"
      ],
      correctAnswer: 1
    },
    {
      id: 70498,
      question: "What characterizes an ASA 1 patient?",
      options: [
        "Multiple chronic medical conditions requiring management",
        "Severe systemic disease affecting daily life",
        "Normal healthy patient free of medical conditions",
        "Patient requiring hospitalization for dental care"
      ],
      correctAnswer: 2
    },
    {
      id: 70499,
      question: "What characterizes an ASA 2 patient?",
      options: [
        "Severe uncontrolled medical conditions",
        "Incapacitating disease threatening life",
        "Normal healthy patient with no conditions",
        "Mild systemic disease that is controlled"
      ],
      correctAnswer: 3
    },
    {
      id: 70500,
      question: "What characterizes an ASA 3 patient?",
      options: [
        "Normal healthy patient needing routine care",
        "Patient in constant threat to life",
        "Brain dead patient declared deceased",
        "Severe systemic disease that is poorly controlled"
      ],
      correctAnswer: 3
    },
    {
      id: 70501,
      question: "For ASA 3 patients, what type of review is needed?",
      options: [
        "No review necessary for treatment",
        "Automatic denial of all dental treatment",
        "Case-by-case review with possible medical consultation",
        "Emergency hospitalization before any care"
      ],
      correctAnswer: 2
    },
    {
      id: 70502,
      question: "What treatment modifications might ASA 3 patients require?",
      options: [
        "No modifications needed for treatment",
        "Treatment only in hospital setting",
        "Referral to specialist for all care",
        "Prophylactic antibiotics, sedation, shorter appointments"
      ],
      correctAnswer: 3
    },
    {
      id: 70503,
      question: "What characterizes an ASA 4 patient?",
      options: [
        "Incapacitating systemic disease threatening life",
        "Mild medical conditions well-controlled",
        "Normal patient with dental anxiety",
        "Healthy patient requiring routine care"
      ],
      correctAnswer: 0
    },
    {
      id: 70504,
      question: "For ASA 4 patients, what type of treatment is recommended?",
      options: [
        "All invasive procedures in office setting",
        "Non-invasive treatment only; hospital for emergency care",
        "Treatment without any special precautions",
        "Refuse all treatment permanently"
      ],
      correctAnswer: 1
    },
    {
      id: 70505,
      question: "In private practice, which ASA classifications will you most commonly see?",
      options: [
        "ASA 5 and ASA 6 only",
        "Only ASA 4 patients",
        "ASA 1, ASA 2, and ASA 3",
        "ASA E emergency cases exclusively"
      ],
      correctAnswer: 2
    },
    {
      id: 70506,
      question: "What does hyperglycemia mean?",
      options: [
        "Blood sugar level is too low",
        "Normal blood sugar fluctuation",
        "Absence of glucose in blood",
        "Blood sugar level is too high"
      ],
      correctAnswer: 3
    },
    {
      id: 70507,
      question: "What does hypoglycemia mean?",
      options: [
        "Blood sugar level is too low",
        "Blood sugar level is too high",
        "Stable blood sugar levels",
        "Glucose intolerance condition"
      ],
      correctAnswer: 0
    },
    {
      id: 70508,
      question: "What is the treatment for hypoglycemia in a conscious patient?",
      options: [
        "Insulin injection immediately",
        "Glucose or sugar drinks (liquid preferred)",
        "Water and rest only",
        "Protein-rich solid foods"
      ],
      correctAnswer: 1
    },
    {
      id: 70509,
      question: "Why are liquid sugar sources preferred for hypoglycemia?",
      options: [
        "They taste better than solid forms",
        "They are cheaper than other options",
        "They work faster and require less energy to absorb",
        "They last longer in emergency kits"
      ],
      correctAnswer: 2
    },
    {
      id: 70510,
      question: "Which instrument has a proper administration technique of \"blue to the sky, orange to the thigh\"?",
      options: [
        "Nitroglycerin spray for angina",
        "Albuterol inhaler for asthma",
        "Glucose meter for diabetes",
        "EpiPen auto-injector for anaphylaxis"
      ],
      correctAnswer: 3
    },
    {
      id: 70511,
      question: "What should you always have in your emergency kit for asthmatic patients?",
      options: [
        "Albuterol rescue inhaler",
        "Long-acting preventive inhalers",
        "Oral corticosteroid tablets",
        "Nebulizer machine for aerosol delivery"
      ],
      correctAnswer: 0
    },
    {
      id: 70512,
      question: "When administering nitroglycerin for angina, what is the maximum number of doses?",
      options: [
        "1 dose then call EMS immediately",
        "3 doses with 5-minute intervals between",
        "5 doses within 10 minutes",
        "Unlimited until pain subsides"
      ],
      correctAnswer: 1
    },
    {
      id: 70513,
      question: "What is the primary concern when a pregnant patient needs an EpiPen?",
      options: [
        "Allergic reaction to epinephrine itself",
        "Permanent damage to cardiovascular system",
        "Possible premature labor or miscarriage",
        "Immediate hypertensive crisis requiring hospitalization"
      ],
      correctAnswer: 2
    },
    {
      id: 70514,
      question: "If a patient's blood pressure is 145/90 and they report white coat syndrome, what should you do?",
      options: [
        "Dismiss patient immediately without treatment",
        "Proceed with treatment without concerns",
        "Request physician's letter and send consultation",
        "Administer antihypertensive medication"
      ],
      correctAnswer: 2
    },
    {
      id: 70515,
      question: "Which medication should NOT be administered during hyperventilation syndrome?",
      options: [
        "Glucose for energy",
        "Aspirin for pain",
        "Nitroglycerin for chest pain",
        "Oxygen therapy"
      ],
      correctAnswer: 3
    },
    {
      id: 70516,
      question: "What is the correct phrase for remembering how to check ABCs during an emergency?",
      options: [
        "Airway, Breathing, Circulation",
        "Alert, Blood pressure, Consciousness",
        "Assess, Breathing, Call for help",
        "Anxiety, Baseline vitals, Consult physician"
      ],
      correctAnswer: 0
    },
    {
      id: 70517,
      question: "When should CPR certification be refreshed according to CDHO guidelines?",
      options: [
        "Every 2 years matching certification expiry",
        "Every year regardless of certification expiry",
        "Every 5 years with full recertification",
        "Only when certification officially expires"
      ],
      correctAnswer: 1
    },
    {
      id: 70518,
      question: "What position should a patient be in when experiencing orthostatic hypotension?",
      options: [
        "Standing upright to improve circulation",
        "Supine with feet slightly elevated",
        "Sitting upright at 90 degrees",
        "Side-lying to prevent aspiration"
      ],
      correctAnswer: 1
    },
    {
      id: 70519,
      question: "What is the first step when a patient experiences profuse bleeding on anticoagulants?",
      options: [
        "Call EMS immediately",
        "Apply hematin and pressure",
        "Check INR levels",
        "Administer vitamin K"
      ],
      correctAnswer: 1
    },
    {
      id: 70520,
      question: "Patients taking omega-3 supplements should have their vital signs monitored even without hypertension.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70521,
      question: "Baby aspirin requires INR level monitoring before dental procedures.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70522,
      question: "Hematin can be used to control profuse bleeding in patients on blood thinners.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70523,
      question: "White coat syndrome refers to anxiety-related elevated blood pressure in medical settings.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70524,
      question: "For diabetic patients, you should ask about their last meal, last medication, and blood sugar level.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70525,
      question: "Lead aprons are absolutely required for all dental radiographs according to current studies.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70526,
      question: "Experienced hygienists' personal practices should take precedence over CDHO guidelines.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70527,
      question: "Nitroglycerin should not be given if the patient took sexual enhancement drugs within 24 hours.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70528,
      question: "You can give unlimited nitroglycerin sprays until angina symptoms resolve.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70529,
      question: "Ammonia capsules are broken near the patient's nose to help regain consciousness from syncope.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70530,
      question: "Oxygen should be administered to patients experiencing hyperventilation syndrome.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70531,
      question: "Asthmatic patients should always bring their inhalers to dental appointments.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70532,
      question: "Air polishing and aerosol-generating procedures can trigger asthmatic episodes.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70533,
      question: "An ASA 1 patient is a normal healthy person free of medical conditions.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70534,
      question: "ASA 3 patients always require hospitalization for any dental treatment.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70535,
      question: "The EpiPen dosage is 0.3 for adults and 0.15 for children.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70536,
      question: "During a seizure, you should place objects in the patient's mouth to prevent tongue biting.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70537,
      question: "Liquid sugar sources work faster than solid foods for treating hypoglycemia.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],    
  "1. Introduction and prevention (Part 3-2)": [
    {
      id: 70538,
      question: "What is the primary purpose of studying medical emergencies in dental hygiene practice?",
      options: [
        "To replace the need for emergency medical services",
        "To diagnose complex medical conditions independently",
        "To recognize, prevent, and manage life-threatening situations",
        "To perform advanced cardiac life support procedures"
      ],
      correctAnswer: 2
    },
    {
      id: 70539,
      question: "Which of the following is NOT one of the three main objectives of learning medical emergencies?",
      options: [
        "Recognition of medical emergencies",
        "Management of medical emergencies",
        "Prevention of medical emergencies",
        "Prescription of emergency medications"
      ],
      correctAnswer: 3
    },
    {
      id: 70540,
      question: "What percentage of dental practitioners will likely face a medical emergency during their career?",
      options: [
        "Approximately 90% will experience emergencies",
        "Approximately 50% will experience emergencies",
        "Approximately 25% will experience emergencies",
        "Approximately 75% will experience emergencies"
      ],
      correctAnswer: 0
    },
    {
      id: 70541,
      question: "Which factor has contributed to the increased likelihood of medical emergencies in dental settings?",
      options: [
        "Reduced number of patients seeking dental care",
        "Aging population with multiple medical conditions",
        "Decreased use of local anesthetics in procedures",
        "Simplified dental procedures requiring less time"
      ],
      correctAnswer: 1
    },
    {
      id: 70542,
      question: "What is the most common medical emergency in dental practice?",
      options: [
        "Cardiac arrest requiring immediate defibrillation",
        "Severe allergic reactions to medications",
        "Syncope, also known as fainting",
        "Respiratory failure due to airway obstruction"
      ],
      correctAnswer: 2
    },
    {
      id: 70543,
      question: "Which of the following best describes syncope?",
      options: [
        "Prolonged confusion without loss of consciousness",
        "Temporary loss of consciousness with spontaneous recovery",
        "Permanent loss of consciousness requiring hospitalization",
        "Loss of motor function without consciousness changes"
      ],
      correctAnswer: 1
    },
    {
      id: 70544,
      question: "What is the primary cause of vasovagal syncope?",
      options: [
        "Sudden drop in blood pressure and heart rate",
        "Acute myocardial infarction with cardiac dysfunction",
        "Severe dehydration leading to circulatory collapse",
        "Cerebrovascular accident affecting consciousness centers"
      ],
      correctAnswer: 0
    },
    {
      id: 70545,
      question: "Which sign or symptom typically precedes a syncopal episode?",
      options: [
        "Severe headache with visual disturbances",
        "Sudden chest pain radiating to the arm",
        "Dizziness, nausea, or feeling warm",
        "Difficulty breathing with audible wheezing"
      ],
      correctAnswer: 2
    },
    {
      id: 70546,
      question: "What is the recommended immediate management for a patient experiencing syncope?",
      options: [
        "Begin chest compressions to restore circulation",
        "Keep patient upright to maintain blood pressure",
        "Administer oxygen at high flow rates immediately",
        "Position patient supine with legs elevated"
      ],
      correctAnswer: 3
    },
    {
      id: 70547,
      question: "How can dental professionals help prevent syncope during treatment?",
      options: [
        "Ensure patients are comfortable and reduce anxiety",
        "Administer sedatives to all anxious patients routinely",
        "Perform all procedures with patient standing upright",
        "Avoid using local anesthetics that may cause reactions"
      ],
      correctAnswer: 0
    },
    {
      id: 70548,
      question: "What characterizes orthostatic hypotension?",
      options: [
        "Consistently high blood pressure regardless of position",
        "Blood pressure drop upon standing from sitting",
        "Elevated blood pressure when lying down flat",
        "Irregular blood pressure fluctuations during exercise"
      ],
      correctAnswer: 1
    },
    {
      id: 70549,
      question: "Which patient population is at highest risk for orthostatic hypotension?",
      options: [
        "Young adults with no medical history",
        "Middle-aged patients with excellent health",
        "Elderly patients taking multiple medications",
        "Children undergoing routine dental examinations"
      ],
      correctAnswer: 2
    },
    {
      id: 70550,
      question: "What is the recommended prevention strategy for orthostatic hypotension in dental practice?",
      options: [
        "Keep patients in supine position indefinitely",
        "Encourage vigorous movement immediately after treatment",
        "Have patients stand quickly after procedures",
        "Allow patients to sit up slowly before standing"
      ],
      correctAnswer: 3
    },
    {
      id: 70551,
      question: "Which condition involves a severe, life-threatening allergic reaction?",
      options: [
        "Anaphylaxis with systemic multi-organ involvement",
        "Mild urticaria with localized skin involvement",
        "Contact dermatitis affecting only exposed areas",
        "Delayed hypersensitivity occurring days after exposure"
      ],
      correctAnswer: 0
    },
    {
      id: 70552,
      question: "What is the first-line medication for treating anaphylaxis?",
      options: [
        "Bronchodilators to open constricted airways",
        "Epinephrine administered via intramuscular injection",
        "Antihistamines to block histamine receptors",
        "Corticosteroids to reduce long-term inflammation"
      ],
      correctAnswer: 1
    },
    {
      id: 70553,
      question: "Which symptom is most indicative of anaphylaxis rather than a mild allergic reaction?",
      options: [
        "Mild rash on arms without other symptoms",
        "Localized itching at the injection site only",
        "Difficulty breathing with throat swelling",
        "Slight nausea without respiratory involvement"
      ],
      correctAnswer: 2
    },
    {
      id: 70554,
      question: "How can dental professionals prevent anaphylactic reactions?",
      options: [
        "Administer antibiotics prophylactically to all patients",
        "Avoid asking about patient medication allergies",
        "Use the same materials for all patients uniformly",
        "Obtain thorough medical and allergy history"
      ],
      correctAnswer: 3
    },
    {
      id: 70555,
      question: "What characterizes angina pectoris?",
      options: [
        "Chest pain due to temporary inadequate oxygen supply",
        "Permanent heart muscle damage with tissue death",
        "Complete blockage of coronary arteries requiring surgery",
        "Inflammation of the heart lining causing discomfort"
      ],
      correctAnswer: 0
    },
    {
      id: 70556,
      question: "Which medication is typically used to manage an angina attack?",
      options: [
        "Aspirin to thin blood and prevent clotting",
        "Nitroglycerin to dilate blood vessels",
        "Beta-blockers to slow heart rate permanently",
        "Calcium channel blockers for long-term control"
      ],
      correctAnswer: 1
    },
    {
      id: 70557,
      question: "What distinguishes myocardial infarction from angina?",
      options: [
        "MI involves actual heart tissue death while angina doesn't",
        "MI causes temporary pain while angina is permanent",
        "MI resolves with rest while angina requires medication",
        "MI occurs only during exercise while angina occurs at rest"
      ],
      correctAnswer: 0
    },
    {
      id: 70558,
      question: "Which sign is characteristic of a myocardial infarction?",
      options: [
        "Intermittent pain occurring only during physical activity",
        "Brief chest discomfort relieved by rest",
        "Severe crushing chest pain lasting over 20 minutes",
        "Mild discomfort that resolves with nitroglycerin"
      ],
      correctAnswer: 2
    },
    {
      id: 70559,
      question: "What is the appropriate emergency response for suspected myocardial infarction?",
      options: [
        "Allow patient to rest and reassess in 30 minutes",
        "Transport patient to hospital in personal vehicle",
        "Continue dental treatment after giving nitroglycerin",
        "Call emergency services immediately and administer aspirin"
      ],
      correctAnswer: 3
    },
    {
      id: 70560,
      question: "Which factor increases the risk of cardiac emergencies during dental treatment?",
      options: [
        "History of heart disease and high stress levels",
        "Young age with no cardiovascular risk factors",
        "Regular exercise and healthy lifestyle habits",
        "Normal blood pressure and cholesterol levels"
      ],
      correctAnswer: 0
    },
    {
      id: 70561,
      question: "What is hypoglycemia?",
      options: [
        "Chronic elevation of blood glucose over time",
        "Abnormally low blood sugar causing symptoms",
        "Abnormally high blood sugar requiring insulin",
        "Normal blood sugar fluctuation during meals"
      ],
      correctAnswer: 1
    },
    {
      id: 70562,
      question: "Which symptom is commonly associated with hypoglycemia?",
      options: [
        "Excessive thirst and frequent urination",
        "Dry mouth with decreased perspiration",
        "Confusion, sweating, and shakiness",
        "Slow onset of symptoms over several days"
      ],
      correctAnswer: 2
    },
    {
      id: 70563,
      question: "What is the immediate treatment for conscious hypoglycemic patients?",
      options: [
        "Give glucose tablets or sugary drink",
        "Administer insulin to regulate blood sugar",
        "Provide protein-rich foods for sustained energy",
        "Encourage exercise to metabolize excess sugar"
      ],
      correctAnswer: 0
    },
    {
      id: 70564,
      question: "How can dental professionals prevent hypoglycemic episodes?",
      options: [
        "Require all diabetic patients to fast before treatment",
        "Schedule appointments immediately after patients have eaten",
        "Prohibit diabetic patients from bringing glucose sources",
        "Avoid scheduling appointments during typical meal times"
      ],
      correctAnswer: 1
    },
    {
      id: 70565,
      question: "What characterizes a cerebrovascular accident (stroke)?",
      options: [
        "Temporary disruption of brain function with full recovery",
        "Minor brain dysfunction without lasting consequences",
        "Interruption of blood flow to brain causing cell death",
        "Reversible brain injury with immediate resolution"
      ],
      correctAnswer: 2
    },
    {
      id: 70566,
      question: "Which acronym helps identify stroke symptoms?",
      options: [
        "SAMPLE for gathering patient history information",
        "RICE for rest, ice, compression, elevation",
        "AVPU for assessing level of consciousness",
        "FAST for face, arm, speech, time"
      ],
      correctAnswer: 3
    },
    {
      id: 70567,
      question: "What does the \"F\" in FAST stand for when assessing stroke?",
      options: [
        "Face drooping on one side",
        "Fever indicating possible infection complications",
        "Fingers showing decreased sensation bilaterally",
        "Feet demonstrating weakness in both lower extremities"
      ],
      correctAnswer: 0
    },
    {
      id: 70568,
      question: "What is the critical time window for stroke treatment to be most effective?",
      options: [
        "Within the first 30 minutes of symptom onset",
        "Within the first 12 hours of symptom onset",
        "Within the first 3 hours of symptom onset",
        "Within the first 24 hours of symptom onset"
      ],
      correctAnswer: 2
    },
    {
      id: 70569,
      question: "Which breathing emergency involves narrowing of the airways?",
      options: [
        "Pulmonary embolism blocking blood vessels",
        "Asthma causing bronchial constriction",
        "Pneumonia affecting alveolar gas exchange",
        "Pleural effusion compressing lung tissue"
      ],
      correctAnswer: 1
    },
    {
      id: 70570,
      question: "What medication do asthmatic patients typically carry for acute attacks?",
      options: [
        "Rescue inhaler with bronchodilator medication",
        "Oral corticosteroids for long-term control",
        "Antihistamines to reduce allergic response",
        "Antibiotics to prevent respiratory infections"
      ],
      correctAnswer: 0
    },
    {
      id: 70571,
      question: "What is the primary management strategy for choking (foreign body airway obstruction)?",
      options: [
        "Place patient supine and monitor breathing",
        "Perform abdominal thrusts (Heimlich maneuver)",
        "Encourage patient to continue coughing forcefully",
        "Immediately begin rescue breathing with ventilations"
      ],
      correctAnswer: 1
    },
    {
      id: 70572,
      question: "How can dental professionals prevent choking during procedures?",
      options: [
        "Work without suction to avoid tissue trauma",
        "Allow patients to talk continuously during treatment",
        "Use rubber dam isolation and maintain suction",
        "Position patients completely upright at all times"
      ],
      correctAnswer: 2
    },
    {
      id: 70573,
      question: "Which seizure type involves loss of consciousness with convulsions?",
      options: [
        "Generalized tonic-clonic seizures with full-body involvement",
        "Absence seizures with brief consciousness lapses",
        "Focal seizures affecting only specific body areas",
        "Myoclonic seizures with brief muscle jerks"
      ],
      correctAnswer: 0
    },
    {
      id: 70574,
      question: "What is the appropriate management during an active seizure?",
      options: [
        "Administer anticonvulsant medications immediately during seizure",
        "Protect patient from injury and time the seizure",
        "Restrain patient movements to prevent injury",
        "Place objects in mouth to prevent tongue biting"
      ],
      correctAnswer: 1
    },
    {
      id: 70575,
      question: "When should emergency services be called for a seizure?",
      options: [
        "Only if the patient has never had seizures before",
        "Only if the patient stops breathing permanently",
        "If seizure lasts longer than 5 minutes",
        "Immediately when any seizure begins regardless of duration"
      ],
      correctAnswer: 2
    },
    {
      id: 70576,
      question: "Which emergency involves severe hyperventilation causing respiratory alkalosis?",
      options: [
        "Asthma attack with bronchial obstruction",
        "Chronic obstructive pulmonary disease exacerbation",
        "Pulmonary embolism blocking circulation",
        "Hyperventilation syndrome due to anxiety"
      ],
      correctAnswer: 3
    },
    {
      id: 70577,
      question: "What is the recommended treatment for hyperventilation syndrome?",
      options: [
        "Administer high-flow oxygen through non-rebreather mask",
        "Have patient breathe into paper bag immediately",
        "Provide bronchodilator medication via nebulizer",
        "Calm patient and encourage slow breathing"
      ],
      correctAnswer: 3
    },
    {
      id: 70578,
      question: "What should be included in a dental office emergency kit?",
      options: [
        "Oxygen, AED, epinephrine, and emergency medications",
        "Only basic first aid supplies like bandages",
        "Advanced surgical instruments for emergency procedures",
        "Prescription medications for long-term chronic conditions"
      ],
      correctAnswer: 0
    },
    {
      id: 70579,
      question: "Why is an Automated External Defibrillator (AED) important in dental offices?",
      options: [
        "It provides oxygen to patients experiencing breathing difficulties",
        "It administers emergency medications automatically to patients",
        "It can restore normal heart rhythm during cardiac arrest",
        "It measures blood pressure during emergency situations"
      ],
      correctAnswer: 2
    },
    {
      id: 70580,
      question: "What is the purpose of obtaining a thorough medical history before dental treatment?",
      options: [
        "To delay treatment until all conditions are resolved",
        "To identify potential risk factors for medical emergencies",
        "To avoid treating patients with any medical conditions",
        "To determine insurance coverage for dental procedures"
      ],
      correctAnswer: 1
    },
    {
      id: 70581,
      question: "Which vital sign should be routinely monitored before and during dental procedures?",
      options: [
        "Body temperature to detect infections early",
        "Pupil response to assess neurological function",
        "Blood pressure to identify cardiovascular concerns",
        "Respiratory rate exclusively for all patients"
      ],
      correctAnswer: 2
    },
    {
      id: 70582,
      question: "How can stress and anxiety contribute to medical emergencies in dental settings?",
      options: [
        "They have no effect on medical emergency occurrence",
        "They only affect patients with no medical history",
        "They can trigger conditions like syncope and hyperventilation",
        "They prevent emergencies by increasing patient alertness"
      ],
      correctAnswer: 2
    },
    {
      id: 70583,
      question: "What is the recommended positioning for most medical emergencies in dental practice?",
      options: [
        "Keep patient in upright seated position always",
        "Have patient stand to improve circulation",
        "Position patient on their side exclusively",
        "Place patient supine with legs elevated"
      ],
      correctAnswer: 3
    },
    {
      id: 70584,
      question: "Which principle is fundamental to preventing medical emergencies?",
      options: [
        "Treat all patients identically regardless of medical history",
        "Avoid asking about medications to save time",
        "Know patient's medical history and prepare accordingly",
        "Schedule all high-risk patients at end of day"
      ],
      correctAnswer: 2
    },
    {
      id: 70585,
      question: "What role does proper training play in managing medical emergencies?",
      options: [
        "It is optional for dental hygienists with experience",
        "It is only required for dentists, not support staff",
        "It ensures quick recognition and appropriate response",
        "It eliminates the need for emergency equipment"
      ],
      correctAnswer: 2
    },
    {
      id: 70586,
      question: "How often should dental professionals practice emergency response protocols?",
      options: [
        "Once during initial training is sufficient for career",
        "Only when an actual emergency occurs",
        "Never, as written protocols are adequate",
        "Regularly through drills and continuing education"
      ],
      correctAnswer: 3
    },
    {
      id: 70587,
      question: "What is the significance of calling emergency medical services (EMS) promptly?",
      options: [
        "It is unnecessary if dental team manages emergency",
        "It should be delayed until all office interventions attempted",
        "It ensures professional help and transportation to hospital",
        "It is only needed for patients without medical insurance"
      ],
      correctAnswer: 2
    },
    {
      id: 70588,
      question: "Which documentation is essential after a medical emergency in the dental office?",
      options: [
        "Only financial billing information for the visit",
        "No documentation needed if patient recovers fully",
        "Detailed account of incident, interventions, and patient response",
        "Brief note stating \"emergency occurred\" without details"
      ],
      correctAnswer: 2
    },
    {
      id: 70589,
      question: "What is the purpose of informed consent regarding medical emergencies?",
      options: [
        "To eliminate all liability for dental practitioners",
        "To prevent patients from suing after emergencies occur",
        "To allow treatment without patient's knowledge",
        "To ensure patients understand risks and emergency protocols"
      ],
      correctAnswer: 3
    },
    {
      id: 70590,
      question: "How does effective communication help prevent medical emergencies?",
      options: [
        "It has no impact on emergency prevention strategies",
        "It only matters after an emergency has occurred",
        "It builds trust and helps identify patient concerns",
        "It should be minimized to reduce patient anxiety"
      ],
      correctAnswer: 2
    },
    {
      id: 70591,
      question: "What is the recommended approach when a patient discloses anxiety about dental treatment?",
      options: [
        "Dismiss concerns and proceed with treatment",
        "Require psychiatric clearance before any treatment",
        "Refuse to treat anxious patients entirely",
        "Acknowledge concerns and implement comfort measures"
      ],
      correctAnswer: 3
    },
    {
      id: 70592,
      question: "Which scenario would warrant postponing elective dental treatment?",
      options: [
        "Patient had breakfast two hours before appointment",
        "Patient asks questions about the planned procedure",
        "Patient arrives exactly on time for appointment",
        "Patient reports feeling unwell with flu-like symptoms"
      ],
      correctAnswer: 3
    },
    {
      id: 70593,
      question: "What is the importance of maintaining current CPR certification for dental professionals?",
      options: [
        "It is only required for dentists, not hygienists",
        "It is optional if emergency services are nearby",
        "It ensures competence in life-saving techniques",
        "It can be substituted with online video training"
      ],
      correctAnswer: 2
    },
    {
      id: 70594,
      question: "How should emergency medications be stored in the dental office?",
      options: [
        "In locked cabinets inaccessible during emergencies",
        "In multiple random locations throughout office",
        "Mixed with regular supplies without labeling",
        "In designated area that is easily accessible"
      ],
      correctAnswer: 3
    },
    {
      id: 70595,
      question: "What is the shelf life concern for emergency medications?",
      options: [
        "Emergency medications never expire and last indefinitely",
        "Expired medications work better than fresh ones",
        "They must be checked regularly and replaced before expiration",
        "Expiration dates are suggestions and can be ignored"
      ],
      correctAnswer: 2
    },
    {
      id: 70596,
      question: "Which member of the dental team should be trained in emergency response?",
      options: [
        "Only the dentist needs emergency training",
        "Only the receptionist who calls emergency services",
        "Training is not necessary with modern equipment",
        "All team members should be trained"
      ],
      correctAnswer: 3
    },
    {
      id: 70597,
      question: "What is the purpose of assigning specific emergency roles to team members?",
      options: [
        "To create confusion during actual emergencies",
        "To limit who can participate in emergency care",
        "To avoid having too many people helping patient",
        "To ensure organized, efficient response to emergencies"
      ],
      correctAnswer: 3
    },
    {
      id: 70598,
      question: "How can proper patient positioning during treatment prevent emergencies?",
      options: [
        "Position has no effect on emergency occurrence",
        "All patients should be treated while standing upright",
        "Appropriate positioning reduces risk of syncope and aspiration",
        "Supine position should be avoided for all patients"
      ],
      correctAnswer: 2
    },
    {
      id: 70599,
      question: "What is the recommended response when a patient's medical history indicates high risk?",
      options: [
        "Refuse to treat the patient in office setting",
        "Proceed with treatment without any modifications",
        "Require patient to sign liability waiver only",
        "Consult with patient's physician and take extra precautions"
      ],
      correctAnswer: 3
    },
    {
      id: 70600,
      question: "Which factor makes elderly patients more vulnerable to medical emergencies?",
      options: [
        "They have stronger immune systems than younger patients",
        "They experience fewer medication side effects",
        "They recover more quickly from medical emergencies",
        "They often have multiple chronic conditions and medications"
      ],
      correctAnswer: 3
    },
    {
      id: 70601,
      question: "What is the relationship between local anesthetic administration and medical emergencies?",
      options: [
        "Local anesthetics never cause any emergency situations",
        "All patients react identically to local anesthetics",
        "Improper technique or allergies can trigger emergencies",
        "Allergic reactions occur only with general anesthesia"
      ],
      correctAnswer: 2
    },
    {
      id: 70602,
      question: "How does maintaining a calm demeanor help during medical emergencies?",
      options: [
        "It has no effect on emergency outcomes",
        "It should be avoided in favor of showing urgency",
        "It only matters for minor emergencies, not major ones",
        "It reduces patient anxiety and helps team function effectively"
      ],
      correctAnswer: 3
    },
    {
      id: 70603,
      question: "What is the significance of knowing the location of emergency equipment?",
      options: [
        "Equipment location is irrelevant during emergencies",
        "Equipment should be stored in locked rooms always",
        "Quick access saves critical time during emergencies",
        "Only the dentist needs to know equipment locations"
      ],
      correctAnswer: 2
    },
    {
      id: 70604,
      question: "Which assessment should be performed immediately when a patient appears to be in distress?",
      options: [
        "Wait and observe for 10 minutes before assessing",
        "Complete full dental examination first before assessment",
        "Ask patient to leave and return another day",
        "Check airway, breathing, and circulation (ABCs)"
      ],
      correctAnswer: 3
    },
    {
      id: 70605,
      question: "What is the purpose of activating emergency medical services early in a crisis?",
      options: [
        "To increase costs and create unnecessary expenses",
        "To transfer all responsibility to paramedics immediately",
        "To avoid having to manage the emergency personally",
        "To ensure help arrives quickly if condition worsens"
      ],
      correctAnswer: 3
    },
    {
      id: 70606,
      question: "How should a dental professional respond if unsure about the severity of a patient's symptoms?",
      options: [
        "Assume symptoms are minor and continue treatment",
        "Ignore symptoms if patient doesn't complain loudly",
        "Ask patient to diagnose their own condition",
        "Err on side of caution and seek emergency help"
      ],
      correctAnswer: 3
    },
    {
      id: 70607,
      question: "What is the value of post-emergency debriefing with the dental team?",
      options: [
        "It serves no purpose and wastes valuable time",
        "It should only occur if the emergency had poor outcome",
        "It is only necessary for dentists, not other staff",
        "It identifies areas for improvement in emergency response"
      ],
      correctAnswer: 3
    },
    {
      id: 70608,
      question: "Which type of emergency requires immediate administration of epinephrine?",
      options: [
        "Severe anaphylactic reaction with systemic symptoms",
        "Simple syncope without allergic component",
        "Mild anxiety without physiological symptoms",
        "Orthostatic hypotension from standing too quickly"
      ],
      correctAnswer: 0
    },
    {
      id: 70609,
      question: "What is the recommended oxygen flow rate for most medical emergencies?",
      options: [
        "1-2 liters per minute for all emergencies",
        "Oxygen should never be given in dental emergencies",
        "10-15 liters per minute for all patients regardless",
        "4-6 liters per minute or higher depending on condition"
      ],
      correctAnswer: 3
    },
    {
      id: 70610,
      question: "How can monitoring vital signs help prevent medical emergencies?",
      options: [
        "Vital signs provide no useful information for prevention",
        "Vital signs should only be taken after emergencies happen",
        "Only blood pressure matters; other vitals are unnecessary",
        "Abnormal readings can alert to problems before emergencies occur"
      ],
      correctAnswer: 3
    },
    {
      id: 70611,
      question: "What is the significance of updating medical history at each appointment?",
      options: [
        "Medical history never changes once initially recorded",
        "Updates are only needed for new patients",
        "Annual updates are sufficient for all patients",
        "Conditions and medications can change over time"
      ],
      correctAnswer: 3
    },
    {
      id: 70612,
      question: "Which approach best describes prevention-focused dental care?",
      options: [
        "Treating emergencies only after they occur",
        "Avoiding treatment for patients with medical conditions",
        "Proactive identification of risks and preventive measures",
        "Relying solely on emergency equipment without preparation"
      ],
      correctAnswer: 2
    },
    {
      id: 70613,
      question: "What is the appropriate response when emergency equipment is found to be expired or malfunctioning?",
      options: [
        "Continue using it until replacement arrives next year",
        "Replace it immediately to ensure readiness",
        "Remove it and work without backup equipment",
        "Use it only for non-critical emergencies"
      ],
      correctAnswer: 1
    },
    {
      id: 70614,
      question: "How does patient education contribute to emergency prevention?",
      options: [
        "It has no impact on emergency occurrence rates",
        "It helps patients recognize and report concerning symptoms",
        "It should be avoided to prevent patient anxiety",
        "It is only necessary for high-risk patients"
      ],
      correctAnswer: 1
    },
    {
      id: 70615,
      question: "What is the recommended action when a patient reports taking anticoagulant medications?",
      options: [
        "Proceed with invasive procedures without modifications",
        "Refuse all dental treatment permanently",
        "Take extra precautions and consider consultation",
        "Ignore the medication history completely"
      ],
      correctAnswer: 2
    },
    {
      id: 70616,
      question: "Which factor indicates a patient may be at risk for a medical emergency?",
      options: [
        "Recent comprehensive dental cleaning without issues",
        "History of well-controlled chronic disease",
        "Unstable or poorly controlled medical conditions",
        "Young age with no family medical history"
      ],
      correctAnswer: 2
    },
    {
      id: 70617,
      question: "Medical emergencies in dental practice are extremely rare and unlikely to occur during a dental hygienist's career.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70618,
      question: "Syncope is the most common medical emergency encountered in dental practice.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70619,
      question: "Orthostatic hypotension occurs when blood pressure increases upon standing up.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70620,
      question: "Epinephrine is the first-line treatment for anaphylaxis.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70621,
      question: "Angina pectoris and myocardial infarction are the same condition.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70622,
      question: "The FAST acronym is used to identify signs of stroke.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70623,
      question: "Hypoglycemia refers to abnormally high blood sugar levels.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70624,
      question: "During an active seizure, objects should be placed in the patient's mouth to prevent tongue biting.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70625,
      question: "An Automated External Defibrillator (AED) should be available in every dental office.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "2. Vital Signs revised": [
    {
      id: 70626,
      question: "Which of the following is a factor that contributes to increased medical emergencies in dental settings?",
      options: [
        "Increased number of older clients and prevalence of chronic disease",
        "Reduction in surgical procedures being performed in dental offices",
        "Decreased number of older clients attending dental appointments",
        "Shorter dental appointment lengths reducing patient stress levels"
      ],
      correctAnswer: 0
    },
    {
      id: 70627,
      question: "What is the best time to schedule a dental appointment for fearful or medically compromised patients, including children?",
      options: [
        "In the morning, to minimize waiting and reduce stress levels",
        "Late afternoon, when the office is quieter and less busy overall",
        "At noon, so the patient has had time to eat a full meal first",
        "In the evening, so patients have more time to prepare mentally"
      ],
      correctAnswer: 0
    },
    {
      id: 70628,
      question: "Crepitation is best defined as which of the following?",
      options: [
        "A crackling, popping, or grating sound or sensation often felt in joints",
        "Fluid accumulation around joints causing visible swelling and pain",
        "Sharp stabbing sensation caused by nerve compression in the spine",
        "Abnormal breath sound caused by mucus blocking the airway passages"
      ],
      correctAnswer: 0
    },
    {
      id: 70629,
      question: "Which facial joint is commonly associated with crepitus?",
      options: [
        "Sphenomandibular joint near the base of the skull region",
        "Temporomandibular joint (TMJ) at the jaw hinge location",
        "Zygomaticofacial joint at the cheekbone region of the face",
        "Stylomandibular joint connecting the styloid process to the mandible"
      ],
      correctAnswer: 1
    },
    {
      id: 70630,
      question: "Ketoacidosis occurs when the body produces high levels of acidic ketones. What is the primary cause?",
      options: [
        "Lack of insulin, leading to a buildup of acidic ketones in the blood",
        "Bacterial infection disrupting the body's normal pH and acid balance",
        "Overproduction of glucose leading to very high blood sugar levels",
        "Excess insulin in the bloodstream causing dangerous blood sugar drops"
      ],
      correctAnswer: 0
    },
    {
      id: 70631,
      question: "Which of the following is a symptom associated with ketoacidosis?",
      options: [
        "Fruity breath, nausea, and confusion in affected individuals",
        "Joint pain, skin rashes, and extreme sensitivity to sunlight",
        "Pale skin, slow heart rate, and decreased urination frequency",
        "Chest pain, shortness of breath, and swollen lymph nodes"
      ],
      correctAnswer: 0
    },
    {
      id: 70632,
      question: "Which of the following correctly lists the vital signs measured during a physical examination?",
      options: [
        "Blood pressure, heart rate, respiratory rate, temperature, height, and weight",
        "Heart rate, skin color, capillary refill time, and pupil response",
        "Temperature, blood type, cholesterol level, and body mass index",
        "Blood pressure, oxygen saturation, glucose level, and reflex testing"
      ],
      correctAnswer: 0
    },
    {
      id: 70633,
      question: "What should clients be asked to avoid before having their blood pressure taken?",
      options: [
        "Wearing tight clothing, crossing legs, and speaking during measurement",
        "Smoking, consuming caffeine, and exercising within 30 minutes prior",
        "Eating large meals, drinking water, and taking any prescribed medication",
        "Drinking juice, sitting for long periods, and taking deep breaths"
      ],
      correctAnswer: 1
    },
    {
      id: 70634,
      question: "When assessing heart rate and rhythm, which three factors should be evaluated?",
      options: [
        "Heart rate, capillary refill time, and skin color changes observed",
        "Heart rate, heart rhythm, and pulse quality in the assessed patient",
        "Heart rate, blood pressure, and respiratory rate together in patients",
        "Heart rate, skin temperature, and oxygen saturation level readings"
      ],
      correctAnswer: 1
    },
    {
      id: 70635,
      question: "What is the normal adult respiratory rate range?",
      options: [
        "20–24 breaths per minute for a healthy resting adult patient",
        "24–30 breaths per minute for a healthy resting adult patient",
        "16–18 breaths per minute for a healthy resting adult patient",
        "8–12 breaths per minute for a healthy resting adult patient"
      ],
      correctAnswer: 2
    },
    {
      id: 70636,
      question: "Why should the clinician avoid making the client aware when measuring their respiratory rate?",
      options: [
        "Because knowing their rate is being monitored may embarrass clients",
        "Awareness of monitoring may cause the patient to alter breathing patterns",
        "To ensure the clinician can count accurately without any distraction",
        "So the client remains calm and does not raise their blood pressure"
      ],
      correctAnswer: 1
    },
    {
      id: 70637,
      question: "How should a clinician monitor respiratory rate after taking a client's pulse?",
      options: [
        "Ask the client to breathe normally while observing their chest movement",
        "Place a hand on the chest and count breaths for exactly 15 seconds",
        "Keep fingers on the radial or brachial artery and observe chest rise and fall",
        "Use a stethoscope on the back and count audible breath sounds heard"
      ],
      correctAnswer: 2
    },
    {
      id: 70638,
      question: "What temperature is considered normal for an adult patient?",
      options: [
        "37.5°C, with anything above 39.0°C indicating pathology present",
        "35.7°C, with anything above 38.8°C indicating a pathologic process",
        "34.5°C, with anything above 37.0°C indicating a pathologic process",
        "36.0°C, with anything above 37.5°C indicating pathology is present"
      ],
      correctAnswer: 1
    },
    {
      id: 70639,
      question: "The brachial artery divides at the neck of the radius into which two branches?",
      options: [
        "Subclavian artery and axillary artery located in the upper region",
        "Radial artery and ulnar artery located in the forearm of the arm",
        "Femoral artery and popliteal artery located in the lower extremity",
        "Carotid artery and jugular vein located in the neck region area"
      ],
      correctAnswer: 1
    },
    {
      id: 70640,
      question: "Which of the following signs may indicate that a dental patient is anxious?",
      options: [
        "Deep breathing, low blood pressure, and constricted pupils noted",
        "Slow speech, relaxed posture, and steady eye contact maintained",
        "Elevated blood pressure, visible trembling, and dilated pupils noted",
        "Low heart rate, pale skin, and calm demeanor throughout the visit"
      ],
      correctAnswer: 2
    },
    {
      id: 70641,
      question: "Why is it important to know about a patient's dental anxiety before treatment?",
      options: [
        "So the office can charge additional fees for sedation services used",
        "To identify risk and modify treatment to minimize stress-related emergencies",
        "To determine whether the patient needs a referral to a psychiatrist",
        "So the hygienist can avoid difficult procedures with anxious patients"
      ],
      correctAnswer: 1
    },
    {
      id: 70642,
      question: "Which drug classes are typically prescribed to help anxious patients before dental appointments?",
      options: [
        "Benzodiazepines and antidepressants to calm and relax the patient",
        "Corticosteroids and antihistamines to reduce inflammatory responses",
        "Analgesics and antibiotics to reduce pain and prevent infection",
        "Vasodilators and anticoagulants to improve blood flow and calmness"
      ],
      correctAnswer: 0
    },
    {
      id: 70643,
      question: "Selective Serotonin Reuptake Inhibitors (SSRIs) work by:",
      options: [
        "Increasing norepinephrine and epinephrine levels throughout the body",
        "Increasing levels of serotonin in the brain to improve overall mood",
        "Blocking dopamine receptors to reduce hyperactivity in the brain",
        "Reducing cortisol production in the adrenal glands to lower stress"
      ],
      correctAnswer: 1
    },
    {
      id: 70644,
      question: "What is the key difference between SSRIs and SNRIs as antidepressants?",
      options: [
        "SSRIs target only pain receptors while SNRIs target mood receptors",
        "SSRIs are injectable while SNRIs are taken as oral tablets only",
        "SSRIs increase serotonin only; SNRIs increase both serotonin and norepinephrine",
        "SSRIs are used for depression only while SNRIs treat anxiety disorders"
      ],
      correctAnswer: 2
    },
    {
      id: 70645,
      question: "Which of the following is part of the Stress Reduction Protocol for a normal healthy anxious patient (ASA 1)?",
      options: [
        "Prescribe full sedation for every appointment regardless of anxiety level",
        "Follow up with postoperative pain and anxiety control after the visit",
        "Keep length of appointment fixed to provide consistency and routine",
        "Schedule appointments in the afternoon to allow the patient more rest"
      ],
      correctAnswer: 1
    },
    {
      id: 70646,
      question: "For high-risk patients (ASA 2, 3, 4), which specific action is part of the stress reduction protocol?",
      options: [
        "Schedule appointments late in the week to give the patient more rest",
        "Monitor and record preoperative and postoperative vital signs at appointments",
        "Limit all appointments to under 15 minutes to reduce exposure time",
        "Avoid taking vital signs to prevent increasing the patient's anxiety"
      ],
      correctAnswer: 1
    },
    {
      id: 70647,
      question: "What does BLS stand for, and what does it include?",
      options: [
        "Basic Lung Support, including breathing exercises and oxygen therapy",
        "Basic Life Support, including positioning, circulation, airway, breathing, and definitive care",
        "Biological Life Systems, referring to natural body responses in emergencies",
        "Basic Laboratory Systems, used to assess blood levels during medical crises"
      ],
      correctAnswer: 1
    },
    {
      id: 70648,
      question: "What does the \"D\" in the BLS acronym stand for?",
      options: [
        "Dehydration management, including fluid replacement therapy protocols",
        "Documentation of all vital signs and emergency events throughout care",
        "Disposition planning for transfer of the patient to hospital care",
        "Definitive care, which includes diagnosis, drugs, and defibrillation"
      ],
      correctAnswer: 3
    },
    {
      id: 70649,
      question: "According to the lecture, what dramatically increases survival rates when combined with rapid BLS initiation?",
      options: [
        "Ready access to defibrillation within less than 8 minutes of collapse",
        "Immediate drug administration before BLS is initiated for the patient",
        "Having a physician present in the dental office at all times available",
        "Administering IV fluids within 5 minutes of a cardiac event occurring"
      ],
      correctAnswer: 0
    },
    {
      id: 70650,
      question: "What is the survival rate if BLS is NOT performed during a cardiac emergency?",
      options: [
        "10% survival when no BLS is performed at the scene of emergency",
        "25% survival when no BLS is performed at the scene of emergency",
        "0% survival when no BLS is performed at the scene of emergency",
        "5% survival when no BLS is performed at the scene of emergency"
      ],
      correctAnswer: 2
    },
    {
      id: 70651,
      question: "What is the minimum number of team members recommended for an emergency team in a dental office?",
      options: [
        "At least 4 members with rotating leadership responsibilities assigned",
        "At least 6 members covering all possible emergency scenarios",
        "At least 2 or 3 members, each with a predefined role in emergencies",
        "At least 5 trained members with clearly assigned specialized roles"
      ],
      correctAnswer: 2
    },
    {
      id: 70652,
      question: "What is the primary task of Team Member #1 during a medical emergency?",
      options: [
        "Retrieve the emergency drug kit and AED from storage areas quickly",
        "Call 911 and provide the dispatcher with all necessary information",
        "Escort emergency services into the building from the main entrance",
        "Initiate BLS as indicated after assessing the victim's condition"
      ],
      correctAnswer: 3
    },
    {
      id: 70653,
      question: "What are the duties of Team Member #2 during a medical emergency?",
      options: [
        "Initiate CPR, alert staff, and remain with the victim at all times",
        "Monitor vitals, prepare emergency drugs, and assist with documentation",
        "Call 911, maintain records, and meet emergency services at the entrance",
        "Bring portable oxygen, gather the emergency kit, and retrieve the AED"
      ],
      correctAnswer: 3
    },
    {
      id: 70654,
      question: "Which piece of information is NOT required when calling EMS during a dental emergency?",
      options: [
        "Number of people needing help and condition of the victim currently",
        "Location of the emergency and telephone number being used for call",
        "The patient's insurance information and dental treatment history",
        "What happened and what aid is currently being given to the victim"
      ],
      correctAnswer: 2
    },
    {
      id: 70655,
      question: "According to the lecture, what should ALWAYS come before drug administration in an emergency?",
      options: [
        "Basic Life Support (BLS) must always be performed first in emergencies",
        "Calling the patient's family physician for authorization to medicate",
        "Checking the patient's drug allergy list before any medication is given",
        "Contacting the local hospital emergency department for guidance first"
      ],
      correctAnswer: 0
    },
    {
      id: 70656,
      question: "Even in the case of anaphylactic shock, what is the correct order of management?",
      options: [
        "Administer antihistamine first, followed by epinephrine and then BLS",
        "Administer epinephrine first, then begin BLS if the patient is unresponsive",
        "Call 911 first, then administer epinephrine while waiting for paramedics",
        "Perform BLS first, then administer epinephrine as the second step"
      ],
      correctAnswer: 3
    },
    {
      id: 70657,
      question: "What is the most important emergency drug for managing acute life-threatening allergic reactions?",
      options: [
        "Aspirin, used to prevent platelet aggregation during allergic responses",
        "Albuterol, used as an inhaled bronchodilator during allergic reactions",
        "Nitroglycerin, used to dilate blood vessels during severe allergic episodes",
        "Epinephrine, which acts as a bronchodilator and vasopressor in emergencies"
      ],
      correctAnswer: 3
    },
    {
      id: 70658,
      question: "What is epinephrine's drug class?",
      options: [
        "Anticholinergic agent used to block parasympathetic nerve signals",
        "Corticosteroid used to suppress immune and inflammatory responses",
        "Catecholamine with vasopressor and bronchodilator properties",
        "Beta-blocker agent used to reduce heart rate and blood pressure"
      ],
      correctAnswer: 2
    },
    {
      id: 70659,
      question: "Why should epinephrine be administered with caution to pregnant patients?",
      options: [
        "It reduces fetal oxygen supply by constricting the umbilical blood vessels",
        "It may bring on premature labour in pregnant patients when administered",
        "It causes severe maternal hypertension leading to placental abruption",
        "It crosses the placental barrier and causes fetal liver toxicity issues"
      ],
      correctAnswer: 1
    },
    {
      id: 70660,
      question: "What is the drug of choice for histamine blockers in the emergency kit?",
      options: [
        "Chlorpheniramine (Benadryl), an antihistamine for managing allergic reactions",
        "Morphine sulphate, an opioid used to reduce pain and anxiety levels",
        "Hydrocortisone, a corticosteroid used to reduce inflammation and swelling",
        "Midazolam, a benzodiazepine used to control seizure activity in patients"
      ],
      correctAnswer: 0
    },
    {
      id: 70661,
      question: "Why are antihistamines contraindicated in the treatment of acute asthmatic episodes?",
      options: [
        "They interact negatively with bronchodilators, reducing their effectiveness",
        "They cause bronchospasm by directly stimulating airway smooth muscle",
        "They increase mucus production, which worsens airway obstruction",
        "Their drying effect on bronchial secretions may worsen the asthma attack"
      ],
      correctAnswer: 3
    },
    {
      id: 70662,
      question: "What is the most useful drug in an emergency kit according to the lecture?",
      options: [
        "Aspirin, used for suspected myocardial infarction and unstable angina",
        "Nitroglycerin spray, used for acute chest pain and angina episodes",
        "Oxygen, used when respiratory distress is evident in the patient",
        "Epinephrine, used for severe allergic reactions and anaphylactic shock"
      ],
      correctAnswer: 2
    },
    {
      id: 70663,
      question: "Oxygen should NOT be used to treat which condition?",
      options: [
        "Respiratory distress caused by a severe asthma attack episode",
        "Hyperventilation in an anxious or panicking dental patient",
        "Cardiac arrest requiring resuscitation and breathing support",
        "Anaphylaxis accompanied by severe breathing difficulties throughout"
      ],
      correctAnswer: 1
    },
    {
      id: 70664,
      question: "What is the drug of choice for the immediate management of chest pain related to angina?",
      options: [
        "Aspirin tablet chewed immediately upon onset of chest pain symptoms",
        "Albuterol inhaler used to open the airways during anginal episodes",
        "Chlorpheniramine injection used to dilate blood vessels during angina",
        "Nitroglycerin, available in tablet, spray, or inhalant form for chest pain"
      ],
      correctAnswer: 3
    },
    {
      id: 70665,
      question: "What is the approximate shelf life of nitroglycerin once it has been opened?",
      options: [
        "6 months, after which potency decreases significantly for clinical use",
        "2 years, as it is a stable compound that lasts when stored correctly",
        "12 weeks, after which the drug becomes less effective for angina relief",
        "24 hours, as it degrades rapidly once the bottle has been unsealed"
      ],
      correctAnswer: 2
    },
    {
      id: 70666,
      question: "What are the side effects of nitroglycerin?",
      options: [
        "Sedation, dry mouth, and thickening of bronchial secretions reported",
        "Nausea, vomiting, and increased blood pressure at higher doses taken",
        "Pulsating headache and facial flushing after administration of drug",
        "Muscle weakness, confusion, and decreased oxygen saturation levels"
      ],
      correctAnswer: 2
    },
    {
      id: 70667,
      question: "What is the drug of choice for treating bronchospasms (acute asthmatic episodes)?",
      options: [
        "Albuterol (Salbutamol), a bronchodilator given via inhaler for asthma",
        "Nitroglycerin spray, which dilates blood vessels and relieves bronchospasm",
        "Epinephrine injection, used to constrict airways and stop bronchospasm",
        "Aromatic ammonia, a respiratory stimulant used to open the airways"
      ],
      correctAnswer: 0
    },
    {
      id: 70668,
      question: "What is the drug of choice for managing a conscious hypoglycemic patient?",
      options: [
        "Glucagon injection given intramuscularly to raise blood sugar levels",
        "Aspirin tablet chewed to stabilize blood sugar during hypoglycemia",
        "Dextrose 50% IV solution administered directly into the bloodstream",
        "Orange juice or non-diet soft drink as an oral antihypoglycemic agent"
      ],
      correctAnswer: 3
    },
    {
      id: 70669,
      question: "Aspirin is indicated in which emergency situation in the dental office?",
      options: [
        "Hypoglycemic episode in a diabetic patient who has lost consciousness",
        "Suspected myocardial infarction or unstable angina in the patient",
        "Acute allergic reaction following exposure to a dental material used",
        "Acute asthmatic episode with severe bronchospasm and breathing difficulty"
      ],
      correctAnswer: 1
    },
    {
      id: 70670,
      question: "What are the contraindications for aspirin use in an emergency?",
      options: [
        "Patients with low blood pressure or a history of anxiety disorders",
        "Patients taking antihistamines or who have a history of asthma attacks",
        "Patients with allergy to aspirin or ongoing life-threatening hemorrhage",
        "Patients with diabetes, hypertension, or a history of heart disease"
      ],
      correctAnswer: 2
    },
    {
      id: 70671,
      question: "Which injection route provides the fastest onset of drug action at 20–30 seconds?",
      options: [
        "Sublingual or intralingual administration under the tongue",
        "Intranasal (IN) delivery via nasal spray into the nasal passages",
        "Intramuscular (IM) injection into the vastus lateralis muscle site",
        "Intravenous (IV) administration directly into the bloodstream"
      ],
      correctAnswer: 3
    },
    {
      id: 70672,
      question: "What is the preferred intramuscular injection site for drug administration in emergencies?",
      options: [
        "Rectus femoris at the front of the thigh for fastest drug absorption",
        "Mid-deltoid of the upper arm for all adult patients in emergencies",
        "Gluteal region in the buttocks for large-volume drug administration",
        "Vastus lateralis as the preferred IM site for emergency drug delivery"
      ],
      correctAnswer: 3
    },
    {
      id: 70673,
      question: "What is the drug of choice for Module 2 anticonvulsants in dental emergencies?",
      options: [
        "Midazolam, a benzodiazepine used to manage acute seizure episodes",
        "Morphine sulphate, an opioid used to sedate and stop seizure activity",
        "Atropine, an anticholinergic used to prevent seizures in dental settings",
        "Hydrocortisone, a corticosteroid with anticonvulsant secondary effects"
      ],
      correctAnswer: 0
    },
    {
      id: 70674,
      question: "What are the \"4 A's\" of aspirin as an analgesic drug?",
      options: [
        "Analgesic, Anticoagulant, Antiemetic, and Antispasmodic properties",
        "Analgesic, Antifungal, Antihistamine, and Antihypertensive properties",
        "Analgesic, Antibiotic, Antiviral, and Anti-inflammatory properties",
        "Analgesic, Antipyretic, Anti-inflammatory, and Antiplatelet properties"
      ],
      correctAnswer: 3
    },
    {
      id: 70675,
      question: "Which drug is the Module 2 choice for managing acute hypotension when heart status is unknown?",
      options: [
        "Epinephrine injection, used to raise both systolic and diastolic pressure",
        "Nitroglycerin, a vasodilator used to regulate blood pressure in emergencies",
        "Atropine, used to increase heart rate and raise blood pressure levels",
        "Methoxamine, a vasopressor used to raise blood pressure in hypotension"
      ],
      correctAnswer: 3
    },
    {
      id: 70676,
      question: "What is the drug of choice for managing bradycardia (heart rate less than 60 bpm)?",
      options: [
        "Atropine, an anticholinergic drug used to increase heart rate in bradycardia",
        "Esmolol, a beta-adrenergic blocker used to further reduce heart rate",
        "Midazolam, a benzodiazepine used to manage irregular heart rhythms",
        "Methoxamine, a vasopressor that increases cardiac output in bradycardia"
      ],
      correctAnswer: 0
    },
    {
      id: 70677,
      question: "What is the drug of choice for managing an acute hypertensive episode in Module 2?",
      options: [
        "Midazolam, a benzodiazepine that lowers blood pressure as a secondary effect",
        "Esmolol, a B-adrenergic blocker used to manage acute hypertensive episodes",
        "Methoxamine, a vasopressor that reduces blood pressure by arterial constriction",
        "Atropine, an anticholinergic drug that lowers blood pressure through vasodilation"
      ],
      correctAnswer: 1
    },
    {
      id: 70678,
      question: "Corticosteroids in the emergency kit are used to manage which condition?",
      options: [
        "Hyperventilation episodes caused by anxiety during dental procedures",
        "Bradycardia episodes when the patient's heart rate drops dangerously low",
        "Acute hypoglycemic episodes when the patient is conscious and alert",
        "Acute allergic reactions, following BLS, epinephrine, and histamine blockers"
      ],
      correctAnswer: 3
    },
    {
      id: 70679,
      question: "What is the drug of choice for respiratory stimulants (Module 2 non-injectable) used in syncope?",
      options: [
        "Nitroglycerin spray used to stimulate breathing by dilating blood vessels",
        "Oxygen administered via face mask to stimulate normal respiratory function",
        "Aromatic ammonia (vaporole) crushed and placed under the client's nose",
        "Salbutamol inhaler used to stimulate respiratory function during syncope"
      ],
      correctAnswer: 2
    },
    {
      id: 70680,
      question: "What is a known side effect of calcium channel blockers on the oral tissues?",
      options: [
        "Gingival enlargement (overgrowth of gum tissue) as a side effect",
        "Xerostomia (dry mouth) causing reduced saliva flow and discomfort",
        "Aphthous ulcer formation on the oral mucosa and gingival tissues",
        "Increased bleeding tendency from gingival tissues during probing"
      ],
      correctAnswer: 0
    },
    {
      id: 70681,
      question: "What epinephrine dose is found in an adult Epi-pen as per Ontario's emergency kit requirements?",
      options: [
        "1.00 mg epinephrine for adult patients in anaphylactic emergencies",
        "0.15 mg epinephrine for adult patients in anaphylactic emergencies",
        "0.30 mg epinephrine for adult patients in anaphylactic emergencies",
        "0.50 mg epinephrine for adult patients in anaphylactic emergencies"
      ],
      correctAnswer: 2
    },
    {
      id: 70682,
      question: "What epinephrine dose is in the Epi-pen Junior for pediatric patients?",
      options: [
        "0.05 mg epinephrine for pediatric patients in anaphylactic emergencies",
        "0.30 mg epinephrine for pediatric patients in anaphylactic emergencies",
        "0.10 mg epinephrine for pediatric patients in anaphylactic emergencies",
        "0.15 mg epinephrine for pediatric patients in anaphylactic emergencies"
      ],
      correctAnswer: 3
    },
    {
      id: 70683,
      question: "What aspirin dosage is included in Ontario's required emergency kit?",
      options: [
        "200 mg aspirin tablet for cardiac emergency management in the office",
        "325 mg aspirin tablet for cardiac emergency management in the office",
        "500 mg aspirin tablet for cardiac emergency management in the office",
        "81 mg aspirin tablet for cardiac emergency management in the office"
      ],
      correctAnswer: 1
    },
    {
      id: 70684,
      question: "What is the CDHO requirement for dental hygienists regarding CPR certification?",
      options: [
        "CPR must be updated annually and recorded on the portfolio submission",
        "CPR must be completed once and kept on file for licensing purposes only",
        "CPR must be completed every 3 years and submitted with license renewal",
        "CPR is optional for hygienists working outside of hospital-based settings"
      ],
      correctAnswer: 0
    },
    {
      id: 70685,
      question: "Which of the following is included in Advanced Cardiovascular Life Support (ACLS)?",
      options: [
        "Basic positioning, airway management, CPR technique, and oxygen therapy",
        "Blood pressure monitoring, medication dispensing, and patient transport",
        "Dietary counseling, drug history review, and discharge planning protocols",
        "Airway adjuncts, dysrhythmia recognition, defibrillation, and venipuncture"
      ],
      correctAnswer: 3
    },
    {
      id: 70686,
      question: "What are the four modules of the emergency drug kit?",
      options: [
        "Critical, Secondary, Pediatric, and Advanced equipment and drug modules",
        "Injectable, non-injectable, oral, and topical drug and equipment categories",
        "Basic critical, non-critical, ACLS, and antidotal drugs and equipment",
        "Primary, secondary, tertiary, and quaternary drug and equipment levels"
      ],
      correctAnswer: 2
    },
    {
      id: 70687,
      question: "What information should be posted by every telephone in the dental office?",
      options: [
        "The names and contact numbers of all team members and their roles",
        "The emergency drug kit contents and expiration dates of all medications",
        "The closest hospital and ambulance response times for the local area",
        "The address of the dental office for emergency communication purposes"
      ],
      correctAnswer: 3
    },
    {
      id: 70688,
      question: "What is parenteral drug administration?",
      options: [
        "Administration that bypasses the GI tract, including IV, IM, and intranasal routes",
        "Sublingual administration that dissolves under the tongue into bloodstream",
        "Oral administration through swallowing that bypasses the skin barrier",
        "Topical application to the skin that enters the bloodstream gradually"
      ],
      correctAnswer: 0
    },
    {
      id: 70689,
      question: "Oxygen is the most useful drug in an emergency kit and should be used to treat hyperventilation in anxious patients.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70690,
      question: "An annual refresher course in BLS/CPR is necessary for all dental office staff members.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70691,
      question: "Drug administration is considered the first priority in all dental medical emergencies before BLS.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70692,
      question: "Nitroglycerin is contraindicated for clients who are hypotensive.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70693,
      question: "The ulnar artery is the largest of the two branches that the brachial artery divides into at the neck of the radius.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70694,
      question: "Antihistamines can be used as a local anesthetic alternative for patients with a history of alleged allergy to local anesthesia.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70695,
      question: "Survival rates increase to 43% when rapid BLS initiation is combined with ready access to defibrillation within 8 minutes.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70696,
      question: "Ketoacidosis is caused by excess insulin in the bloodstream, leading to dangerously low blood sugar levels.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
  ],  
  "3. Legal considerations revised": [
    {
      id: 70697,
      question: "Which of the following is a reason medical emergencies occur in a dental setting?",
      options: [
        "The patient forgot to brush their teeth before the appointment",
        "Clinician's fault such as failure to address the medical history",
        "The patient did not pay their dental bill before treatment",
        "The dental chair was not adjusted to the correct height"
      ],
      correctAnswer: 1
    },
    {
      id: 70698,
      question: "Which type of hypersensitivity reaction involves anaphylactic shock requiring immediate treatment?",
      options: [
        "Type 4 delayed hypersensitivity reaction to allergen exposure",
        "Type 3 immune complex reaction involving clusters of substances",
        "Type 2 cytotoxic reaction attacking the body's own cells",
        "Type 1 hypersensitivity reaction requiring epinephrine as drug of choice"
      ],
      correctAnswer: 3
    },
    {
      id: 70699,
      question: "What is a Type 2 hypersensitivity (cytotoxic) reaction?",
      options: [
        "The immune system forms clusters of foreign substances like bacteria",
        "The body's immune system attacks its own cells, such as in hemolytic anemia",
        "A delayed reaction appearing hours or days after allergen exposure",
        "An immediate systemic reaction causing throat swelling and low blood pressure"
      ],
      correctAnswer: 1
    },
    {
      id: 70700,
      question: "Which of the following is an example of a Type 3 (immune complex) hypersensitivity reaction?",
      options: [
        "Hemolytic anemia caused by the body attacking its own red blood cells",
        "Anaphylaxis triggered by a bee sting or penicillin injection",
        "Contact dermatitis from touching poison ivy leaves",
        "Lupus or rheumatoid arthritis from immune complexes forming"
      ],
      correctAnswer: 3
    },
    {
      id: 70701,
      question: "Which type of hypersensitivity reaction is characterized by symptoms like redness, blisters, and swelling that appear hours or days after exposure?",
      options: [
        "Type 1 anaphylactic hypersensitivity with rapid systemic effects",
        "Type 4 delayed hypersensitivity, such as contact dermatitis from poison ivy",
        "Type 2 cytotoxic hypersensitivity attacking the body's own tissues",
        "Type 3 immune complex hypersensitivity forming antigen-antibody clusters"
      ],
      correctAnswer: 1
    },
    {
      id: 70702,
      question: "Which of the following symptoms is associated with anaphylactic shock (Type 1 hypersensitivity)?",
      options: [
        "Staring spells, eyelid blinking, and brief loss of awareness",
        "Gradual onset redness and blistering appearing days after exposure",
        "Swelling in the throat, difficulty breathing, and low blood pressure",
        "Confusion, rapid breathing, and fruity breath from elevated glucose"
      ],
      correctAnswer: 2
    },
    {
      id: 70703,
      question: "In what dental emergency situation would Benadryl (diphenhydramine) be appropriate to use?",
      options: [
        "Grand mal seizure with tonic-clonic movements and tongue biting",
        "Cardiac arrest requiring CPR and defibrillation immediately",
        "Syncope where the patient has lost consciousness and needs repositioning",
        "Mild to moderate allergic reaction to dental materials or medications"
      ],
      correctAnswer: 3
    },
    {
      id: 70704,
      question: "Which of the following is a side effect of Benadryl (diphenhydramine)?",
      options: [
        "Hypertension and increased heart rate with prolonged use",
        "Bronchoconstriction causing difficulty breathing and wheezing",
        "Drowsiness and dry mouth, also known as xerostomia",
        "Elevated blood pressure and increased pupil dilation"
      ],
      correctAnswer: 2
    },
    {
      id: 70705,
      question: "Why should patients be cautioned about driving after taking Benadryl?",
      options: [
        "It can cause rapid heartbeat making it unsafe to operate a vehicle",
        "It can cause drowsiness and impair the ability to function normally",
        "It causes blurred vision making it difficult to see the road clearly",
        "It raises blood pressure making patients dizzy during driving"
      ],
      correctAnswer: 1
    },
    {
      id: 70706,
      question: "Which of the following is a fast-acting asthma medication?",
      options: [
        "Fluticasone/Salmeterol (Advair) for long-term asthma maintenance",
        "Mometasone/Formoterol (Dulera) used for chronic asthma control",
        "Budesonide/Formoterol (Symbicort) for long-term asthma prevention",
        "Albuterol/Salbutamol (Ventolin) used for acute bronchospasm relief"
      ],
      correctAnswer: 3
    },
    {
      id: 70707,
      question: "Which of the following is a long-acting asthma medication?",
      options: [
        "Levalbuterol (Xopenex) used for quick relief of acute bronchospasm",
        "Albuterol (Proventil) used to rapidly open narrowed airway passages",
        "Fluticasone/Vilanterol (Breo Ellipta) used for long-term asthma control",
        "Salbutamol (Ventolin) used for acute relief of bronchospasm symptoms"
      ],
      correctAnswer: 2
    },
    {
      id: 70708,
      question: "What is malpractice in the context of dental care?",
      options: [
        "Forgetting to document a routine cleaning appointment in the chart",
        "Providing care that falls below the professional standard causing harm",
        "Running late for a scheduled appointment without notifying the patient",
        "Overcharging a patient for dental services rendered at the office"
      ],
      correctAnswer: 1
    },
    {
      id: 70709,
      question: "What are the four key concepts required to prove malpractice?",
      options: [
        "Licensing, registration, training, and documentation of all procedures",
        "Obligation (duty), breach of duty, cause, and resulting damage to patient",
        "Consent, communication, documentation, and proper drug administration",
        "Intent, motive, outcome, and reporting to regulatory authorities"
      ],
      correctAnswer: 1
    },
    {
      id: 70710,
      question: "What is an example of an \"omission\" in a dental emergency context?",
      options: [
        "Administering the wrong dosage of medication to a patient",
        "Performing surgery on the wrong site during a dental procedure",
        "Not calling 911 when a patient requires emergency medical services",
        "Applying topical anesthetic before completing the medical history"
      ],
      correctAnswer: 2
    },
    {
      id: 70711,
      question: "What is an example of \"commission\" in a malpractice context?",
      options: [
        "Failing to refer a patient to a periodontist who needed specialist care",
        "Not informing a patient about the risks associated with a procedure",
        "Neglecting to review the medical history before starting treatment",
        "Administering the wrong drug or dosage to a patient in the office"
      ],
      correctAnswer: 3
    },
    {
      id: 70712,
      question: "Which of the following best describes the Good Samaritan Rule?",
      options: [
        "It requires all dental professionals to provide care in every emergency",
        "It protects health care providers who render good faith emergency care to non-clients",
        "It holds professionals to higher standards outside their normal workplace",
        "It mandates dental offices maintain AEDs and trained CPR employees"
      ],
      correctAnswer: 1
    },
    {
      id: 70713,
      question: "How does the Good Samaritan Rule differ when applied inside a dental office?",
      options: [
        "Inside the office, no legal protection exists and all actions are criminal",
        "The rule only applies inside dental offices and not in public settings",
        "Good Samaritan protections are stronger inside the dental office setting",
        "Inside the office, professionals are held to CDHO duty of care standards"
      ],
      correctAnswer: 3
    },
    {
      id: 70714,
      question: "What does \"professional negligence\" mean in dental hygiene practice?",
      options: [
        "Failure to pay annual membership dues to the regulatory college",
        "Disagreeing with a dentist's treatment recommendation for a patient",
        "Failing to do what a reasonable prudent dental hygienist would do",
        "Accidentally breaking an instrument during a routine cleaning procedure"
      ],
      correctAnswer: 2
    },
    {
      id: 70715,
      question: "Which of the following is an example of professional negligence?",
      options: [
        "Recommending fluoride treatment to a patient who declined it before",
        "Failing to refer a patient with 8–12mm pocketing to a periodontist",
        "Using a scaler that is slightly dull instead of having it sharpened first",
        "Documenting a treatment incorrectly but correcting the error right away"
      ],
      correctAnswer: 1
    },
    {
      id: 70716,
      question: "What is required to prove malpractice in a dental setting?",
      options: [
        "A patient complaint filed within 6 months of the dental appointment",
        "Omission or commission, failure of standard of care, and harm to client",
        "Video evidence of the procedure and a signed witness statement",
        "A regulatory investigation outcome and insurance company agreement"
      ],
      correctAnswer: 1
    },
    {
      id: 70717,
      question: "If a clinician treats a patient without required antibiotic premedication and no harm results, what is the legal outcome?",
      options: [
        "It is malpractice regardless of outcome because the risk was taken",
        "It is automatically reported to the CDHO for regulatory review",
        "It is not malpractice because no injury occurred, though still negligent",
        "It becomes professional negligence only if the patient complains later"
      ],
      correctAnswer: 2
    },
    {
      id: 70718,
      question: "If a patient develops infective endocarditis after treatment without required antibiotic premedication, what is the legal classification?",
      options: [
        "Negligence only, as the harm was not a direct result of the treatment",
        "Malpractice, because harm occurred as a direct result of failing standard of care",
        "A random event, as endocarditis can occur in any patient at any time",
        "An unavoidable emergency, since infections are unpredictable events"
      ],
      correctAnswer: 1
    },
    {
      id: 70719,
      question: "Which of the following represents \"Regulatory Legal Defence\" coverage for dental hygienists?",
      options: [
        "Covers costs of treatment for a patient who suffered harm in the office",
        "Reimburses lost earnings if a hygienist misses work due to illness",
        "Covers legal expenses from disciplinary hearings by provincial regulatory bodies",
        "Provides funding for the rehabilitation of a hygienist injured at work"
      ],
      correctAnswer: 2
    },
    {
      id: 70720,
      question: "What does \"Loss of Earnings\" coverage protect in the CDHA liability insurance?",
      options: [
        "Income lost due to a patient refusing to pay for completed dental work",
        "Earnings lost when attending a trial, pretrial, or appeal related to a case",
        "Revenue lost when the dental office closes due to a staff emergency",
        "Income replacement during maternity or parental leave from practice"
      ],
      correctAnswer: 1
    },
    {
      id: 70721,
      question: "What is the correct management protocol for syncope in the dental office?",
      options: [
        "Sit the patient upright, give oxygen, and administer epinephrine",
        "Recline the chair slightly, monitor vitals, and offer water to the patient",
        "Lay the patient flat with legs elevated, administer oxygen, and monitor",
        "Call 911 immediately, administer nitroglycerin, and wait for EMS"
      ],
      correctAnswer: 2
    },
    {
      id: 70722,
      question: "What is another term for syncope/fainting?",
      options: [
        "Vasodilatory collapse associated with rapid onset cardiovascular failure",
        "Vasodepressor syncope, also associated with postural hypotension",
        "Vasopressor syncope caused by sudden high blood pressure episodes",
        "Vasopressive response triggered by acute hypoglycemic conditions"
      ],
      correctAnswer: 1
    },
    {
      id: 70723,
      question: "Which condition is associated with postural hypotension and may cause loss of consciousness?",
      options: [
        "Hyperglycemia from elevated blood sugar causing systemic complications",
        "Anaphylaxis from an acute allergic reaction to a dental material",
        "Asthma from bronchoconstriction during a dental procedure",
        "Syncope, where sudden drop in blood pressure causes fainting episodes"
      ],
      correctAnswer: 3
    },
    {
      id: 70724,
      question: "Which of the following is least likely to be seen in a dental office setting?",
      options: [
        "Syncope caused by anxiety or postural hypotension during treatment",
        "Asthma exacerbation triggered by dental materials or stress",
        "Acute adrenal insufficiency associated with Addison's disease",
        "Hyperventilation caused by stress and anxiety during dental care"
      ],
      correctAnswer: 2
    },
    {
      id: 70725,
      question: "Acute adrenal insufficiency involves a deficiency of which hormone?",
      options: [
        "Epinephrine deficiency leading to reduced response to allergens",
        "Insulin deficiency leading to elevated blood sugar during emergency",
        "Cortisol deficiency leading to rapid onset of loss of consciousness",
        "Serotonin deficiency leading to altered mood and unconsciousness"
      ],
      correctAnswer: 2
    },
    {
      id: 70726,
      question: "Which of the following is a common cause of respiratory distress in the dental office?",
      options: [
        "Cardiac tamponade causing compression of the heart muscle tissues",
        "Pulmonary embolism causing sudden obstruction of the lung arteries",
        "Hyperventilation, asthma, or hypoglycemia during dental treatment",
        "Deep vein thrombosis causing blood clots to travel to the lungs"
      ],
      correctAnswer: 2
    },
    {
      id: 70727,
      question: "Which of the following can be used to minimize the risk of foreign body obstruction during dental treatment?",
      options: [
        "Administering oxygen before beginning the dental procedure",
        "Using rubber dam, frequent suctioning, and proper chair positioning",
        "Prescribing antihistamines to reduce swelling in the oral cavity",
        "Asking the patient to hold their breath during instrument placement"
      ],
      correctAnswer: 1
    },
    {
      id: 70728,
      question: "What instrument should be readily available in the dental office to manage foreign body obstruction?",
      options: [
        "AED (Automated External Defibrillator) for cardiac rhythm management",
        "Tongue depressor for clearing oral obstructions from the airway",
        "Magill Intubation Forceps for retrieving objects from the airway",
        "Laryngoscope for visualizing the vocal cords during intubation"
      ],
      correctAnswer: 2
    },
    {
      id: 70729,
      question: "Which of the following can cause altered consciousness in the dental setting?",
      options: [
        "Hyperventilation, drug overdose, hypoglycemia, or hyperglycemia",
        "Toothache pain causing vasodilation and reduced brain perfusion",
        "Excessive fluoride exposure causing neurological symptoms",
        "Dehydration from not drinking enough water before the appointment"
      ],
      correctAnswer: 0
    },
    {
      id: 70730,
      question: "Which of the following are symptoms of hyperglycemia (diabetic coma)?",
      options: [
        "Pale, clammy skin with trembling and confusion from low blood sugar",
        "Slow breathing, pinpoint pupils, and sedation from drug overdose",
        "Rapid breathing, polydipsia, dry flushed skin, fruity breath, and polyuria",
        "Sudden chest pain, arm numbness, and shortness of breath"
      ],
      correctAnswer: 2
    },
    {
      id: 70731,
      question: "What is the emergency management for hyperglycemia in the dental office?",
      options: [
        "Activate EMS, give fluids to the patient, and keep patient warm",
        "Administer epinephrine and place the patient in the recovery position",
        "Lay patient flat, elevate legs, give oxygen, and monitor vital signs",
        "Administer orange juice and monitor the patient until recovery occurs"
      ],
      correctAnswer: 0
    },
    {
      id: 70732,
      question: "Why should epinephrine NOT be used in patients with hyperthyroid conditions?",
      options: [
        "Hyperthyroid patients are contraindicated for epinephrine use",
        "Epinephrine stimulates the thyroid, worsening hyperthyroid conditions",
        "Epinephrine causes excessive sedation in hyperthyroid patients",
        "Epinephrine lowers blood sugar dangerously in hyperthyroid patients"
      ],
      correctAnswer: 0
    },
    {
      id: 70733,
      question: "What is a cerebrovascular accident (CVA)?",
      options: [
        "Reduction of cerebral blood flow to a brain region causing neurologic impairment",
        "An allergic reaction causing swelling of the brain and confusion",
        "A cardiac event caused by blockage of the coronary arteries",
        "Sudden drop in blood sugar causing loss of consciousness in patients"
      ],
      correctAnswer: 0
    },
    {
      id: 70734,
      question: "How can the onset of a cerebrovascular accident (stroke) present?",
      options: [
        "Symptoms may present as either sudden or slow onset in patients",
        "CVA onset always requires 24 hours before symptoms are noticed",
        "Onset is always sudden and never gradual in CVA presentations",
        "Onset is always gradual and never sudden in CVA presentations"
      ],
      correctAnswer: 0
    },
    {
      id: 70735,
      question: "What is the most common type of seizure?",
      options: [
        "Grand Mal (Tonic-Clonic) seizure with body stiffening and jerking",
        "Focal seizure affecting only one side of the body during the event",
        "Myoclonic seizure involving sudden, brief muscle jerks throughout",
        "Absence seizure (Petit Mal) characterized by brief staring episodes"
      ],
      correctAnswer: 0
    },
    {
      id: 70736,
      question: "How long does a Grand Mal (Tonic-Clonic) seizure typically last?",
      options: [
        "About 10 seconds, followed by immediate return to full consciousness",
        "About 30 seconds, followed by confusion and extreme tiredness",
        "About 1–2 minutes, followed by a brief period of disorientation",
        "About 5–15 minutes, followed by confusion and tiredness (post-ictal)"
      ],
      correctAnswer: 3
    },
    {
      id: 70737,
      question: "What is the post-ictal phase following a Grand Mal seizure?",
      options: [
        "The period after the seizure characterized by confusion and tiredness",
        "The recovery period before the seizure when the patient seems normal",
        "The active phase of the seizure involving violent shaking movements",
        "The period before the seizure where the patient feels a warning aura"
      ],
      correctAnswer: 0
    },
    {
      id: 70738,
      question: "What is an absence seizure (Petit Mal)?",
      options: [
        "A small brief seizure with staring, eyelid blinking, and no big movements",
        "A focal seizure affecting only one limb with rhythmic jerking movements",
        "A seizure with violent body shaking, tongue biting, and loss of control",
        "A prolonged seizure lasting more than 5 minutes requiring EMS"
      ],
      correctAnswer: 0
    },
    {
      id: 70739,
      question: "How long does an absence seizure (Petit Mal) typically last?",
      options: [
        "About 5–15 minutes, requiring monitoring and oxygen administration",
        "About 1–2 minutes, with the patient returning to normal activity",
        "About 30 seconds, followed by a brief period of post-ictal confusion",
        "About 10 seconds, with the patient often not remembering the episode"
      ],
      correctAnswer: 3
    },
    {
      id: 70740,
      question: "What is the dental office protocol when a patient has a seizure?",
      options: [
        "Do not restrain patient, protect from injury, give oxygen, call EMS if >5 min",
        "Place an object in the mouth to prevent tongue biting during the seizure",
        "Administer midazolam immediately for all seizures in the dental chair",
        "Restrain the patient and call EMS immediately for all seizures"
      ],
      correctAnswer: 0
    },
    {
      id: 70741,
      question: "When should EMS be called during a patient's seizure in the dental office?",
      options: [
        "Immediately at seizure onset regardless of duration or type",
        "Only if the patient requests emergency services during the episode",
        "After administering midazolam and waiting 10 minutes for response",
        "If the seizure is prolonged (greater than 5 minutes) or repeated"
      ],
      correctAnswer: 3
    },
    {
      id: 70742,
      question: "Which of the following is listed as another medical emergency relevant to the dental office?",
      options: [
        "Angina Pectoris (stable and unstable) or acute myocardial infarction",
        "Renal failure requiring dialysis and careful fluid management",
        "Pneumonia and pulmonary fibrosis requiring oxygen supplementation",
        "Deep vein thrombosis requiring anticoagulation therapy administration"
      ],
      correctAnswer: 0
    },
    {
      id: 70743,
      question: "What is the intent requirement for malpractice in dental care?",
      options: [
        "The clinician intended to cause harm or knew the patient might be harmed",
        "The patient must prove the clinician was angry or upset during treatment",
        "The clinician must have intentionally falsified the patient's records",
        "The clinician must have intended to perform the wrong procedure"
      ],
      correctAnswer: 0
    },
    {
      id: 70744,
      question: "How do community standards help limit liability for emergencies in dental offices?",
      options: [
        "By having AEDs available and CPR-trained employees in the office",
        "By requiring all staff to carry personal malpractice insurance policies",
        "By requiring all dental staff to speak the patient's native language",
        "By ensuring all patients sign extensive liability waivers before treatment"
      ],
      correctAnswer: 0
    },
    {
      id: 70745,
      question: "What does limiting liability through \"professional relationships\" involve?",
      options: [
        "Developing relationships with specialists for timely consultations",
        "Joining a professional union to provide collective legal protection",
        "Hiring a legal representative to attend all patient appointments",
        "Maintaining friendly relationships with patients to avoid complaints"
      ],
      correctAnswer: 0
    },
    {
      id: 70746,
      question: "What is an example of protecting client privacy as part of avoiding a breach of duty?",
      options: [
        "Asking patients to sign a confidentiality agreement before treatment",
        "Confirming patient identity by asking them to state their full name",
        "Updating patient records immediately after every appointment",
        "Not leaving a client's chart in visible areas or taking contact info home"
      ],
      correctAnswer: 3
    },
    {
      id: 70747,
      question: "Which of the following is classified as a \"random event\" that can cause a medical emergency?",
      options: [
        "Failure to address the medical history before beginning treatment",
        "Commission of a procedure that was not requested by the patient",
        "Administering the wrong drug due to poor labeling in the office",
        "An unavoidable emergency like syncope occurring despite all precautions"
      ],
      correctAnswer: 3
    },
    {
      id: 70748,
      question: "A clinician can be found guilty of malpractice even if the patient suffers no harm from the breach of standard of care.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70749,
      question: "The Good Samaritan Rule provides full protection to dental professionals inside their own office during a patient emergency.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70750,
      question: "Type 4 delayed hypersensitivity reactions, such as contact dermatitis, can take hours or days to develop after allergen exposure.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70751,
      question: "During a seizure in a dental office, a clinician should restrain the patient to prevent them from injuring themselves.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70752,
      question: "Epinephrine is contraindicated in patients with hyperthyroidism during a dental emergency.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70753,
      question: "Syncope is managed by laying the patient flat with legs elevated, administering oxygen, and monitoring the patient.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
  ], 
  "2-3. Medical Emergencies": [
    {
      id: 70754,
      question: "Which of the following is a primary reason why medical emergencies in the dental office are more likely today?",
      options: [
        "Patients are less willing to disclose their medical histories to clinicians",
        "More people are living longer with controlled chronic diseases",
        "Dental procedures have become significantly shorter in recent years",
        "Clinicians are less trained in emergency management than before"
      ],
      correctAnswer: 1
    },
    {
      id: 70755,
      question: "Which factor related to surgical procedures contributes to increased medical emergency risk in dental settings?",
      options: [
        "An increase in short, simple procedures such as polish-only appointments",
        "Reduced use of local anesthesia for routine dental hygiene procedures",
        "An increase in complex surgical procedures such as implant placements",
        "A decrease in the number of patients seeking elective dental care"
      ],
      correctAnswer: 2
    },
    {
      id: 70756,
      question: "Why does increased drug use contribute to a higher risk of medical emergencies in dental offices?",
      options: [
        "Patients are less likely to report drug allergies when medications are common",
        "Local anesthetics, sedation agents, and nitrous oxide all carry associated risks",
        "Drug use by clinicians impairs their ability to manage emergencies safely",
        "Patients who use drugs tend to have more difficult dental anatomy"
      ],
      correctAnswer: 1
    },
    {
      id: 70757,
      question: "According to the class, which of the following correctly describes how medical advances contribute to emergency risk?",
      options: [
        "Advances in medicine have completely eliminated the need for medical history",
        "Patients who previously would have died from illnesses now survive and present for dental care",
        "Medical advances have reduced the number of medications patients take daily",
        "Newer surgical techniques prevent any complications during dental treatment"
      ],
      correctAnswer: 1
    },
    {
      id: 70758,
      question: "What is the recommended time to schedule dental appointments for fearful or medically compromised patients?",
      options: [
        "Last appointment of the day so the office has extra time available",
        "Mid-afternoon, after the patient has had time to eat and relax",
        "First thing in the morning, when patients are less active and less anxious",
        "Any time is acceptable as long as sedation is available for the patient"
      ],
      correctAnswer: 2
    },
    {
      id: 70759,
      question: "Why should medically compromised patients have shorter dental appointments?",
      options: [
        "Longer appointments increase the risk of infection from prolonged exposure",
        "Insurance companies do not reimburse for appointments exceeding one hour",
        "Longer appointments increase the stress placed on the patient's body",
        "Short appointments ensure the clinician finishes on time every session"
      ],
      correctAnswer: 2
    },
    {
      id: 70760,
      question: "A highly anxious patient who refuses both local anesthetic and nitrous oxide requires what action?",
      options: [
        "Proceed with treatment using topical anesthetic only to manage discomfort",
        "Contact the patient's family doctor to discuss consent and management options",
        "Refer the patient to an oral surgeon who specializes in anxious patients",
        "Dismiss the patient from care since they cannot cooperate with treatment"
      ],
      correctAnswer: 1
    },
    {
      id: 70761,
      question: "What is the single best strategy to reduce the risk of a medical emergency in a dental setting?",
      options: [
        "Keep all appointments short and avoid scheduling complex procedures",
        "Ensure oxygen and an EpiPen are readily available at every appointment",
        "Complete and review a thorough medical history for every patient",
        "Always schedule medically complex patients in the afternoon for safety"
      ],
      correctAnswer: 2
    },
    {
      id: 70762,
      question: "If a patient reports that they bruise easily during the medical history review, what should the clinician do?",
      options: [
        "Document it and proceed with care since bruising is rarely significant",
        "Cancel the appointment immediately and refer the patient to their physician",
        "Investigate further to determine if the patient has a bleeding disorder",
        "Note it in the chart and increase suction use throughout the procedure"
      ],
      correctAnswer: 2
    },
    {
      id: 70763,
      question: "Why is it important for dental clinicians to follow up thoroughly on medical history questionnaire responses?",
      options: [
        "It helps the clinician bill the insurance company at the correct rate",
        "Incomplete follow-up can lead to missing conditions that increase emergency risk",
        "Medical histories are primarily legal documents rather than clinical tools",
        "Regulatory bodies require completed medical forms before any appointment"
      ],
      correctAnswer: 1
    },
    {
      id: 70764,
      question: "For a patient with epilepsy, what key information should be documented before proceeding with dental treatment?",
      options: [
        "The patient's most recent dental appointment and last cleaning date",
        "Whether the patient has dental anxiety and how they prefer to manage it",
        "When the last seizure occurred and whether the condition is currently controlled",
        "Whether the patient takes calcium channel blockers affecting gingival tissue"
      ],
      correctAnswer: 2
    },
    {
      id: 70765,
      question: "According to Ontario dental practice, which source should be referenced for the most current blood pressure guidelines?",
      options: [
        "The American Heart Association guidelines for hypertension management",
        "The provincial CDHO guidelines, which are more current for Ontario practice",
        "The textbook by Malamed published in 2007 for dental emergencies",
        "The Canadian Dental Association's published clinical practice standards"
      ],
      correctAnswer: 1
    },
    {
      id: 70766,
      question: "Why should blood pressure be reassessed after five minutes if the initial reading is elevated?",
      options: [
        "The cuff may have been placed incorrectly and the error must be corrected",
        "A single reading is insufficient to make any clinical decisions about the patient",
        "To confirm the reading and determine whether treatment can proceed safely",
        "Regulatory guidelines require two readings for every patient appointment"
      ],
      correctAnswer: 2
    },
    {
      id: 70767,
      question: "What should patients with hypertension be asked to avoid before a dental appointment?",
      options: [
        "Eating a large meal, wearing tight clothing, or taking prescribed medications",
        "Drinking water, using mouthwash, or arriving too early for the appointment",
        "Smoking, consuming caffeinated drinks, and exercising within 30 minutes prior",
        "Talking to anyone before the appointment to keep stress levels very low"
      ],
      correctAnswer: 2
    },
    {
      id: 70768,
      question: "For routine pediatric patients aged around 7–10 years old, which vitals are typically assessed in dental practice?",
      options: [
        "Blood pressure and temperature, but not pulse or respiratory rate",
        "Height and weight only, since other vitals are not relevant in children",
        "Full vitals including blood pressure, identical to adult assessment protocols",
        "Pulse and respiration only, since blood pressure is not typically taken"
      ],
      correctAnswer: 3
    },
    {
      id: 70769,
      question: "Why is patient height and weight recorded in a dental setting?",
      options: [
        "To assess nutritional status and make dietary recommendations for patients",
        "For BMI calculation, sedation dosing, and appropriate local anesthetic dosing",
        "To determine the correct chair height for patient comfort and accessibility",
        "For documentation purposes required by all Ontario dental regulatory bodies"
      ],
      correctAnswer: 1
    },
    {
      id: 70770,
      question: "What is the significance of BMI in dental clinical practice?",
      options: [
        "It helps estimate the patient's likelihood of developing periodontal disease",
        "It determines whether a patient qualifies for government-funded dental care",
        "It influences sedation dosing and local anesthetic maximum dosage calculations",
        "It measures patient fitness levels to guide appointment length scheduling"
      ],
      correctAnswer: 2
    },
    {
      id: 70771,
      question: "Why can local anesthetic still be administered to cardiac patients in a dental setting?",
      options: [
        "Cardiac patients are immune to adverse reactions from local anesthetic agents",
        "Local anesthetic is mandatory for all patients regardless of medical history",
        "It can be given safely when dosing is carefully adjusted to body weight",
        "The dentist's consent overrides any cardiac-related concerns during care"
      ],
      correctAnswer: 2
    },
    {
      id: 70772,
      question: "What are the three factors that should be evaluated when monitoring a patient's heart rate and rhythm?",
      options: [
        "Heart rate, skin colour, and capillary refill time at the fingertip",
        "Heart rate, blood pressure, and respiratory rate measured together",
        "Heart rate, heart rhythm, and pulse quality assessed at the radial artery",
        "Heart rate, temperature, and oxygen saturation measured simultaneously"
      ],
      correctAnswer: 2
    },
    {
      id: 70773,
      question: "Where is the pulse most commonly assessed in dental clinical practice?",
      options: [
        "Carotid artery at the side of the neck for easiest clinician access",
        "Brachial artery located in the upper arm region near the elbow",
        "Femoral artery in the groin for most accurate cardiovascular readings",
        "Radial artery at the wrist for ease of access and patient comfort"
      ],
      correctAnswer: 3
    },
    {
      id: 70774,
      question: "Why should the clinician avoid telling the patient when their respiratory rate is being measured?",
      options: [
        "Patients may object to being monitored and refuse to cooperate further",
        "Informing the patient will require written consent before measurement",
        "Patients may consciously alter their breathing pattern when they are aware",
        "Regulatory standards prohibit disclosure of assessment procedures used"
      ],
      correctAnswer: 2
    },
    {
      id: 70775,
      question: "For how long should respiratory rate ideally be monitored according to the class?",
      options: [
        "At least 10 seconds to obtain a reading, with 20 seconds as the ideal",
        "At least 15 seconds to obtain a reading, with 30 seconds as the ideal",
        "At least 30 seconds to obtain a reading, with 60 seconds as the ideal",
        "At least 45 seconds to obtain a reading, with 90 seconds as the ideal"
      ],
      correctAnswer: 2
    },
    {
      id: 70776,
      question: "What is the normal respiratory rate for a healthy adult at rest?",
      options: [
        "8 to 12 breaths per minute for a healthy resting adult patient",
        "16 to 18 breaths per minute for a healthy resting adult patient",
        "20 to 24 breaths per minute for a healthy resting adult patient",
        "24 to 30 breaths per minute for a healthy resting adult patient"
      ],
      correctAnswer: 1
    },
    {
      id: 70777,
      question: "What is the average normal body temperature, and at what reading does it indicate a pathologic process?",
      options: [
        "Average is 36.5°C; above 38.0°C indicates a pathologic process",
        "Average is 36.0°C; above 37.5°C indicates a pathologic process",
        "Average is 35.7°C; above 38.8°C indicates a pathologic process",
        "Average is 37.0°C; above 39.5°C indicates a pathologic process"
      ],
      correctAnswer: 2
    },
    {
      id: 70778,
      question: "Which of the following is a visible sign of anxiety that can be detected during visual inspection of a patient?",
      options: [
        "Elevated blood pressure, dilated pupils, and excessive sweating",
        "Pale skin, low blood pressure, and very slow speech patterns",
        "Decreased heart rate, constricted pupils, and slow blinking",
        "Increased appetite, rapid blinking, and increased salivation"
      ],
      correctAnswer: 0
    },
    {
      id: 70779,
      question: "What is the recommended approach when a clinician notices a patient is visibly anxious?",
      options: [
        "Ask the patient directly whether they are nervous to address their anxiety",
        "Use distraction techniques such as conversation or entertainment options",
        "Immediately offer benzodiazepine medication before starting any procedure",
        "Reschedule the appointment for a time when the patient feels more prepared"
      ],
      correctAnswer: 1
    },
    {
      id: 70780,
      question: "Why does excessive waiting time in the dental office increase patient anxiety?",
      options: [
        "Patients become bored and start researching the procedure on their phones",
        "Prolonged waiting causes physical discomfort from sitting in the dental chair",
        "Waiting gives patients more time to anticipate and ruminate about the procedure",
        "Delayed appointments violate CDHO scheduling regulations for anxiety patients"
      ],
      correctAnswer: 2
    },
    {
      id: 70781,
      question: "Which of the following best describes how a moderately anxious patient may appear during dental care?",
      options: [
        "Relaxed posture, slow speech, and comfortable eye contact with the clinician",
        "Giving quick answers, fidgeting with hands or tissues, and stiff posture",
        "Appearing sleepy, slow to respond, and showing very constricted pupils",
        "Requesting additional details about procedures and asking for a second opinion"
      ],
      correctAnswer: 1
    },
    {
      id: 70782,
      question: "What is the purpose of including anxiety screening questions in the medical history form?",
      options: [
        "To determine the patient's preferred language for appointment communications",
        "To identify anxiety levels so that treatment can be modified to prevent emergencies",
        "To comply with provincial insurance requirements for anxiety-related treatments",
        "To decide whether the patient should be referred to a psychologist first"
      ],
      correctAnswer: 1
    },
    {
      id: 70783,
      question: "Why is compassion important when managing a patient with significant dental anxiety?",
      options: [
        "Compassionate clinicians are less likely to be sued for malpractice later",
        "Anxious patients are often battling real fears or past traumatic dental experiences",
        "Dental regulations in Ontario require all clinicians to demonstrate empathy",
        "Compassion improves the speed at which procedures can be completed safely"
      ],
      correctAnswer: 1
    },
    {
      id: 70784,
      question: "According to ASA classification, which category describes a patient with a well-controlled systemic condition?",
      options: [
        "ASA I: a completely healthy patient with no systemic disease present",
        "ASA II: a patient with a mild systemic disease that is well controlled",
        "ASA III: a patient with a severe systemic disease that limits daily activity",
        "ASA IV: a patient with a life-threatening disease that is not controlled"
      ],
      correctAnswer: 1
    },
    {
      id: 70785,
      question: "What type of dental treatment is permitted for an ASA IV patient in a dental office?",
      options: [
        "All treatment types including invasive surgery with physician consultation",
        "Only emergency extractions needed to prevent immediate systemic infection",
        "Invasive procedures only if performed under full general anesthesia",
        "Non-invasive treatment only, with invasive treatment requiring physician guidelines"
      ],
      correctAnswer: 3
    },
    {
      id: 70786,
      question: "For which ASA categories is it especially important to record pre- and post-operative vital signs?",
      options: [
        "ASA I and II, since these patients are the most common in private practice",
        "ASA II and IV, since both categories have significant systemic conditions",
        "ASA III and IV, since these patients carry greater medical risk during care",
        "ASA I and III, since alternating high and low risk requires closer monitoring"
      ],
      correctAnswer: 2
    },
    {
      id: 70787,
      question: "What does 'white coat syndrome' refer to in the context of vital signs assessment?",
      options: [
        "A condition where patients develop infections from improperly sterilised equipment",
        "Elevated blood pressure readings caused by anxiety about being in a clinical setting",
        "A professional requirement for all clinicians to wear clean uniforms daily",
        "A disorder in which patients refuse to have their blood pressure taken"
      ],
      correctAnswer: 1
    },
    {
      id: 70788,
      question: "Which of the following is included in the stress reduction protocol for a healthy, minimally anxious patient?",
      options: [
        "Mandatory prescription of anti-anxiety medication before every appointment",
        "Scheduling appointments in the afternoon to allow the patient to rest first",
        "Recognising the patient's anxiety level and premedicating the night before if needed",
        "Requiring a medical clearance letter before any dental treatment is initiated"
      ],
      correctAnswer: 2
    },
    {
      id: 70789,
      question: "What post-treatment action is recommended for highly anxious or fearful patients?",
      options: [
        "Mail a formal written summary of all procedures performed during the visit",
        "Call the patient later that same day or the following day to follow up",
        "Ask the patient to complete an anxiety survey before leaving the office",
        "Refer the patient to a counsellor or therapist for ongoing anxiety management"
      ],
      correctAnswer: 1
    },
    {
      id: 70790,
      question: "How should highly anxious, moderate-to-high-risk patients be scheduled to reduce emergency risk?",
      options: [
        "Schedule at the last appointment of the week to avoid affecting other patients",
        "Schedule randomly throughout the week to maintain equal appointment distribution",
        "Schedule early in the week and early in the day when the team is most alert",
        "Schedule only on Fridays so the weekend provides extra recovery time"
      ],
      correctAnswer: 2
    },
    {
      id: 70791,
      question: "What is the role of pain control in the dental stress reduction protocol?",
      options: [
        "Pain control is secondary to time management during busy clinical sessions",
        "Adequate pain control during therapy is essential to minimise physiological stress",
        "Pain control only matters if the patient is classified as ASA III or higher",
        "Pain control is delegated entirely to the dentist and not the hygienist's concern"
      ],
      correctAnswer: 1
    },
    {
      id: 70792,
      question: "Which class of antidepressants is most commonly encountered in dental patients?",
      options: [
        "Selective Serotonin Reuptake Inhibitors (SSRIs), which affect serotonin only",
        "Monoamine Oxidase Inhibitors (MAOIs), which block neurotransmitter breakdown",
        "Tricyclic antidepressants (TCAs), which affect multiple neurotransmitter systems",
        "Serotonin-Norepinephrine Reuptake Inhibitors (SNRIs) affecting two neurotransmitters"
      ],
      correctAnswer: 0
    },
    {
      id: 70793,
      question: "Why do SNRIs require extra caution compared to SSRIs in dental patients?",
      options: [
        "SNRIs affect both serotonin and norepinephrine, increasing interaction risks",
        "SNRIs are associated with a higher risk of xerostomia than other antidepressants",
        "SNRIs have a much shorter half-life, meaning they wear off during appointments",
        "SNRIs interact more severely with topical anesthetics applied to the gingiva"
      ],
      correctAnswer: 0
    },
    {
      id: 70794,
      question: "What interaction risk must clinicians be mindful of when a dental patient takes SSRIs?",
      options: [
        "SSRIs can reduce the effectiveness of rubber dam material in isolation",
        "SSRIs may interact with local anesthetic or oral sedation agents used in treatment",
        "SSRIs increase the risk of latex allergy reactions during dental procedures",
        "SSRIs reduce the absorption of fluoride, making topical treatment ineffective"
      ],
      correctAnswer: 1
    },
    {
      id: 70795,
      question: "What makes Zoloft (sertraline) relatively easier to manage in dental patients compared to SNRIs?",
      options: [
        "Zoloft affects serotonin only, making it simpler to assess interaction risks",
        "Zoloft does not cause dry mouth, which is beneficial for oral health management",
        "Zoloft is available as a liquid form that does not interact with dental materials",
        "Zoloft has a shorter duration of action, reducing the window for drug interactions"
      ],
      correctAnswer: 0
    },
    {
      id: 70796,
      question: "In Ontario, which drug is the only one a dental hygienist is authorised to administer independently?",
      options: [
        "Nitroglycerin, if the patient is conscious and experiencing chest pain",
        "Albuterol inhaler, if the patient is experiencing an asthmatic episode",
        "Aromatic ammonia, if the patient is showing signs of syncope or fainting",
        "Epinephrine via EpiPen in a life-threatening emergency situation"
      ],
      correctAnswer: 3
    },
    {
      id: 70797,
      question: "In Ontario, why are dental hygienists not permitted to independently administer oxygen?",
      options: [
        "Oxygen administration is too dangerous to be performed by non-physicians",
        "It falls outside the regulated scope of dental hygiene practice in Ontario",
        "Oxygen equipment is too complex for dental hygienists to operate safely",
        "Ontario clinics are not required to have oxygen available for emergencies"
      ],
      correctAnswer: 1
    },
    {
      id: 70798,
      question: "For a conscious patient with angina who needs nitroglycerin, who administers it in the dental office?",
      options: [
        "The patient self-administers it, or the dentist administers it from the kit",
        "The emergency responder administers it after being called to the office",
        "The dental hygienist places the tablet under the patient's tongue for them",
        "The dental assistant draws it into a syringe and injects it intramuscularly"
      ],
      correctAnswer: 0
    },
    {
      id: 70799,
      question: "Under what condition may a dental hygienist suggest an over-the-counter medication to a patient?",
      options: [
        "Only if the dentist is absent and no other medication option is available",
        "Only if the patient specifically asks and the hygienist has read the label",
        "The hygienist may never suggest medications; this is outside their scope",
        "When they know the risks, there are no contraindications, and they document it"
      ],
      correctAnswer: 3
    },
    {
      id: 70800,
      question: "Which of the following correctly lists contents that should be in a dental office emergency kit?",
      options: [
        "EpiPen, albuterol inhaler, nitroglycerin, oxygen, and glucose sources",
        "Morphine, midazolam, atropine, dextrose, and an AED device",
        "Diphenhydramine, beta-blockers, aspirin, and a blood pressure machine",
        "Antibiotics, corticosteroids, blood glucose monitor, and a tourniquet"
      ],
      correctAnswer: 0
    },
    {
      id: 70801,
      question: "What is the approximate shelf life of nitroglycerin once the bottle has been opened?",
      options: [
        "About 12 weeks, or approximately three months after opening the bottle",
        "About 24 months, or approximately two years after opening the bottle",
        "About 4 weeks, or approximately one month after opening the bottle",
        "About 6 months, or approximately half a year after opening the bottle"
      ],
      correctAnswer: 0
    },
    {
      id: 70802,
      question: "Nitroglycerin is contraindicated in which of the following patient scenarios?",
      options: [
        "A patient who took a sexual enhancement drug within the past 24 hours",
        "A patient with type 2 diabetes whose blood sugar is well controlled",
        "A patient with stable angina who has used nitroglycerin in the past",
        "A patient with a history of asthma who uses a salbutamol inhaler"
      ],
      correctAnswer: 0
    },
    {
      id: 70803,
      question: "If a dental office does not have a junior EpiPen (0.15 mg) for a child in an emergency, what should be done?",
      options: [
        "Administer the adult dose (0.3 mg) since saving the life is the priority",
        "Give half of an adult EpiPen by discharging part of the device only",
        "Administer Benadryl as an alternative since it is safer for children",
        "Wait for EMS to arrive since giving the wrong dose is too dangerous"
      ],
      correctAnswer: 0
    },
    {
      id: 70804,
      question: "Why is Benadryl (diphenhydramine) not considered a mandatory item in all dental office emergency kits?",
      options: [
        "It is rarely needed, not universally stocked, and not officially mandatory",
        "Benadryl requires a prescription in Ontario and cannot be kept OTC in clinics",
        "It is only effective when combined with epinephrine and cannot be used alone",
        "Benadryl causes such severe drowsiness that it is dangerous in dental settings"
      ],
      correctAnswer: 0
    },
    {
      id: 70805,
      question: "What is the correct management approach when aromatic ammonia is used for syncope?",
      options: [
        "Break it under the patient's nose to stimulate via inhalation of vapour",
        "Place it under the patient's tongue so it absorbs sublingually quickly",
        "Inject it intramuscularly into the thigh for the fastest onset of action",
        "Mix it with oxygen and administer it through a face mask to the patient"
      ],
      correctAnswer: 0
    },
    {
      id: 70806,
      question: "For which of the following conditions is oxygen administration indicated in a dental office?",
      options: [
        "Hypoxia or cardiovascular conditions where the body lacks sufficient oxygen",
        "Any patient who requests oxygen to help them feel calm during treatment",
        "Orthostatic hypotension where repositioning the chair is insufficient alone",
        "Hyperventilation caused by anxiety, since the patient needs more oxygen"
      ],
      correctAnswer: 0
    },
    {
      id: 70807,
      question: "What is the maximum flow rate of oxygen typically referenced in this class for dental emergencies?",
      options: [
        "3 litres per minute as the maximum oxygen flow in dental emergencies",
        "10 litres per minute as the maximum oxygen flow in dental emergencies",
        "1 litre per minute as the maximum oxygen flow in dental emergencies",
        "5 litres per minute as the maximum oxygen flow in dental emergencies"
      ],
      correctAnswer: 0
    },
    {
      id: 70808,
      question: "What does the clinical phrase 'if it's not documented, it didn't happen' mean in dental practice?",
      options: [
        "Undocumented actions cannot be legally defended or professionally verified",
        "Documentation is optional but recommended for all patient interactions",
        "Only major procedures need to be documented in the progress notes",
        "All appointments must be filmed to verify that procedures were performed"
      ],
      correctAnswer: 0
    },
    {
      id: 70809,
      question: "When should a clinician document all observations and actions taken during a patient emergency?",
      options: [
        "As soon as possible after the event, including EMS handover time and details",
        "Documentation is not required for emergencies since EMS will handle reporting",
        "Only after the patient has left the clinic and is confirmed to be safe",
        "Before initiating any treatment so the timeline is accurately captured"
      ],
      correctAnswer: 0
    },
    {
      id: 70810,
      question: "According to the class, what is the correct priority order during a dental medical emergency?",
      options: [
        "BLS comes first; drug administration is secondary to life-saving resuscitation",
        "Visual assessment first, then documentation, then BLS as a last resort",
        "Drug administration first, then BLS if drugs are ineffective for the patient",
        "Call EMS first, then begin BLS while waiting for emergency services to arrive"
      ],
      correctAnswer: 0
    },
    {
      id: 70811,
      question: "Even in a case of anaphylaxis, what is the correct sequence of management?",
      options: [
        "Perform BLS first, then administer the EpiPen as the secondary measure",
        "Call EMS first, administer EpiPen, then begin BLS only if EMS is delayed",
        "Administer Benadryl first, then BLS, then EpiPen only if no improvement",
        "Administer EpiPen first to address the allergy before starting BLS"
      ],
      correctAnswer: 0
    },
    {
      id: 70812,
      question: "What is the primary responsibility of Team Member 1 during a dental office medical emergency?",
      options: [
        "Stay with the patient, initiate BLS, and yell for help to alert the team",
        "Meet EMS at the entrance of the building to guide them to the correct unit",
        "Retrieve the emergency kit and bring the AED to the site of emergency",
        "Call 911 and stay on the line to relay all necessary information to dispatch"
      ],
      correctAnswer: 0
    },
    {
      id: 70813,
      question: "What is the primary responsibility of Team Member 2 during a dental office medical emergency?",
      options: [
        "Call 911 and provide the operator with all relevant patient information",
        "Document all actions taken from the moment the emergency is identified",
        "Remain with the patient and initiate CPR until the dentist arrives on site",
        "Bring oxygen, the emergency kit, and the AED to the location of the patient"
      ],
      correctAnswer: 3
    },
    {
      id: 70814,
      question: "Why does the dentist typically lead the emergency team during a medical emergency in the dental office?",
      options: [
        "The dentist is the only team member trained in Basic Life Support (BLS)",
        "Dentists have more years of general education compared to other dental staff",
        "Dental regulations require that the most senior person always leads the team",
        "The dentist holds authority to administer emergency drugs from the kit"
      ],
      correctAnswer: 3
    },
    {
      id: 70815,
      question: "How often must dental hygienists complete CPR and BLS refresher training according to CDHO requirements?",
      options: [
        "Every three years, as long as the clinician works in a regulated facility",
        "Only once upon graduation, as the skills are considered lifelong training",
        "Every two years, aligned with the RDH licence renewal cycle in Ontario",
        "Every year, regardless of when the license renewal is scheduled to occur"
      ],
      correctAnswer: 3
    },
    {
      id: 70816,
      question: "What information should be provided to EMS when calling 911 during a dental emergency?",
      options: [
        "The dentist's license number and the names of all staff present at the time",
        "The patient's insurance information, billing code, and dental record number",
        "The clinic's business hours, parking instructions, and postal code only",
        "Location, phone number, what happened, patient condition, aid given, and medical history"
      ],
      correctAnswer: 3
    },
    {
      id: 70817,
      question: "Which of the following correctly lists aspirin's four pharmacological properties (the '4 A's')?",
      options: [
        "Analgesic, Antiemetic, Antiviral, and Anti-inflammatory properties",
        "Antihypertensive, Analgesic, Anti-inflammatory, and Antifungal properties",
        "Antibiotic, Antifungal, Anti-inflammatory, and Antispasmodic properties",
        "Analgesic, Antipyretic, Anti-inflammatory, and Antiplatelet properties"
      ],
      correctAnswer: 3
    },
    {
      id: 70818,
      question: "Ibuprofen is described as having '3 A's'. Which property does it lack compared to aspirin?",
      options: [
        "Analgesic (pain relief) effect that is present in aspirin but not ibuprofen",
        "Anti-inflammatory effect that is present in aspirin but not ibuprofen",
        "Antipyretic (fever-reducing) effect that is present in aspirin but not ibuprofen",
        "Antiplatelet effect that is present in aspirin but not in ibuprofen"
      ],
      correctAnswer: 3
    },
    {
      id: 70819,
      question: "When would an RDH suggest ibuprofen (Advil) post-operatively rather than Tylenol?",
      options: [
        "When the patient only has mild pain without any notable gingival inflammation",
        "When the patient is taking SSRIs and requires a non-serotonin-based pain option",
        "When the patient reports a history of stomach ulcers from anti-inflammatory use",
        "When the patient has significant periodontal inflammation and pain after treatment"
      ],
      correctAnswer: 3
    },
    {
      id: 70820,
      question: "What is ketoacidosis, and in which diabetic condition is it most commonly seen?",
      options: [
        "A condition of very low blood sugar requiring immediate glucose administration",
        "An inflammatory response in the kidneys caused by uncontrolled blood sugar",
        "Excess sugar in the blood due to too much insulin; most common in Type 2 diabetes",
        "A condition of excess acids/ketones in the body, most common in Type 1 diabetes"
      ],
      correctAnswer: 3
    },
    {
      id: 70821,
      question: "What does the term 'diaphoresis' describe in the context of a patient assessment?",
      options: [
        "A sensation of the heart pounding or beating rapidly perceived by the patient",
        "Difficulty swallowing, often associated with a pharyngeal or esophageal issue",
        "Abnormal electrical activity of the heart causing an irregular heart rhythm",
        "Excessive perspiration or sweating, often associated with a medical emergency"
      ],
      correctAnswer: 3
    },
    {
      id: 70822,
      question: "What does 'dysphagia' refer to when assessing a dental patient's symptoms?",
      options: [
        "Excessive sweating in response to pain, fever, or emotional distress",
        "Abnormal heart rhythm that causes irregular pumping of blood through vessels",
        "Difficulty breathing associated with obstructed or restricted airway passages",
        "Difficulty swallowing, which may indicate a systemic or structural condition"
      ],
      correctAnswer: 3
    },
    {
      id: 70823,
      question: "What is the correct definition of 'hemolysis' as it relates to blood physiology?",
      options: [
        "The migration of white blood cells to the site of an active infection",
        "The formation of clots inside blood vessels, reducing blood flow to organs",
        "The excessive production of red blood cells in response to chronic hypoxia",
        "The rupturing or destruction of red blood cells within the bloodstream"
      ],
      correctAnswer: 3
    },
    {
      id: 70824,
      question: "What does 'orthostatic hypotension' describe in a dental patient context?",
      options: [
        "Abnormally low blood pressure that is consistently present at all body positions",
        "A rapid increase in heart rate triggered by sitting in the dental chair",
        "Elevated blood pressure caused by anxiety during dental treatment procedures",
        "A sudden drop in blood pressure when the patient changes body position rapidly"
      ],
      correctAnswer: 3
    },
    {
      id: 70825,
      question: "In Ontario, oxygen administration falls within the regulated scope of practice for dental hygienists.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70826,
      question: "The best time to schedule appointments for fearful or medically compromised patients is first thing in the morning.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70827,
      question: "Blood pressure should be taken on all pediatric patients, including those as young as 7 years old, as part of a routine dental assessment.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70828,
      question: "Respiratory rate should be measured immediately after taking the pulse, without informing the patient.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70829,
      question: "Oxygen is indicated for treating hyperventilation in anxious dental patients.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70830,
      question: "BLS must be performed before drug administration, even in a case of anaphylaxis.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 70831,
      question: "SSRIs and SNRIs carry the same level of interaction risk with local anesthetics and oral sedation agents.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 70832,
      question: "The dental hygienist in Ontario may administer the EpiPen independently in a life-threatening emergency.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
  ]  
};
